/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './app/routes/__root'
import { Route as appRouteImport } from './app/routes/(app)/route'
import { Route as IndexImport } from './app/routes/index'
import { Route as authLoginImport } from './app/routes/(auth)/login'
import { Route as appForbiddenImport } from './app/routes/(app)/forbidden'
import { Route as appUsersRouteImport } from './app/routes/(app)/users/route'
import { Route as appStoreInformationRouteImport } from './app/routes/(app)/store-information/route'
import { Route as appRecommendationManagementRouteImport } from './app/routes/(app)/recommendation-management/route'
import { Route as appPromosOfferRouteImport } from './app/routes/(app)/promos-offer/route'
import { Route as appPointsManagementRouteImport } from './app/routes/(app)/points-management/route'
import { Route as appPaymentManagementRouteImport } from './app/routes/(app)/payment-management/route'
import { Route as appLogsManagementRouteImport } from './app/routes/(app)/logs-management/route'
import { Route as appFaqRouteImport } from './app/routes/(app)/faq/route'
import { Route as appDashboardRouteImport } from './app/routes/(app)/dashboard/route'
import { Route as appConfigurationManagementRouteImport } from './app/routes/(app)/configuration-management/route'
import { Route as appAccountRouteImport } from './app/routes/(app)/account/route'
import { Route as appUsersIndexImport } from './app/routes/(app)/users/index'
import { Route as appStoreInformationIndexImport } from './app/routes/(app)/store-information/index'
import { Route as appRecommendationManagementIndexImport } from './app/routes/(app)/recommendation-management/index'
import { Route as appPromosOfferIndexImport } from './app/routes/(app)/promos-offer/index'
import { Route as appPointsManagementIndexImport } from './app/routes/(app)/points-management/index'
import { Route as appPaymentManagementIndexImport } from './app/routes/(app)/payment-management/index'
import { Route as appLogsManagementIndexImport } from './app/routes/(app)/logs-management/index'
import { Route as appFaqIndexImport } from './app/routes/(app)/faq/index'
import { Route as appDashboardIndexImport } from './app/routes/(app)/dashboard/index'
import { Route as appConfigurationManagementIndexImport } from './app/routes/(app)/configuration-management/index'
import { Route as appAccountIndexImport } from './app/routes/(app)/account/index'
import { Route as appPromosOfferOfferImport } from './app/routes/(app)/promos-offer/offer'
import { Route as appDashboardSalesPerformanceImport } from './app/routes/(app)/dashboard/sales-performance'
import { Route as appDashboardOverviewImport } from './app/routes/(app)/dashboard/overview'
import { Route as appAccountLanguageImport } from './app/routes/(app)/account/language'
import { Route as appUsersStoreOwnersRouteImport } from './app/routes/(app)/users/store-owners/route'
import { Route as appUsersRolesRouteImport } from './app/routes/(app)/users/roles/route'
import { Route as appUsersCustomersRouteImport } from './app/routes/(app)/users/customers/route'
import { Route as appUsersAffiliatesRouteImport } from './app/routes/(app)/users/affiliates/route'
import { Route as appUsersAdminRouteImport } from './app/routes/(app)/users/admin/route'
import { Route as appStoreInformationSwitchStoreRouteImport } from './app/routes/(app)/store-information/switch-store/route'
import { Route as appStoreInformationPremiumStoresRouteImport } from './app/routes/(app)/store-information/premium-stores/route'
import { Route as appStoreInformationBasicStoresRouteImport } from './app/routes/(app)/store-information/basic-stores/route'
import { Route as appRecommendationManagementMainPageRouteImport } from './app/routes/(app)/recommendation-management/main-page/route'
import { Route as appRecommendationManagementEditorsPickRouteImport } from './app/routes/(app)/recommendation-management/editors-pick/route'
import { Route as appPromosOfferPromotionalBannerRouteImport } from './app/routes/(app)/promos-offer/promotional-banner/route'
import { Route as appPromosOfferAdvertisementRouteImport } from './app/routes/(app)/promos-offer/advertisement/route'
import { Route as appPointsManagementSystemTransferRouteImport } from './app/routes/(app)/points-management/system-transfer/route'
import { Route as appPointsManagementPointsTransferRouteImport } from './app/routes/(app)/points-management/points-transfer/route'
import { Route as appPointsManagementPointsConfigurationRouteImport } from './app/routes/(app)/points-management/points-configuration/route'
import { Route as appPointsManagementPointsBalanceStatementRouteImport } from './app/routes/(app)/points-management/points-balance-statement/route'
import { Route as appPaymentManagementStorePaymentLogRouteImport } from './app/routes/(app)/payment-management/store-payment-log/route'
import { Route as appPaymentManagementOverviewRouteImport } from './app/routes/(app)/payment-management/overview/route'
import { Route as appPaymentManagementCustomerPaymentLogsRouteImport } from './app/routes/(app)/payment-management/customer-payment-logs/route'
import { Route as appPaymentManagementAffiliateLogRouteImport } from './app/routes/(app)/payment-management/affiliate-log/route'
import { Route as appPaymentManagementAccountInformationRouteImport } from './app/routes/(app)/payment-management/account-information/route'
import { Route as appLogsManagementStaticDataTypeRouteImport } from './app/routes/(app)/logs-management/static-data-type/route'
import { Route as appLogsManagementSmsLogsRouteImport } from './app/routes/(app)/logs-management/sms-logs/route'
import { Route as appLogsManagementEmailLogsRouteImport } from './app/routes/(app)/logs-management/email-logs/route'
import { Route as appFaqReviewRatingsRouteImport } from './app/routes/(app)/faq/review-ratings/route'
import { Route as appFaqInquiryRouteImport } from './app/routes/(app)/faq/inquiry/route'
import { Route as appFaqComplaintsRouteImport } from './app/routes/(app)/faq/complaints/route'
import { Route as appDashboardReservationLedgerRouteImport } from './app/routes/(app)/dashboard/reservation-ledger/route'
import { Route as appDashboardReferralReportsRouteImport } from './app/routes/(app)/dashboard/referral-reports/route'
import { Route as appDashboardConversionAnalyticsRouteImport } from './app/routes/(app)/dashboard/conversion-analytics/route'
import { Route as appConfigurationManagementWithdrawalsSetupRouteImport } from './app/routes/(app)/configuration-management/withdrawals-setup/route'
import { Route as appConfigurationManagementLocationRouteImport } from './app/routes/(app)/configuration-management/location/route'
import { Route as appConfigurationManagementHoslogPlansRouteImport } from './app/routes/(app)/configuration-management/hoslog-plans/route'
import { Route as appConfigurationManagementGroupManagementRouteImport } from './app/routes/(app)/configuration-management/group-management/route'
import { Route as appConfigurationManagementDiscountManagementRouteImport } from './app/routes/(app)/configuration-management/discount-management/route'
import { Route as appConfigurationManagementCommissionsRouteImport } from './app/routes/(app)/configuration-management/commissions/route'
import { Route as appConfigurationManagementChargesRouteImport } from './app/routes/(app)/configuration-management/charges/route'
import { Route as appAccountProfileRouteImport } from './app/routes/(app)/account/profile/route'
import { Route as appUsersStoreOwnersIndexImport } from './app/routes/(app)/users/store-owners/index'
import { Route as appUsersRolesIndexImport } from './app/routes/(app)/users/roles/index'
import { Route as appUsersCustomersIndexImport } from './app/routes/(app)/users/customers/index'
import { Route as appUsersAffiliatesIndexImport } from './app/routes/(app)/users/affiliates/index'
import { Route as appUsersAdminIndexImport } from './app/routes/(app)/users/admin/index'
import { Route as appStoreInformationPremiumStoresIndexImport } from './app/routes/(app)/store-information/premium-stores/index'
import { Route as appStoreInformationBasicStoresIndexImport } from './app/routes/(app)/store-information/basic-stores/index'
import { Route as appRecommendationManagementMainPageIndexImport } from './app/routes/(app)/recommendation-management/main-page/index'
import { Route as appRecommendationManagementEditorsPickIndexImport } from './app/routes/(app)/recommendation-management/editors-pick/index'
import { Route as appPromosOfferPromotionalBannerIndexImport } from './app/routes/(app)/promos-offer/promotional-banner/index'
import { Route as appPromosOfferAdvertisementIndexImport } from './app/routes/(app)/promos-offer/advertisement/index'
import { Route as appPointsManagementSystemTransferIndexImport } from './app/routes/(app)/points-management/system-transfer/index'
import { Route as appPointsManagementPointsTransferIndexImport } from './app/routes/(app)/points-management/points-transfer/index'
import { Route as appPointsManagementPointsRequestIndexImport } from './app/routes/(app)/points-management/points-request/index'
import { Route as appPointsManagementPointsConfigurationIndexImport } from './app/routes/(app)/points-management/points-configuration/index'
import { Route as appPointsManagementPointsBalanceStatementIndexImport } from './app/routes/(app)/points-management/points-balance-statement/index'
import { Route as appPaymentManagementStorePaymentLogIndexImport } from './app/routes/(app)/payment-management/store-payment-log/index'
import { Route as appPaymentManagementOverviewIndexImport } from './app/routes/(app)/payment-management/overview/index'
import { Route as appPaymentManagementCustomerPaymentLogsIndexImport } from './app/routes/(app)/payment-management/customer-payment-logs/index'
import { Route as appPaymentManagementAffiliateLogIndexImport } from './app/routes/(app)/payment-management/affiliate-log/index'
import { Route as appPaymentManagementAdminPaymentSetupIndexImport } from './app/routes/(app)/payment-management/admin-payment-setup/index'
import { Route as appPaymentManagementAccountInformationIndexImport } from './app/routes/(app)/payment-management/account-information/index'
import { Route as appLogsManagementStaticDataTypeIndexImport } from './app/routes/(app)/logs-management/static-data-type/index'
import { Route as appLogsManagementSmsLogsIndexImport } from './app/routes/(app)/logs-management/sms-logs/index'
import { Route as appLogsManagementEmailLogsIndexImport } from './app/routes/(app)/logs-management/email-logs/index'
import { Route as appLogsManagementApiLogsIndexImport } from './app/routes/(app)/logs-management/api-logs/index'
import { Route as appLogsManagementAccessLogsIndexImport } from './app/routes/(app)/logs-management/access-logs/index'
import { Route as appFaqReviewRatingsIndexImport } from './app/routes/(app)/faq/review-ratings/index'
import { Route as appFaqInquiryIndexImport } from './app/routes/(app)/faq/inquiry/index'
import { Route as appFaqComplaintsIndexImport } from './app/routes/(app)/faq/complaints/index'
import { Route as appDashboardReservationLedgerIndexImport } from './app/routes/(app)/dashboard/reservation-ledger/index'
import { Route as appDashboardReferralReportsIndexImport } from './app/routes/(app)/dashboard/referral-reports/index'
import { Route as appDashboardConversionAnalyticsIndexImport } from './app/routes/(app)/dashboard/conversion-analytics/index'
import { Route as appConfigurationManagementWithdrawalsSetupIndexImport } from './app/routes/(app)/configuration-management/withdrawals-setup/index'
import { Route as appConfigurationManagementLocationIndexImport } from './app/routes/(app)/configuration-management/location/index'
import { Route as appConfigurationManagementHoslogPlansIndexImport } from './app/routes/(app)/configuration-management/hoslog-plans/index'
import { Route as appConfigurationManagementGroupManagementIndexImport } from './app/routes/(app)/configuration-management/group-management/index'
import { Route as appConfigurationManagementDiscountManagementIndexImport } from './app/routes/(app)/configuration-management/discount-management/index'
import { Route as appConfigurationManagementCommissionsIndexImport } from './app/routes/(app)/configuration-management/commissions/index'
import { Route as appConfigurationManagementChargesIndexImport } from './app/routes/(app)/configuration-management/charges/index'
import { Route as appAccountProfileIndexImport } from './app/routes/(app)/account/profile/index'
import { Route as appUsersCustomersCustomerIdImport } from './app/routes/(app)/users/customers/$customerId'
import { Route as appUsersAffiliatesAffiliateIdImport } from './app/routes/(app)/users/affiliates/$affiliateId'
import { Route as appPaymentManagementAffiliateLogMonthlyReportImport } from './app/routes/(app)/payment-management/affiliate-log/$monthly-report'
import { Route as appPaymentManagementAdminPaymentSetupAddBankInformationImport } from './app/routes/(app)/payment-management/admin-payment-setup/add-bank-information'
import { Route as appStoreInformationPremiumStoresPlanManagementRouteImport } from './app/routes/(app)/store-information/premium-stores/plan-management/route'
import { Route as appStoreInformationPremiumStoresAddPremiumStoreRouteImport } from './app/routes/(app)/store-information/premium-stores/add-premium-store/route'
import { Route as appStoreInformationPremiumStoresManagePremiumStoreRouteImport } from './app/routes/(app)/store-information/premium-stores/$manage-premium-store/route'
import { Route as appStoreInformationBasicStoresSwitchStoreRouteImport } from './app/routes/(app)/store-information/basic-stores/switch-store/route'
import { Route as appStoreInformationBasicStoresAddStoreRouteImport } from './app/routes/(app)/store-information/basic-stores/add-store/route'
import { Route as appStoreInformationBasicStoresManageStoreRouteImport } from './app/routes/(app)/store-information/basic-stores/$manage-store/route'
import { Route as appRecommendationManagementMainPageStoreListRouteImport } from './app/routes/(app)/recommendation-management/main-page/$store-list/route'
import { Route as appPaymentManagementStorePaymentLogStoreIdRouteImport } from './app/routes/(app)/payment-management/store-payment-log/$storeId/route'
import { Route as appLogsManagementStaticDataTypeStaticDataTypeNameRouteImport } from './app/routes/(app)/logs-management/static-data-type/$staticDataTypeName/route'
import { Route as appConfigurationManagementGroupManagementSubGroupRouteImport } from './app/routes/(app)/configuration-management/group-management/$sub-group/route'
import { Route as appConfigurationManagementDiscountManagementDiscountCategoryRouteImport } from './app/routes/(app)/configuration-management/discount-management/$discountCategory/route'
import { Route as appConfigurationManagementCommissionsCategoryIdRouteImport } from './app/routes/(app)/configuration-management/commissions/$categoryId/route'
import { Route as appConfigurationManagementChargesCategoryIdRouteImport } from './app/routes/(app)/configuration-management/charges/$categoryId/route'
import { Route as appStoreInformationPremiumStoresAddPremiumStoreIndexImport } from './app/routes/(app)/store-information/premium-stores/add-premium-store/index'
import { Route as appStoreInformationPremiumStoresManagePremiumStoreIndexImport } from './app/routes/(app)/store-information/premium-stores/$manage-premium-store/index'
import { Route as appStoreInformationBasicStoresAddStoreIndexImport } from './app/routes/(app)/store-information/basic-stores/add-store/index'
import { Route as appStoreInformationBasicStoresManageStoreIndexImport } from './app/routes/(app)/store-information/basic-stores/$manage-store/index'
import { Route as appRecommendationManagementMainPageStoreListIndexImport } from './app/routes/(app)/recommendation-management/main-page/$store-list/index'
import { Route as appPaymentManagementStorePaymentLogStoreIdIndexImport } from './app/routes/(app)/payment-management/store-payment-log/$storeId/index'
import { Route as appLogsManagementStaticDataTypeStaticDataTypeNameIndexImport } from './app/routes/(app)/logs-management/static-data-type/$staticDataTypeName/index'
import { Route as appConfigurationManagementGroupManagementSubGroupIndexImport } from './app/routes/(app)/configuration-management/group-management/$sub-group/index'
import { Route as appConfigurationManagementDiscountManagementDiscountCategoryIndexImport } from './app/routes/(app)/configuration-management/discount-management/$discountCategory/index'
import { Route as appConfigurationManagementCommissionsCategoryIdIndexImport } from './app/routes/(app)/configuration-management/commissions/$categoryId/index'
import { Route as appConfigurationManagementChargesCategoryIdIndexImport } from './app/routes/(app)/configuration-management/charges/$categoryId/index'
import { Route as appUsersRolesPrivilegeRoleIdImport } from './app/routes/(app)/users/roles/privilege/$roleId'
import { Route as appConfigurationManagementGroupManagementSubGroupClubGalleryImport } from './app/routes/(app)/configuration-management/group-management/$sub-group/$club-gallery'
import { Route as appStoreInformationPremiumStoresPlanManagementClubidRouteImport } from './app/routes/(app)/store-information/premium-stores/plan-management/$clubid/route'
import { Route as appStoreInformationPremiumStoresHostManagementGalleryRouteImport } from './app/routes/(app)/store-information/premium-stores/host-management/gallery/route'
import { Route as appStoreInformationPremiumStoresHostManagementClubidRouteImport } from './app/routes/(app)/store-information/premium-stores/host-management/$clubid/route'
import { Route as appStoreInformationPremiumStoresGalleryStoreGalleryRouteImport } from './app/routes/(app)/store-information/premium-stores/gallery/$store-gallery/route'
import { Route as appStoreInformationBasicStoresHostManagementClubidRouteImport } from './app/routes/(app)/store-information/basic-stores/host-management/$clubid/route'
import { Route as appRecommendationManagementMainPageStoreListHostListRouteImport } from './app/routes/(app)/recommendation-management/main-page/$store-list/$host-list/route'
import { Route as appPointsManagementPointsConfigurationCustomerProgramIdRouteImport } from './app/routes/(app)/points-management/points-configuration/customer/$programId/route'
import { Route as appConfigurationManagementChargesCategoryIdSlabsRouteImport } from './app/routes/(app)/configuration-management/charges/$categoryId/slabs/route'
import { Route as appStoreInformationPremiumStoresPlanManagementClubidIndexImport } from './app/routes/(app)/store-information/premium-stores/plan-management/$clubid/index'
import { Route as appStoreInformationPremiumStoresHostManagementClubidIndexImport } from './app/routes/(app)/store-information/premium-stores/host-management/$clubid/index'
import { Route as appStoreInformationPremiumStoresGalleryStoreGalleryIndexImport } from './app/routes/(app)/store-information/premium-stores/gallery/$store-gallery/index'
import { Route as appStoreInformationBasicStoresSwitchStoreIdIndexImport } from './app/routes/(app)/store-information/basic-stores/switch-store/$id/index'
import { Route as appStoreInformationBasicStoresHostManagementClubidIndexImport } from './app/routes/(app)/store-information/basic-stores/host-management/$clubid/index'
import { Route as appRecommendationManagementMainPageStoreListHostListIndexImport } from './app/routes/(app)/recommendation-management/main-page/$store-list/$host-list/index'
import { Route as appPointsManagementPointsConfigurationCustomerProgramIdIndexImport } from './app/routes/(app)/points-management/points-configuration/customer/$programId/index'
import { Route as appDashboardReferralReportsReportTypeReferrerIdIndexImport } from './app/routes/(app)/dashboard/referral-reports/$reportType/$referrerId/index'
import { Route as appConfigurationManagementChargesCategoryIdSlabsIndexImport } from './app/routes/(app)/configuration-management/charges/$categoryId/slabs/index'
import { Route as appPointsManagementPointsConfigurationAffiliatePointCategoryIdSlabsImport } from './app/routes/(app)/points-management/points-configuration/affiliate/$pointCategoryId/slabs'
import { Route as appStoreInformationPremiumStoresHostManagementGalleryHostGalleryRouteImport } from './app/routes/(app)/store-information/premium-stores/host-management/gallery/$host-gallery/route'
import { Route as appStoreInformationPremiumStoresHostManagementClubidGalleryRouteImport } from './app/routes/(app)/store-information/premium-stores/host-management/$clubid/gallery/route'
import { Route as appStoreInformationPremiumStoresHostManagementClubidAddHostRouteImport } from './app/routes/(app)/store-information/premium-stores/host-management/$clubid/add-host/route'
import { Route as appStoreInformationPremiumStoresHostManagementClubidManageHostRouteImport } from './app/routes/(app)/store-information/premium-stores/host-management/$clubid/$manage-host/route'
import { Route as appStoreInformationBasicStoresHostManagementClubidGalleryRouteImport } from './app/routes/(app)/store-information/basic-stores/host-management/$clubid/gallery/route'
import { Route as appStoreInformationBasicStoresHostManagementClubidAddHostRouteImport } from './app/routes/(app)/store-information/basic-stores/host-management/$clubid/add-host/route'
import { Route as appStoreInformationBasicStoresHostManagementClubidManageHostRouteImport } from './app/routes/(app)/store-information/basic-stores/host-management/$clubid/$manage-host/route'
import { Route as appStoreInformationPremiumStoresHostManagementGalleryHostGalleryIndexImport } from './app/routes/(app)/store-information/premium-stores/host-management/gallery/$host-gallery/index'
import { Route as appStoreInformationPremiumStoresHostManagementClubidAddHostIndexImport } from './app/routes/(app)/store-information/premium-stores/host-management/$clubid/add-host/index'
import { Route as appStoreInformationPremiumStoresHostManagementClubidManageHostIndexImport } from './app/routes/(app)/store-information/premium-stores/host-management/$clubid/$manage-host/index'
import { Route as appStoreInformationBasicStoresHostManagementClubidAddHostIndexImport } from './app/routes/(app)/store-information/basic-stores/host-management/$clubid/add-host/index'
import { Route as appStoreInformationBasicStoresHostManagementClubidManageHostIndexImport } from './app/routes/(app)/store-information/basic-stores/host-management/$clubid/$manage-host/index'
import { Route as appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryRouteImport } from './app/routes/(app)/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery/route'
import { Route as appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryRouteImport } from './app/routes/(app)/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery/route'
import { Route as appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryIndexImport } from './app/routes/(app)/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery/index'
import { Route as appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryIndexImport } from './app/routes/(app)/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery/index'

// Create/Update Routes

const appRouteRoute = appRouteImport.update({
  id: '/(app)',
  getParentRoute: () => IndexRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const authLoginRoute = authLoginImport.update({
  id: '/(auth)/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const appForbiddenRoute = appForbiddenImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => appRouteRoute,
} as any)

const appUsersRouteRoute = appUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => appRouteRoute,
} as any)

const appStoreInformationRouteRoute = appStoreInformationRouteImport.update({
  id: '/store-information',
  path: '/store-information',
  getParentRoute: () => appRouteRoute,
} as any)

const appRecommendationManagementRouteRoute =
  appRecommendationManagementRouteImport.update({
    id: '/recommendation-management',
    path: '/recommendation-management',
    getParentRoute: () => appRouteRoute,
  } as any)

const appPromosOfferRouteRoute = appPromosOfferRouteImport.update({
  id: '/promos-offer',
  path: '/promos-offer',
  getParentRoute: () => appRouteRoute,
} as any)

const appPointsManagementRouteRoute = appPointsManagementRouteImport.update({
  id: '/points-management',
  path: '/points-management',
  getParentRoute: () => appRouteRoute,
} as any)

const appPaymentManagementRouteRoute = appPaymentManagementRouteImport.update({
  id: '/payment-management',
  path: '/payment-management',
  getParentRoute: () => appRouteRoute,
} as any)

const appLogsManagementRouteRoute = appLogsManagementRouteImport.update({
  id: '/logs-management',
  path: '/logs-management',
  getParentRoute: () => appRouteRoute,
} as any)

const appFaqRouteRoute = appFaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => appRouteRoute,
} as any)

const appDashboardRouteRoute = appDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => appRouteRoute,
} as any)

const appConfigurationManagementRouteRoute =
  appConfigurationManagementRouteImport.update({
    id: '/configuration-management',
    path: '/configuration-management',
    getParentRoute: () => appRouteRoute,
  } as any)

const appAccountRouteRoute = appAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => appRouteRoute,
} as any)

const appUsersIndexRoute = appUsersIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appUsersRouteRoute,
} as any)

const appStoreInformationIndexRoute = appStoreInformationIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appStoreInformationRouteRoute,
} as any)

const appRecommendationManagementIndexRoute =
  appRecommendationManagementIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appRecommendationManagementRouteRoute,
  } as any)

const appPromosOfferIndexRoute = appPromosOfferIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appPromosOfferRouteRoute,
} as any)

const appPointsManagementIndexRoute = appPointsManagementIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appPointsManagementRouteRoute,
} as any)

const appPaymentManagementIndexRoute = appPaymentManagementIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appPaymentManagementRouteRoute,
} as any)

const appLogsManagementIndexRoute = appLogsManagementIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appLogsManagementRouteRoute,
} as any)

const appFaqIndexRoute = appFaqIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appFaqRouteRoute,
} as any)

const appDashboardIndexRoute = appDashboardIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appDashboardRouteRoute,
} as any)

const appConfigurationManagementIndexRoute =
  appConfigurationManagementIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appConfigurationManagementRouteRoute,
  } as any)

const appAccountIndexRoute = appAccountIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appAccountRouteRoute,
} as any)

const appPromosOfferOfferRoute = appPromosOfferOfferImport.update({
  id: '/offer',
  path: '/offer',
  getParentRoute: () => appPromosOfferRouteRoute,
} as any)

const appDashboardSalesPerformanceRoute =
  appDashboardSalesPerformanceImport.update({
    id: '/sales-performance',
    path: '/sales-performance',
    getParentRoute: () => appDashboardRouteRoute,
  } as any)

const appDashboardOverviewRoute = appDashboardOverviewImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => appDashboardRouteRoute,
} as any)

const appAccountLanguageRoute = appAccountLanguageImport.update({
  id: '/language',
  path: '/language',
  getParentRoute: () => appAccountRouteRoute,
} as any)

const appUsersStoreOwnersRouteRoute = appUsersStoreOwnersRouteImport.update({
  id: '/store-owners',
  path: '/store-owners',
  getParentRoute: () => appUsersRouteRoute,
} as any)

const appUsersRolesRouteRoute = appUsersRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => appUsersRouteRoute,
} as any)

const appUsersCustomersRouteRoute = appUsersCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => appUsersRouteRoute,
} as any)

const appUsersAffiliatesRouteRoute = appUsersAffiliatesRouteImport.update({
  id: '/affiliates',
  path: '/affiliates',
  getParentRoute: () => appUsersRouteRoute,
} as any)

const appUsersAdminRouteRoute = appUsersAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => appUsersRouteRoute,
} as any)

const appStoreInformationSwitchStoreRouteRoute =
  appStoreInformationSwitchStoreRouteImport.update({
    id: '/switch-store',
    path: '/switch-store',
    getParentRoute: () => appStoreInformationRouteRoute,
  } as any)

const appStoreInformationPremiumStoresRouteRoute =
  appStoreInformationPremiumStoresRouteImport.update({
    id: '/premium-stores',
    path: '/premium-stores',
    getParentRoute: () => appStoreInformationRouteRoute,
  } as any)

const appStoreInformationBasicStoresRouteRoute =
  appStoreInformationBasicStoresRouteImport.update({
    id: '/basic-stores',
    path: '/basic-stores',
    getParentRoute: () => appStoreInformationRouteRoute,
  } as any)

const appRecommendationManagementMainPageRouteRoute =
  appRecommendationManagementMainPageRouteImport.update({
    id: '/main-page',
    path: '/main-page',
    getParentRoute: () => appRecommendationManagementRouteRoute,
  } as any)

const appRecommendationManagementEditorsPickRouteRoute =
  appRecommendationManagementEditorsPickRouteImport.update({
    id: '/editors-pick',
    path: '/editors-pick',
    getParentRoute: () => appRecommendationManagementRouteRoute,
  } as any)

const appPromosOfferPromotionalBannerRouteRoute =
  appPromosOfferPromotionalBannerRouteImport.update({
    id: '/promotional-banner',
    path: '/promotional-banner',
    getParentRoute: () => appPromosOfferRouteRoute,
  } as any)

const appPromosOfferAdvertisementRouteRoute =
  appPromosOfferAdvertisementRouteImport.update({
    id: '/advertisement',
    path: '/advertisement',
    getParentRoute: () => appPromosOfferRouteRoute,
  } as any)

const appPointsManagementSystemTransferRouteRoute =
  appPointsManagementSystemTransferRouteImport.update({
    id: '/system-transfer',
    path: '/system-transfer',
    getParentRoute: () => appPointsManagementRouteRoute,
  } as any)

const appPointsManagementPointsTransferRouteRoute =
  appPointsManagementPointsTransferRouteImport.update({
    id: '/points-transfer',
    path: '/points-transfer',
    getParentRoute: () => appPointsManagementRouteRoute,
  } as any)

const appPointsManagementPointsConfigurationRouteRoute =
  appPointsManagementPointsConfigurationRouteImport.update({
    id: '/points-configuration',
    path: '/points-configuration',
    getParentRoute: () => appPointsManagementRouteRoute,
  } as any)

const appPointsManagementPointsBalanceStatementRouteRoute =
  appPointsManagementPointsBalanceStatementRouteImport.update({
    id: '/points-balance-statement',
    path: '/points-balance-statement',
    getParentRoute: () => appPointsManagementRouteRoute,
  } as any)

const appPaymentManagementStorePaymentLogRouteRoute =
  appPaymentManagementStorePaymentLogRouteImport.update({
    id: '/store-payment-log',
    path: '/store-payment-log',
    getParentRoute: () => appPaymentManagementRouteRoute,
  } as any)

const appPaymentManagementOverviewRouteRoute =
  appPaymentManagementOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => appPaymentManagementRouteRoute,
  } as any)

const appPaymentManagementCustomerPaymentLogsRouteRoute =
  appPaymentManagementCustomerPaymentLogsRouteImport.update({
    id: '/customer-payment-logs',
    path: '/customer-payment-logs',
    getParentRoute: () => appPaymentManagementRouteRoute,
  } as any)

const appPaymentManagementAffiliateLogRouteRoute =
  appPaymentManagementAffiliateLogRouteImport.update({
    id: '/affiliate-log',
    path: '/affiliate-log',
    getParentRoute: () => appPaymentManagementRouteRoute,
  } as any)

const appPaymentManagementAccountInformationRouteRoute =
  appPaymentManagementAccountInformationRouteImport.update({
    id: '/account-information',
    path: '/account-information',
    getParentRoute: () => appPaymentManagementRouteRoute,
  } as any)

const appLogsManagementStaticDataTypeRouteRoute =
  appLogsManagementStaticDataTypeRouteImport.update({
    id: '/static-data-type',
    path: '/static-data-type',
    getParentRoute: () => appLogsManagementRouteRoute,
  } as any)

const appLogsManagementSmsLogsRouteRoute =
  appLogsManagementSmsLogsRouteImport.update({
    id: '/sms-logs',
    path: '/sms-logs',
    getParentRoute: () => appLogsManagementRouteRoute,
  } as any)

const appLogsManagementEmailLogsRouteRoute =
  appLogsManagementEmailLogsRouteImport.update({
    id: '/email-logs',
    path: '/email-logs',
    getParentRoute: () => appLogsManagementRouteRoute,
  } as any)

const appFaqReviewRatingsRouteRoute = appFaqReviewRatingsRouteImport.update({
  id: '/review-ratings',
  path: '/review-ratings',
  getParentRoute: () => appFaqRouteRoute,
} as any)

const appFaqInquiryRouteRoute = appFaqInquiryRouteImport.update({
  id: '/inquiry',
  path: '/inquiry',
  getParentRoute: () => appFaqRouteRoute,
} as any)

const appFaqComplaintsRouteRoute = appFaqComplaintsRouteImport.update({
  id: '/complaints',
  path: '/complaints',
  getParentRoute: () => appFaqRouteRoute,
} as any)

const appDashboardReservationLedgerRouteRoute =
  appDashboardReservationLedgerRouteImport.update({
    id: '/reservation-ledger',
    path: '/reservation-ledger',
    getParentRoute: () => appDashboardRouteRoute,
  } as any)

const appDashboardReferralReportsRouteRoute =
  appDashboardReferralReportsRouteImport.update({
    id: '/referral-reports',
    path: '/referral-reports',
    getParentRoute: () => appDashboardRouteRoute,
  } as any)

const appDashboardConversionAnalyticsRouteRoute =
  appDashboardConversionAnalyticsRouteImport.update({
    id: '/conversion-analytics',
    path: '/conversion-analytics',
    getParentRoute: () => appDashboardRouteRoute,
  } as any)

const appConfigurationManagementWithdrawalsSetupRouteRoute =
  appConfigurationManagementWithdrawalsSetupRouteImport.update({
    id: '/withdrawals-setup',
    path: '/withdrawals-setup',
    getParentRoute: () => appConfigurationManagementRouteRoute,
  } as any)

const appConfigurationManagementLocationRouteRoute =
  appConfigurationManagementLocationRouteImport.update({
    id: '/location',
    path: '/location',
    getParentRoute: () => appConfigurationManagementRouteRoute,
  } as any)

const appConfigurationManagementHoslogPlansRouteRoute =
  appConfigurationManagementHoslogPlansRouteImport.update({
    id: '/hoslog-plans',
    path: '/hoslog-plans',
    getParentRoute: () => appConfigurationManagementRouteRoute,
  } as any)

const appConfigurationManagementGroupManagementRouteRoute =
  appConfigurationManagementGroupManagementRouteImport.update({
    id: '/group-management',
    path: '/group-management',
    getParentRoute: () => appConfigurationManagementRouteRoute,
  } as any)

const appConfigurationManagementDiscountManagementRouteRoute =
  appConfigurationManagementDiscountManagementRouteImport.update({
    id: '/discount-management',
    path: '/discount-management',
    getParentRoute: () => appConfigurationManagementRouteRoute,
  } as any)

const appConfigurationManagementCommissionsRouteRoute =
  appConfigurationManagementCommissionsRouteImport.update({
    id: '/commissions',
    path: '/commissions',
    getParentRoute: () => appConfigurationManagementRouteRoute,
  } as any)

const appConfigurationManagementChargesRouteRoute =
  appConfigurationManagementChargesRouteImport.update({
    id: '/charges',
    path: '/charges',
    getParentRoute: () => appConfigurationManagementRouteRoute,
  } as any)

const appAccountProfileRouteRoute = appAccountProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => appAccountRouteRoute,
} as any)

const appUsersStoreOwnersIndexRoute = appUsersStoreOwnersIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appUsersStoreOwnersRouteRoute,
} as any)

const appUsersRolesIndexRoute = appUsersRolesIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appUsersRolesRouteRoute,
} as any)

const appUsersCustomersIndexRoute = appUsersCustomersIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appUsersCustomersRouteRoute,
} as any)

const appUsersAffiliatesIndexRoute = appUsersAffiliatesIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appUsersAffiliatesRouteRoute,
} as any)

const appUsersAdminIndexRoute = appUsersAdminIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appUsersAdminRouteRoute,
} as any)

const appStoreInformationPremiumStoresIndexRoute =
  appStoreInformationPremiumStoresIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appStoreInformationPremiumStoresRouteRoute,
  } as any)

const appStoreInformationBasicStoresIndexRoute =
  appStoreInformationBasicStoresIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appStoreInformationBasicStoresRouteRoute,
  } as any)

const appRecommendationManagementMainPageIndexRoute =
  appRecommendationManagementMainPageIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appRecommendationManagementMainPageRouteRoute,
  } as any)

const appRecommendationManagementEditorsPickIndexRoute =
  appRecommendationManagementEditorsPickIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appRecommendationManagementEditorsPickRouteRoute,
  } as any)

const appPromosOfferPromotionalBannerIndexRoute =
  appPromosOfferPromotionalBannerIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appPromosOfferPromotionalBannerRouteRoute,
  } as any)

const appPromosOfferAdvertisementIndexRoute =
  appPromosOfferAdvertisementIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appPromosOfferAdvertisementRouteRoute,
  } as any)

const appPointsManagementSystemTransferIndexRoute =
  appPointsManagementSystemTransferIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appPointsManagementSystemTransferRouteRoute,
  } as any)

const appPointsManagementPointsTransferIndexRoute =
  appPointsManagementPointsTransferIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appPointsManagementPointsTransferRouteRoute,
  } as any)

const appPointsManagementPointsRequestIndexRoute =
  appPointsManagementPointsRequestIndexImport.update({
    id: '/points-request/',
    path: '/points-request/',
    getParentRoute: () => appPointsManagementRouteRoute,
  } as any)

const appPointsManagementPointsConfigurationIndexRoute =
  appPointsManagementPointsConfigurationIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appPointsManagementPointsConfigurationRouteRoute,
  } as any)

const appPointsManagementPointsBalanceStatementIndexRoute =
  appPointsManagementPointsBalanceStatementIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appPointsManagementPointsBalanceStatementRouteRoute,
  } as any)

const appPaymentManagementStorePaymentLogIndexRoute =
  appPaymentManagementStorePaymentLogIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appPaymentManagementStorePaymentLogRouteRoute,
  } as any)

const appPaymentManagementOverviewIndexRoute =
  appPaymentManagementOverviewIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appPaymentManagementOverviewRouteRoute,
  } as any)

const appPaymentManagementCustomerPaymentLogsIndexRoute =
  appPaymentManagementCustomerPaymentLogsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appPaymentManagementCustomerPaymentLogsRouteRoute,
  } as any)

const appPaymentManagementAffiliateLogIndexRoute =
  appPaymentManagementAffiliateLogIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appPaymentManagementAffiliateLogRouteRoute,
  } as any)

const appPaymentManagementAdminPaymentSetupIndexRoute =
  appPaymentManagementAdminPaymentSetupIndexImport.update({
    id: '/admin-payment-setup/',
    path: '/admin-payment-setup/',
    getParentRoute: () => appPaymentManagementRouteRoute,
  } as any)

const appPaymentManagementAccountInformationIndexRoute =
  appPaymentManagementAccountInformationIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appPaymentManagementAccountInformationRouteRoute,
  } as any)

const appLogsManagementStaticDataTypeIndexRoute =
  appLogsManagementStaticDataTypeIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appLogsManagementStaticDataTypeRouteRoute,
  } as any)

const appLogsManagementSmsLogsIndexRoute =
  appLogsManagementSmsLogsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appLogsManagementSmsLogsRouteRoute,
  } as any)

const appLogsManagementEmailLogsIndexRoute =
  appLogsManagementEmailLogsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appLogsManagementEmailLogsRouteRoute,
  } as any)

const appLogsManagementApiLogsIndexRoute =
  appLogsManagementApiLogsIndexImport.update({
    id: '/api-logs/',
    path: '/api-logs/',
    getParentRoute: () => appLogsManagementRouteRoute,
  } as any)

const appLogsManagementAccessLogsIndexRoute =
  appLogsManagementAccessLogsIndexImport.update({
    id: '/access-logs/',
    path: '/access-logs/',
    getParentRoute: () => appLogsManagementRouteRoute,
  } as any)

const appFaqReviewRatingsIndexRoute = appFaqReviewRatingsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appFaqReviewRatingsRouteRoute,
} as any)

const appFaqInquiryIndexRoute = appFaqInquiryIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appFaqInquiryRouteRoute,
} as any)

const appFaqComplaintsIndexRoute = appFaqComplaintsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appFaqComplaintsRouteRoute,
} as any)

const appDashboardReservationLedgerIndexRoute =
  appDashboardReservationLedgerIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appDashboardReservationLedgerRouteRoute,
  } as any)

const appDashboardReferralReportsIndexRoute =
  appDashboardReferralReportsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appDashboardReferralReportsRouteRoute,
  } as any)

const appDashboardConversionAnalyticsIndexRoute =
  appDashboardConversionAnalyticsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appDashboardConversionAnalyticsRouteRoute,
  } as any)

const appConfigurationManagementWithdrawalsSetupIndexRoute =
  appConfigurationManagementWithdrawalsSetupIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appConfigurationManagementWithdrawalsSetupRouteRoute,
  } as any)

const appConfigurationManagementLocationIndexRoute =
  appConfigurationManagementLocationIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appConfigurationManagementLocationRouteRoute,
  } as any)

const appConfigurationManagementHoslogPlansIndexRoute =
  appConfigurationManagementHoslogPlansIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appConfigurationManagementHoslogPlansRouteRoute,
  } as any)

const appConfigurationManagementGroupManagementIndexRoute =
  appConfigurationManagementGroupManagementIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appConfigurationManagementGroupManagementRouteRoute,
  } as any)

const appConfigurationManagementDiscountManagementIndexRoute =
  appConfigurationManagementDiscountManagementIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      appConfigurationManagementDiscountManagementRouteRoute,
  } as any)

const appConfigurationManagementCommissionsIndexRoute =
  appConfigurationManagementCommissionsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appConfigurationManagementCommissionsRouteRoute,
  } as any)

const appConfigurationManagementChargesIndexRoute =
  appConfigurationManagementChargesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appConfigurationManagementChargesRouteRoute,
  } as any)

const appAccountProfileIndexRoute = appAccountProfileIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appAccountProfileRouteRoute,
} as any)

const appUsersCustomersCustomerIdRoute =
  appUsersCustomersCustomerIdImport.update({
    id: '/$customerId',
    path: '/$customerId',
    getParentRoute: () => appUsersCustomersRouteRoute,
  } as any)

const appUsersAffiliatesAffiliateIdRoute =
  appUsersAffiliatesAffiliateIdImport.update({
    id: '/$affiliateId',
    path: '/$affiliateId',
    getParentRoute: () => appUsersAffiliatesRouteRoute,
  } as any)

const appPaymentManagementAffiliateLogMonthlyReportRoute =
  appPaymentManagementAffiliateLogMonthlyReportImport.update({
    id: '/$monthly-report',
    path: '/$monthly-report',
    getParentRoute: () => appPaymentManagementAffiliateLogRouteRoute,
  } as any)

const appPaymentManagementAdminPaymentSetupAddBankInformationRoute =
  appPaymentManagementAdminPaymentSetupAddBankInformationImport.update({
    id: '/admin-payment-setup/add-bank-information',
    path: '/admin-payment-setup/add-bank-information',
    getParentRoute: () => appPaymentManagementRouteRoute,
  } as any)

const appStoreInformationPremiumStoresPlanManagementRouteRoute =
  appStoreInformationPremiumStoresPlanManagementRouteImport.update({
    id: '/plan-management',
    path: '/plan-management',
    getParentRoute: () => appStoreInformationPremiumStoresRouteRoute,
  } as any)

const appStoreInformationPremiumStoresAddPremiumStoreRouteRoute =
  appStoreInformationPremiumStoresAddPremiumStoreRouteImport.update({
    id: '/add-premium-store',
    path: '/add-premium-store',
    getParentRoute: () => appStoreInformationPremiumStoresRouteRoute,
  } as any)

const appStoreInformationPremiumStoresManagePremiumStoreRouteRoute =
  appStoreInformationPremiumStoresManagePremiumStoreRouteImport.update({
    id: '/$manage-premium-store',
    path: '/$manage-premium-store',
    getParentRoute: () => appStoreInformationPremiumStoresRouteRoute,
  } as any)

const appStoreInformationBasicStoresSwitchStoreRouteRoute =
  appStoreInformationBasicStoresSwitchStoreRouteImport.update({
    id: '/switch-store',
    path: '/switch-store',
    getParentRoute: () => appStoreInformationBasicStoresRouteRoute,
  } as any)

const appStoreInformationBasicStoresAddStoreRouteRoute =
  appStoreInformationBasicStoresAddStoreRouteImport.update({
    id: '/add-store',
    path: '/add-store',
    getParentRoute: () => appStoreInformationBasicStoresRouteRoute,
  } as any)

const appStoreInformationBasicStoresManageStoreRouteRoute =
  appStoreInformationBasicStoresManageStoreRouteImport.update({
    id: '/$manage-store',
    path: '/$manage-store',
    getParentRoute: () => appStoreInformationBasicStoresRouteRoute,
  } as any)

const appRecommendationManagementMainPageStoreListRouteRoute =
  appRecommendationManagementMainPageStoreListRouteImport.update({
    id: '/$store-list',
    path: '/$store-list',
    getParentRoute: () => appRecommendationManagementMainPageRouteRoute,
  } as any)

const appPaymentManagementStorePaymentLogStoreIdRouteRoute =
  appPaymentManagementStorePaymentLogStoreIdRouteImport.update({
    id: '/$storeId',
    path: '/$storeId',
    getParentRoute: () => appPaymentManagementStorePaymentLogRouteRoute,
  } as any)

const appLogsManagementStaticDataTypeStaticDataTypeNameRouteRoute =
  appLogsManagementStaticDataTypeStaticDataTypeNameRouteImport.update({
    id: '/$staticDataTypeName',
    path: '/$staticDataTypeName',
    getParentRoute: () => appLogsManagementStaticDataTypeRouteRoute,
  } as any)

const appConfigurationManagementGroupManagementSubGroupRouteRoute =
  appConfigurationManagementGroupManagementSubGroupRouteImport.update({
    id: '/$sub-group',
    path: '/$sub-group',
    getParentRoute: () => appConfigurationManagementGroupManagementRouteRoute,
  } as any)

const appConfigurationManagementDiscountManagementDiscountCategoryRouteRoute =
  appConfigurationManagementDiscountManagementDiscountCategoryRouteImport.update(
    {
      id: '/$discountCategory',
      path: '/$discountCategory',
      getParentRoute: () =>
        appConfigurationManagementDiscountManagementRouteRoute,
    } as any,
  )

const appConfigurationManagementCommissionsCategoryIdRouteRoute =
  appConfigurationManagementCommissionsCategoryIdRouteImport.update({
    id: '/$categoryId',
    path: '/$categoryId',
    getParentRoute: () => appConfigurationManagementCommissionsRouteRoute,
  } as any)

const appConfigurationManagementChargesCategoryIdRouteRoute =
  appConfigurationManagementChargesCategoryIdRouteImport.update({
    id: '/$categoryId',
    path: '/$categoryId',
    getParentRoute: () => appConfigurationManagementChargesRouteRoute,
  } as any)

const appStoreInformationPremiumStoresAddPremiumStoreIndexRoute =
  appStoreInformationPremiumStoresAddPremiumStoreIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      appStoreInformationPremiumStoresAddPremiumStoreRouteRoute,
  } as any)

const appStoreInformationPremiumStoresManagePremiumStoreIndexRoute =
  appStoreInformationPremiumStoresManagePremiumStoreIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      appStoreInformationPremiumStoresManagePremiumStoreRouteRoute,
  } as any)

const appStoreInformationBasicStoresAddStoreIndexRoute =
  appStoreInformationBasicStoresAddStoreIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appStoreInformationBasicStoresAddStoreRouteRoute,
  } as any)

const appStoreInformationBasicStoresManageStoreIndexRoute =
  appStoreInformationBasicStoresManageStoreIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appStoreInformationBasicStoresManageStoreRouteRoute,
  } as any)

const appRecommendationManagementMainPageStoreListIndexRoute =
  appRecommendationManagementMainPageStoreListIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      appRecommendationManagementMainPageStoreListRouteRoute,
  } as any)

const appPaymentManagementStorePaymentLogStoreIdIndexRoute =
  appPaymentManagementStorePaymentLogStoreIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appPaymentManagementStorePaymentLogStoreIdRouteRoute,
  } as any)

const appLogsManagementStaticDataTypeStaticDataTypeNameIndexRoute =
  appLogsManagementStaticDataTypeStaticDataTypeNameIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      appLogsManagementStaticDataTypeStaticDataTypeNameRouteRoute,
  } as any)

const appConfigurationManagementGroupManagementSubGroupIndexRoute =
  appConfigurationManagementGroupManagementSubGroupIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      appConfigurationManagementGroupManagementSubGroupRouteRoute,
  } as any)

const appConfigurationManagementDiscountManagementDiscountCategoryIndexRoute =
  appConfigurationManagementDiscountManagementDiscountCategoryIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        appConfigurationManagementDiscountManagementDiscountCategoryRouteRoute,
    } as any,
  )

const appConfigurationManagementCommissionsCategoryIdIndexRoute =
  appConfigurationManagementCommissionsCategoryIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      appConfigurationManagementCommissionsCategoryIdRouteRoute,
  } as any)

const appConfigurationManagementChargesCategoryIdIndexRoute =
  appConfigurationManagementChargesCategoryIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appConfigurationManagementChargesCategoryIdRouteRoute,
  } as any)

const appUsersRolesPrivilegeRoleIdRoute =
  appUsersRolesPrivilegeRoleIdImport.update({
    id: '/privilege/$roleId',
    path: '/privilege/$roleId',
    getParentRoute: () => appUsersRolesRouteRoute,
  } as any)

const appConfigurationManagementGroupManagementSubGroupClubGalleryRoute =
  appConfigurationManagementGroupManagementSubGroupClubGalleryImport.update({
    id: '/$club-gallery',
    path: '/$club-gallery',
    getParentRoute: () =>
      appConfigurationManagementGroupManagementSubGroupRouteRoute,
  } as any)

const appStoreInformationPremiumStoresPlanManagementClubidRouteRoute =
  appStoreInformationPremiumStoresPlanManagementClubidRouteImport.update({
    id: '/$clubid',
    path: '/$clubid',
    getParentRoute: () =>
      appStoreInformationPremiumStoresPlanManagementRouteRoute,
  } as any)

const appStoreInformationPremiumStoresHostManagementGalleryRouteRoute =
  appStoreInformationPremiumStoresHostManagementGalleryRouteImport.update({
    id: '/host-management/gallery',
    path: '/host-management/gallery',
    getParentRoute: () => appStoreInformationPremiumStoresRouteRoute,
  } as any)

const appStoreInformationPremiumStoresHostManagementClubidRouteRoute =
  appStoreInformationPremiumStoresHostManagementClubidRouteImport.update({
    id: '/host-management/$clubid',
    path: '/host-management/$clubid',
    getParentRoute: () => appStoreInformationPremiumStoresRouteRoute,
  } as any)

const appStoreInformationPremiumStoresGalleryStoreGalleryRouteRoute =
  appStoreInformationPremiumStoresGalleryStoreGalleryRouteImport.update({
    id: '/gallery/$store-gallery',
    path: '/gallery/$store-gallery',
    getParentRoute: () => appStoreInformationPremiumStoresRouteRoute,
  } as any)

const appStoreInformationBasicStoresHostManagementClubidRouteRoute =
  appStoreInformationBasicStoresHostManagementClubidRouteImport.update({
    id: '/host-management/$clubid',
    path: '/host-management/$clubid',
    getParentRoute: () => appStoreInformationBasicStoresRouteRoute,
  } as any)

const appRecommendationManagementMainPageStoreListHostListRouteRoute =
  appRecommendationManagementMainPageStoreListHostListRouteImport.update({
    id: '/$host-list',
    path: '/$host-list',
    getParentRoute: () =>
      appRecommendationManagementMainPageStoreListRouteRoute,
  } as any)

const appPointsManagementPointsConfigurationCustomerProgramIdRouteRoute =
  appPointsManagementPointsConfigurationCustomerProgramIdRouteImport.update({
    id: '/customer/$programId',
    path: '/customer/$programId',
    getParentRoute: () => appPointsManagementPointsConfigurationRouteRoute,
  } as any)

const appConfigurationManagementChargesCategoryIdSlabsRouteRoute =
  appConfigurationManagementChargesCategoryIdSlabsRouteImport.update({
    id: '/slabs',
    path: '/slabs',
    getParentRoute: () => appConfigurationManagementChargesCategoryIdRouteRoute,
  } as any)

const appStoreInformationPremiumStoresPlanManagementClubidIndexRoute =
  appStoreInformationPremiumStoresPlanManagementClubidIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      appStoreInformationPremiumStoresPlanManagementClubidRouteRoute,
  } as any)

const appStoreInformationPremiumStoresHostManagementClubidIndexRoute =
  appStoreInformationPremiumStoresHostManagementClubidIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      appStoreInformationPremiumStoresHostManagementClubidRouteRoute,
  } as any)

const appStoreInformationPremiumStoresGalleryStoreGalleryIndexRoute =
  appStoreInformationPremiumStoresGalleryStoreGalleryIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      appStoreInformationPremiumStoresGalleryStoreGalleryRouteRoute,
  } as any)

const appStoreInformationBasicStoresSwitchStoreIdIndexRoute =
  appStoreInformationBasicStoresSwitchStoreIdIndexImport.update({
    id: '/$id/',
    path: '/$id/',
    getParentRoute: () => appStoreInformationBasicStoresSwitchStoreRouteRoute,
  } as any)

const appStoreInformationBasicStoresHostManagementClubidIndexRoute =
  appStoreInformationBasicStoresHostManagementClubidIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      appStoreInformationBasicStoresHostManagementClubidRouteRoute,
  } as any)

const appRecommendationManagementMainPageStoreListHostListIndexRoute =
  appRecommendationManagementMainPageStoreListHostListIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      appRecommendationManagementMainPageStoreListHostListRouteRoute,
  } as any)

const appPointsManagementPointsConfigurationCustomerProgramIdIndexRoute =
  appPointsManagementPointsConfigurationCustomerProgramIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      appPointsManagementPointsConfigurationCustomerProgramIdRouteRoute,
  } as any)

const appDashboardReferralReportsReportTypeReferrerIdIndexRoute =
  appDashboardReferralReportsReportTypeReferrerIdIndexImport.update({
    id: '/$reportType/$referrerId/',
    path: '/$reportType/$referrerId/',
    getParentRoute: () => appDashboardReferralReportsRouteRoute,
  } as any)

const appConfigurationManagementChargesCategoryIdSlabsIndexRoute =
  appConfigurationManagementChargesCategoryIdSlabsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      appConfigurationManagementChargesCategoryIdSlabsRouteRoute,
  } as any)

const appPointsManagementPointsConfigurationAffiliatePointCategoryIdSlabsRoute =
  appPointsManagementPointsConfigurationAffiliatePointCategoryIdSlabsImport.update(
    {
      id: '/affiliate/$pointCategoryId/slabs',
      path: '/affiliate/$pointCategoryId/slabs',
      getParentRoute: () => appPointsManagementPointsConfigurationRouteRoute,
    } as any,
  )

const appStoreInformationPremiumStoresHostManagementGalleryHostGalleryRouteRoute =
  appStoreInformationPremiumStoresHostManagementGalleryHostGalleryRouteImport.update(
    {
      id: '/$host-gallery',
      path: '/$host-gallery',
      getParentRoute: () =>
        appStoreInformationPremiumStoresHostManagementGalleryRouteRoute,
    } as any,
  )

const appStoreInformationPremiumStoresHostManagementClubidGalleryRouteRoute =
  appStoreInformationPremiumStoresHostManagementClubidGalleryRouteImport.update(
    {
      id: '/gallery',
      path: '/gallery',
      getParentRoute: () =>
        appStoreInformationPremiumStoresHostManagementClubidRouteRoute,
    } as any,
  )

const appStoreInformationPremiumStoresHostManagementClubidAddHostRouteRoute =
  appStoreInformationPremiumStoresHostManagementClubidAddHostRouteImport.update(
    {
      id: '/add-host',
      path: '/add-host',
      getParentRoute: () =>
        appStoreInformationPremiumStoresHostManagementClubidRouteRoute,
    } as any,
  )

const appStoreInformationPremiumStoresHostManagementClubidManageHostRouteRoute =
  appStoreInformationPremiumStoresHostManagementClubidManageHostRouteImport.update(
    {
      id: '/$manage-host',
      path: '/$manage-host',
      getParentRoute: () =>
        appStoreInformationPremiumStoresHostManagementClubidRouteRoute,
    } as any,
  )

const appStoreInformationBasicStoresHostManagementClubidGalleryRouteRoute =
  appStoreInformationBasicStoresHostManagementClubidGalleryRouteImport.update({
    id: '/gallery',
    path: '/gallery',
    getParentRoute: () =>
      appStoreInformationBasicStoresHostManagementClubidRouteRoute,
  } as any)

const appStoreInformationBasicStoresHostManagementClubidAddHostRouteRoute =
  appStoreInformationBasicStoresHostManagementClubidAddHostRouteImport.update({
    id: '/add-host',
    path: '/add-host',
    getParentRoute: () =>
      appStoreInformationBasicStoresHostManagementClubidRouteRoute,
  } as any)

const appStoreInformationBasicStoresHostManagementClubidManageHostRouteRoute =
  appStoreInformationBasicStoresHostManagementClubidManageHostRouteImport.update(
    {
      id: '/$manage-host',
      path: '/$manage-host',
      getParentRoute: () =>
        appStoreInformationBasicStoresHostManagementClubidRouteRoute,
    } as any,
  )

const appStoreInformationPremiumStoresHostManagementGalleryHostGalleryIndexRoute =
  appStoreInformationPremiumStoresHostManagementGalleryHostGalleryIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        appStoreInformationPremiumStoresHostManagementGalleryHostGalleryRouteRoute,
    } as any,
  )

const appStoreInformationPremiumStoresHostManagementClubidAddHostIndexRoute =
  appStoreInformationPremiumStoresHostManagementClubidAddHostIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        appStoreInformationPremiumStoresHostManagementClubidAddHostRouteRoute,
    } as any,
  )

const appStoreInformationPremiumStoresHostManagementClubidManageHostIndexRoute =
  appStoreInformationPremiumStoresHostManagementClubidManageHostIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        appStoreInformationPremiumStoresHostManagementClubidManageHostRouteRoute,
    } as any,
  )

const appStoreInformationBasicStoresHostManagementClubidAddHostIndexRoute =
  appStoreInformationBasicStoresHostManagementClubidAddHostIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      appStoreInformationBasicStoresHostManagementClubidAddHostRouteRoute,
  } as any)

const appStoreInformationBasicStoresHostManagementClubidManageHostIndexRoute =
  appStoreInformationBasicStoresHostManagementClubidManageHostIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        appStoreInformationBasicStoresHostManagementClubidManageHostRouteRoute,
    } as any,
  )

const appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryRouteRoute =
  appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryRouteImport.update(
    {
      id: '/$host-gallery',
      path: '/$host-gallery',
      getParentRoute: () =>
        appStoreInformationPremiumStoresHostManagementClubidGalleryRouteRoute,
    } as any,
  )

const appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryRouteRoute =
  appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryRouteImport.update(
    {
      id: '/$host-gallery',
      path: '/$host-gallery',
      getParentRoute: () =>
        appStoreInformationBasicStoresHostManagementClubidGalleryRouteRoute,
    } as any,
  )

const appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryIndexRoute =
  appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryRouteRoute,
    } as any,
  )

const appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryIndexRoute =
  appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryRouteRoute,
    } as any,
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/(app)': {
      id: '/(app)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof appRouteImport
      parentRoute: typeof IndexRoute
    }
    '/(app)/account': {
      id: '/(app)/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof appAccountRouteImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/configuration-management': {
      id: '/(app)/configuration-management'
      path: '/configuration-management'
      fullPath: '/configuration-management'
      preLoaderRoute: typeof appConfigurationManagementRouteImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/dashboard': {
      id: '/(app)/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof appDashboardRouteImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/faq': {
      id: '/(app)/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof appFaqRouteImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/logs-management': {
      id: '/(app)/logs-management'
      path: '/logs-management'
      fullPath: '/logs-management'
      preLoaderRoute: typeof appLogsManagementRouteImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/payment-management': {
      id: '/(app)/payment-management'
      path: '/payment-management'
      fullPath: '/payment-management'
      preLoaderRoute: typeof appPaymentManagementRouteImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/points-management': {
      id: '/(app)/points-management'
      path: '/points-management'
      fullPath: '/points-management'
      preLoaderRoute: typeof appPointsManagementRouteImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/promos-offer': {
      id: '/(app)/promos-offer'
      path: '/promos-offer'
      fullPath: '/promos-offer'
      preLoaderRoute: typeof appPromosOfferRouteImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/recommendation-management': {
      id: '/(app)/recommendation-management'
      path: '/recommendation-management'
      fullPath: '/recommendation-management'
      preLoaderRoute: typeof appRecommendationManagementRouteImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/store-information': {
      id: '/(app)/store-information'
      path: '/store-information'
      fullPath: '/store-information'
      preLoaderRoute: typeof appStoreInformationRouteImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/users': {
      id: '/(app)/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof appUsersRouteImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/forbidden': {
      id: '/(app)/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof appForbiddenImport
      parentRoute: typeof appRouteImport
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginImport
      parentRoute: typeof rootRoute
    }
    '/(app)/account/profile': {
      id: '/(app)/account/profile'
      path: '/profile'
      fullPath: '/account/profile'
      preLoaderRoute: typeof appAccountProfileRouteImport
      parentRoute: typeof appAccountRouteImport
    }
    '/(app)/configuration-management/charges': {
      id: '/(app)/configuration-management/charges'
      path: '/charges'
      fullPath: '/configuration-management/charges'
      preLoaderRoute: typeof appConfigurationManagementChargesRouteImport
      parentRoute: typeof appConfigurationManagementRouteImport
    }
    '/(app)/configuration-management/commissions': {
      id: '/(app)/configuration-management/commissions'
      path: '/commissions'
      fullPath: '/configuration-management/commissions'
      preLoaderRoute: typeof appConfigurationManagementCommissionsRouteImport
      parentRoute: typeof appConfigurationManagementRouteImport
    }
    '/(app)/configuration-management/discount-management': {
      id: '/(app)/configuration-management/discount-management'
      path: '/discount-management'
      fullPath: '/configuration-management/discount-management'
      preLoaderRoute: typeof appConfigurationManagementDiscountManagementRouteImport
      parentRoute: typeof appConfigurationManagementRouteImport
    }
    '/(app)/configuration-management/group-management': {
      id: '/(app)/configuration-management/group-management'
      path: '/group-management'
      fullPath: '/configuration-management/group-management'
      preLoaderRoute: typeof appConfigurationManagementGroupManagementRouteImport
      parentRoute: typeof appConfigurationManagementRouteImport
    }
    '/(app)/configuration-management/hoslog-plans': {
      id: '/(app)/configuration-management/hoslog-plans'
      path: '/hoslog-plans'
      fullPath: '/configuration-management/hoslog-plans'
      preLoaderRoute: typeof appConfigurationManagementHoslogPlansRouteImport
      parentRoute: typeof appConfigurationManagementRouteImport
    }
    '/(app)/configuration-management/location': {
      id: '/(app)/configuration-management/location'
      path: '/location'
      fullPath: '/configuration-management/location'
      preLoaderRoute: typeof appConfigurationManagementLocationRouteImport
      parentRoute: typeof appConfigurationManagementRouteImport
    }
    '/(app)/configuration-management/withdrawals-setup': {
      id: '/(app)/configuration-management/withdrawals-setup'
      path: '/withdrawals-setup'
      fullPath: '/configuration-management/withdrawals-setup'
      preLoaderRoute: typeof appConfigurationManagementWithdrawalsSetupRouteImport
      parentRoute: typeof appConfigurationManagementRouteImport
    }
    '/(app)/dashboard/conversion-analytics': {
      id: '/(app)/dashboard/conversion-analytics'
      path: '/conversion-analytics'
      fullPath: '/dashboard/conversion-analytics'
      preLoaderRoute: typeof appDashboardConversionAnalyticsRouteImport
      parentRoute: typeof appDashboardRouteImport
    }
    '/(app)/dashboard/referral-reports': {
      id: '/(app)/dashboard/referral-reports'
      path: '/referral-reports'
      fullPath: '/dashboard/referral-reports'
      preLoaderRoute: typeof appDashboardReferralReportsRouteImport
      parentRoute: typeof appDashboardRouteImport
    }
    '/(app)/dashboard/reservation-ledger': {
      id: '/(app)/dashboard/reservation-ledger'
      path: '/reservation-ledger'
      fullPath: '/dashboard/reservation-ledger'
      preLoaderRoute: typeof appDashboardReservationLedgerRouteImport
      parentRoute: typeof appDashboardRouteImport
    }
    '/(app)/faq/complaints': {
      id: '/(app)/faq/complaints'
      path: '/complaints'
      fullPath: '/faq/complaints'
      preLoaderRoute: typeof appFaqComplaintsRouteImport
      parentRoute: typeof appFaqRouteImport
    }
    '/(app)/faq/inquiry': {
      id: '/(app)/faq/inquiry'
      path: '/inquiry'
      fullPath: '/faq/inquiry'
      preLoaderRoute: typeof appFaqInquiryRouteImport
      parentRoute: typeof appFaqRouteImport
    }
    '/(app)/faq/review-ratings': {
      id: '/(app)/faq/review-ratings'
      path: '/review-ratings'
      fullPath: '/faq/review-ratings'
      preLoaderRoute: typeof appFaqReviewRatingsRouteImport
      parentRoute: typeof appFaqRouteImport
    }
    '/(app)/logs-management/email-logs': {
      id: '/(app)/logs-management/email-logs'
      path: '/email-logs'
      fullPath: '/logs-management/email-logs'
      preLoaderRoute: typeof appLogsManagementEmailLogsRouteImport
      parentRoute: typeof appLogsManagementRouteImport
    }
    '/(app)/logs-management/sms-logs': {
      id: '/(app)/logs-management/sms-logs'
      path: '/sms-logs'
      fullPath: '/logs-management/sms-logs'
      preLoaderRoute: typeof appLogsManagementSmsLogsRouteImport
      parentRoute: typeof appLogsManagementRouteImport
    }
    '/(app)/logs-management/static-data-type': {
      id: '/(app)/logs-management/static-data-type'
      path: '/static-data-type'
      fullPath: '/logs-management/static-data-type'
      preLoaderRoute: typeof appLogsManagementStaticDataTypeRouteImport
      parentRoute: typeof appLogsManagementRouteImport
    }
    '/(app)/payment-management/account-information': {
      id: '/(app)/payment-management/account-information'
      path: '/account-information'
      fullPath: '/payment-management/account-information'
      preLoaderRoute: typeof appPaymentManagementAccountInformationRouteImport
      parentRoute: typeof appPaymentManagementRouteImport
    }
    '/(app)/payment-management/affiliate-log': {
      id: '/(app)/payment-management/affiliate-log'
      path: '/affiliate-log'
      fullPath: '/payment-management/affiliate-log'
      preLoaderRoute: typeof appPaymentManagementAffiliateLogRouteImport
      parentRoute: typeof appPaymentManagementRouteImport
    }
    '/(app)/payment-management/customer-payment-logs': {
      id: '/(app)/payment-management/customer-payment-logs'
      path: '/customer-payment-logs'
      fullPath: '/payment-management/customer-payment-logs'
      preLoaderRoute: typeof appPaymentManagementCustomerPaymentLogsRouteImport
      parentRoute: typeof appPaymentManagementRouteImport
    }
    '/(app)/payment-management/overview': {
      id: '/(app)/payment-management/overview'
      path: '/overview'
      fullPath: '/payment-management/overview'
      preLoaderRoute: typeof appPaymentManagementOverviewRouteImport
      parentRoute: typeof appPaymentManagementRouteImport
    }
    '/(app)/payment-management/store-payment-log': {
      id: '/(app)/payment-management/store-payment-log'
      path: '/store-payment-log'
      fullPath: '/payment-management/store-payment-log'
      preLoaderRoute: typeof appPaymentManagementStorePaymentLogRouteImport
      parentRoute: typeof appPaymentManagementRouteImport
    }
    '/(app)/points-management/points-balance-statement': {
      id: '/(app)/points-management/points-balance-statement'
      path: '/points-balance-statement'
      fullPath: '/points-management/points-balance-statement'
      preLoaderRoute: typeof appPointsManagementPointsBalanceStatementRouteImport
      parentRoute: typeof appPointsManagementRouteImport
    }
    '/(app)/points-management/points-configuration': {
      id: '/(app)/points-management/points-configuration'
      path: '/points-configuration'
      fullPath: '/points-management/points-configuration'
      preLoaderRoute: typeof appPointsManagementPointsConfigurationRouteImport
      parentRoute: typeof appPointsManagementRouteImport
    }
    '/(app)/points-management/points-transfer': {
      id: '/(app)/points-management/points-transfer'
      path: '/points-transfer'
      fullPath: '/points-management/points-transfer'
      preLoaderRoute: typeof appPointsManagementPointsTransferRouteImport
      parentRoute: typeof appPointsManagementRouteImport
    }
    '/(app)/points-management/system-transfer': {
      id: '/(app)/points-management/system-transfer'
      path: '/system-transfer'
      fullPath: '/points-management/system-transfer'
      preLoaderRoute: typeof appPointsManagementSystemTransferRouteImport
      parentRoute: typeof appPointsManagementRouteImport
    }
    '/(app)/promos-offer/advertisement': {
      id: '/(app)/promos-offer/advertisement'
      path: '/advertisement'
      fullPath: '/promos-offer/advertisement'
      preLoaderRoute: typeof appPromosOfferAdvertisementRouteImport
      parentRoute: typeof appPromosOfferRouteImport
    }
    '/(app)/promos-offer/promotional-banner': {
      id: '/(app)/promos-offer/promotional-banner'
      path: '/promotional-banner'
      fullPath: '/promos-offer/promotional-banner'
      preLoaderRoute: typeof appPromosOfferPromotionalBannerRouteImport
      parentRoute: typeof appPromosOfferRouteImport
    }
    '/(app)/recommendation-management/editors-pick': {
      id: '/(app)/recommendation-management/editors-pick'
      path: '/editors-pick'
      fullPath: '/recommendation-management/editors-pick'
      preLoaderRoute: typeof appRecommendationManagementEditorsPickRouteImport
      parentRoute: typeof appRecommendationManagementRouteImport
    }
    '/(app)/recommendation-management/main-page': {
      id: '/(app)/recommendation-management/main-page'
      path: '/main-page'
      fullPath: '/recommendation-management/main-page'
      preLoaderRoute: typeof appRecommendationManagementMainPageRouteImport
      parentRoute: typeof appRecommendationManagementRouteImport
    }
    '/(app)/store-information/basic-stores': {
      id: '/(app)/store-information/basic-stores'
      path: '/basic-stores'
      fullPath: '/store-information/basic-stores'
      preLoaderRoute: typeof appStoreInformationBasicStoresRouteImport
      parentRoute: typeof appStoreInformationRouteImport
    }
    '/(app)/store-information/premium-stores': {
      id: '/(app)/store-information/premium-stores'
      path: '/premium-stores'
      fullPath: '/store-information/premium-stores'
      preLoaderRoute: typeof appStoreInformationPremiumStoresRouteImport
      parentRoute: typeof appStoreInformationRouteImport
    }
    '/(app)/store-information/switch-store': {
      id: '/(app)/store-information/switch-store'
      path: '/switch-store'
      fullPath: '/store-information/switch-store'
      preLoaderRoute: typeof appStoreInformationSwitchStoreRouteImport
      parentRoute: typeof appStoreInformationRouteImport
    }
    '/(app)/users/admin': {
      id: '/(app)/users/admin'
      path: '/admin'
      fullPath: '/users/admin'
      preLoaderRoute: typeof appUsersAdminRouteImport
      parentRoute: typeof appUsersRouteImport
    }
    '/(app)/users/affiliates': {
      id: '/(app)/users/affiliates'
      path: '/affiliates'
      fullPath: '/users/affiliates'
      preLoaderRoute: typeof appUsersAffiliatesRouteImport
      parentRoute: typeof appUsersRouteImport
    }
    '/(app)/users/customers': {
      id: '/(app)/users/customers'
      path: '/customers'
      fullPath: '/users/customers'
      preLoaderRoute: typeof appUsersCustomersRouteImport
      parentRoute: typeof appUsersRouteImport
    }
    '/(app)/users/roles': {
      id: '/(app)/users/roles'
      path: '/roles'
      fullPath: '/users/roles'
      preLoaderRoute: typeof appUsersRolesRouteImport
      parentRoute: typeof appUsersRouteImport
    }
    '/(app)/users/store-owners': {
      id: '/(app)/users/store-owners'
      path: '/store-owners'
      fullPath: '/users/store-owners'
      preLoaderRoute: typeof appUsersStoreOwnersRouteImport
      parentRoute: typeof appUsersRouteImport
    }
    '/(app)/account/language': {
      id: '/(app)/account/language'
      path: '/language'
      fullPath: '/account/language'
      preLoaderRoute: typeof appAccountLanguageImport
      parentRoute: typeof appAccountRouteImport
    }
    '/(app)/dashboard/overview': {
      id: '/(app)/dashboard/overview'
      path: '/overview'
      fullPath: '/dashboard/overview'
      preLoaderRoute: typeof appDashboardOverviewImport
      parentRoute: typeof appDashboardRouteImport
    }
    '/(app)/dashboard/sales-performance': {
      id: '/(app)/dashboard/sales-performance'
      path: '/sales-performance'
      fullPath: '/dashboard/sales-performance'
      preLoaderRoute: typeof appDashboardSalesPerformanceImport
      parentRoute: typeof appDashboardRouteImport
    }
    '/(app)/promos-offer/offer': {
      id: '/(app)/promos-offer/offer'
      path: '/offer'
      fullPath: '/promos-offer/offer'
      preLoaderRoute: typeof appPromosOfferOfferImport
      parentRoute: typeof appPromosOfferRouteImport
    }
    '/(app)/account/': {
      id: '/(app)/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof appAccountIndexImport
      parentRoute: typeof appAccountRouteImport
    }
    '/(app)/configuration-management/': {
      id: '/(app)/configuration-management/'
      path: '/'
      fullPath: '/configuration-management/'
      preLoaderRoute: typeof appConfigurationManagementIndexImport
      parentRoute: typeof appConfigurationManagementRouteImport
    }
    '/(app)/dashboard/': {
      id: '/(app)/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof appDashboardIndexImport
      parentRoute: typeof appDashboardRouteImport
    }
    '/(app)/faq/': {
      id: '/(app)/faq/'
      path: '/'
      fullPath: '/faq/'
      preLoaderRoute: typeof appFaqIndexImport
      parentRoute: typeof appFaqRouteImport
    }
    '/(app)/logs-management/': {
      id: '/(app)/logs-management/'
      path: '/'
      fullPath: '/logs-management/'
      preLoaderRoute: typeof appLogsManagementIndexImport
      parentRoute: typeof appLogsManagementRouteImport
    }
    '/(app)/payment-management/': {
      id: '/(app)/payment-management/'
      path: '/'
      fullPath: '/payment-management/'
      preLoaderRoute: typeof appPaymentManagementIndexImport
      parentRoute: typeof appPaymentManagementRouteImport
    }
    '/(app)/points-management/': {
      id: '/(app)/points-management/'
      path: '/'
      fullPath: '/points-management/'
      preLoaderRoute: typeof appPointsManagementIndexImport
      parentRoute: typeof appPointsManagementRouteImport
    }
    '/(app)/promos-offer/': {
      id: '/(app)/promos-offer/'
      path: '/'
      fullPath: '/promos-offer/'
      preLoaderRoute: typeof appPromosOfferIndexImport
      parentRoute: typeof appPromosOfferRouteImport
    }
    '/(app)/recommendation-management/': {
      id: '/(app)/recommendation-management/'
      path: '/'
      fullPath: '/recommendation-management/'
      preLoaderRoute: typeof appRecommendationManagementIndexImport
      parentRoute: typeof appRecommendationManagementRouteImport
    }
    '/(app)/store-information/': {
      id: '/(app)/store-information/'
      path: '/'
      fullPath: '/store-information/'
      preLoaderRoute: typeof appStoreInformationIndexImport
      parentRoute: typeof appStoreInformationRouteImport
    }
    '/(app)/users/': {
      id: '/(app)/users/'
      path: '/'
      fullPath: '/users/'
      preLoaderRoute: typeof appUsersIndexImport
      parentRoute: typeof appUsersRouteImport
    }
    '/(app)/configuration-management/charges/$categoryId': {
      id: '/(app)/configuration-management/charges/$categoryId'
      path: '/$categoryId'
      fullPath: '/configuration-management/charges/$categoryId'
      preLoaderRoute: typeof appConfigurationManagementChargesCategoryIdRouteImport
      parentRoute: typeof appConfigurationManagementChargesRouteImport
    }
    '/(app)/configuration-management/commissions/$categoryId': {
      id: '/(app)/configuration-management/commissions/$categoryId'
      path: '/$categoryId'
      fullPath: '/configuration-management/commissions/$categoryId'
      preLoaderRoute: typeof appConfigurationManagementCommissionsCategoryIdRouteImport
      parentRoute: typeof appConfigurationManagementCommissionsRouteImport
    }
    '/(app)/configuration-management/discount-management/$discountCategory': {
      id: '/(app)/configuration-management/discount-management/$discountCategory'
      path: '/$discountCategory'
      fullPath: '/configuration-management/discount-management/$discountCategory'
      preLoaderRoute: typeof appConfigurationManagementDiscountManagementDiscountCategoryRouteImport
      parentRoute: typeof appConfigurationManagementDiscountManagementRouteImport
    }
    '/(app)/configuration-management/group-management/$sub-group': {
      id: '/(app)/configuration-management/group-management/$sub-group'
      path: '/$sub-group'
      fullPath: '/configuration-management/group-management/$sub-group'
      preLoaderRoute: typeof appConfigurationManagementGroupManagementSubGroupRouteImport
      parentRoute: typeof appConfigurationManagementGroupManagementRouteImport
    }
    '/(app)/logs-management/static-data-type/$staticDataTypeName': {
      id: '/(app)/logs-management/static-data-type/$staticDataTypeName'
      path: '/$staticDataTypeName'
      fullPath: '/logs-management/static-data-type/$staticDataTypeName'
      preLoaderRoute: typeof appLogsManagementStaticDataTypeStaticDataTypeNameRouteImport
      parentRoute: typeof appLogsManagementStaticDataTypeRouteImport
    }
    '/(app)/payment-management/store-payment-log/$storeId': {
      id: '/(app)/payment-management/store-payment-log/$storeId'
      path: '/$storeId'
      fullPath: '/payment-management/store-payment-log/$storeId'
      preLoaderRoute: typeof appPaymentManagementStorePaymentLogStoreIdRouteImport
      parentRoute: typeof appPaymentManagementStorePaymentLogRouteImport
    }
    '/(app)/recommendation-management/main-page/$store-list': {
      id: '/(app)/recommendation-management/main-page/$store-list'
      path: '/$store-list'
      fullPath: '/recommendation-management/main-page/$store-list'
      preLoaderRoute: typeof appRecommendationManagementMainPageStoreListRouteImport
      parentRoute: typeof appRecommendationManagementMainPageRouteImport
    }
    '/(app)/store-information/basic-stores/$manage-store': {
      id: '/(app)/store-information/basic-stores/$manage-store'
      path: '/$manage-store'
      fullPath: '/store-information/basic-stores/$manage-store'
      preLoaderRoute: typeof appStoreInformationBasicStoresManageStoreRouteImport
      parentRoute: typeof appStoreInformationBasicStoresRouteImport
    }
    '/(app)/store-information/basic-stores/add-store': {
      id: '/(app)/store-information/basic-stores/add-store'
      path: '/add-store'
      fullPath: '/store-information/basic-stores/add-store'
      preLoaderRoute: typeof appStoreInformationBasicStoresAddStoreRouteImport
      parentRoute: typeof appStoreInformationBasicStoresRouteImport
    }
    '/(app)/store-information/basic-stores/switch-store': {
      id: '/(app)/store-information/basic-stores/switch-store'
      path: '/switch-store'
      fullPath: '/store-information/basic-stores/switch-store'
      preLoaderRoute: typeof appStoreInformationBasicStoresSwitchStoreRouteImport
      parentRoute: typeof appStoreInformationBasicStoresRouteImport
    }
    '/(app)/store-information/premium-stores/$manage-premium-store': {
      id: '/(app)/store-information/premium-stores/$manage-premium-store'
      path: '/$manage-premium-store'
      fullPath: '/store-information/premium-stores/$manage-premium-store'
      preLoaderRoute: typeof appStoreInformationPremiumStoresManagePremiumStoreRouteImport
      parentRoute: typeof appStoreInformationPremiumStoresRouteImport
    }
    '/(app)/store-information/premium-stores/add-premium-store': {
      id: '/(app)/store-information/premium-stores/add-premium-store'
      path: '/add-premium-store'
      fullPath: '/store-information/premium-stores/add-premium-store'
      preLoaderRoute: typeof appStoreInformationPremiumStoresAddPremiumStoreRouteImport
      parentRoute: typeof appStoreInformationPremiumStoresRouteImport
    }
    '/(app)/store-information/premium-stores/plan-management': {
      id: '/(app)/store-information/premium-stores/plan-management'
      path: '/plan-management'
      fullPath: '/store-information/premium-stores/plan-management'
      preLoaderRoute: typeof appStoreInformationPremiumStoresPlanManagementRouteImport
      parentRoute: typeof appStoreInformationPremiumStoresRouteImport
    }
    '/(app)/payment-management/admin-payment-setup/add-bank-information': {
      id: '/(app)/payment-management/admin-payment-setup/add-bank-information'
      path: '/admin-payment-setup/add-bank-information'
      fullPath: '/payment-management/admin-payment-setup/add-bank-information'
      preLoaderRoute: typeof appPaymentManagementAdminPaymentSetupAddBankInformationImport
      parentRoute: typeof appPaymentManagementRouteImport
    }
    '/(app)/payment-management/affiliate-log/$monthly-report': {
      id: '/(app)/payment-management/affiliate-log/$monthly-report'
      path: '/$monthly-report'
      fullPath: '/payment-management/affiliate-log/$monthly-report'
      preLoaderRoute: typeof appPaymentManagementAffiliateLogMonthlyReportImport
      parentRoute: typeof appPaymentManagementAffiliateLogRouteImport
    }
    '/(app)/users/affiliates/$affiliateId': {
      id: '/(app)/users/affiliates/$affiliateId'
      path: '/$affiliateId'
      fullPath: '/users/affiliates/$affiliateId'
      preLoaderRoute: typeof appUsersAffiliatesAffiliateIdImport
      parentRoute: typeof appUsersAffiliatesRouteImport
    }
    '/(app)/users/customers/$customerId': {
      id: '/(app)/users/customers/$customerId'
      path: '/$customerId'
      fullPath: '/users/customers/$customerId'
      preLoaderRoute: typeof appUsersCustomersCustomerIdImport
      parentRoute: typeof appUsersCustomersRouteImport
    }
    '/(app)/account/profile/': {
      id: '/(app)/account/profile/'
      path: '/'
      fullPath: '/account/profile/'
      preLoaderRoute: typeof appAccountProfileIndexImport
      parentRoute: typeof appAccountProfileRouteImport
    }
    '/(app)/configuration-management/charges/': {
      id: '/(app)/configuration-management/charges/'
      path: '/'
      fullPath: '/configuration-management/charges/'
      preLoaderRoute: typeof appConfigurationManagementChargesIndexImport
      parentRoute: typeof appConfigurationManagementChargesRouteImport
    }
    '/(app)/configuration-management/commissions/': {
      id: '/(app)/configuration-management/commissions/'
      path: '/'
      fullPath: '/configuration-management/commissions/'
      preLoaderRoute: typeof appConfigurationManagementCommissionsIndexImport
      parentRoute: typeof appConfigurationManagementCommissionsRouteImport
    }
    '/(app)/configuration-management/discount-management/': {
      id: '/(app)/configuration-management/discount-management/'
      path: '/'
      fullPath: '/configuration-management/discount-management/'
      preLoaderRoute: typeof appConfigurationManagementDiscountManagementIndexImport
      parentRoute: typeof appConfigurationManagementDiscountManagementRouteImport
    }
    '/(app)/configuration-management/group-management/': {
      id: '/(app)/configuration-management/group-management/'
      path: '/'
      fullPath: '/configuration-management/group-management/'
      preLoaderRoute: typeof appConfigurationManagementGroupManagementIndexImport
      parentRoute: typeof appConfigurationManagementGroupManagementRouteImport
    }
    '/(app)/configuration-management/hoslog-plans/': {
      id: '/(app)/configuration-management/hoslog-plans/'
      path: '/'
      fullPath: '/configuration-management/hoslog-plans/'
      preLoaderRoute: typeof appConfigurationManagementHoslogPlansIndexImport
      parentRoute: typeof appConfigurationManagementHoslogPlansRouteImport
    }
    '/(app)/configuration-management/location/': {
      id: '/(app)/configuration-management/location/'
      path: '/'
      fullPath: '/configuration-management/location/'
      preLoaderRoute: typeof appConfigurationManagementLocationIndexImport
      parentRoute: typeof appConfigurationManagementLocationRouteImport
    }
    '/(app)/configuration-management/withdrawals-setup/': {
      id: '/(app)/configuration-management/withdrawals-setup/'
      path: '/'
      fullPath: '/configuration-management/withdrawals-setup/'
      preLoaderRoute: typeof appConfigurationManagementWithdrawalsSetupIndexImport
      parentRoute: typeof appConfigurationManagementWithdrawalsSetupRouteImport
    }
    '/(app)/dashboard/conversion-analytics/': {
      id: '/(app)/dashboard/conversion-analytics/'
      path: '/'
      fullPath: '/dashboard/conversion-analytics/'
      preLoaderRoute: typeof appDashboardConversionAnalyticsIndexImport
      parentRoute: typeof appDashboardConversionAnalyticsRouteImport
    }
    '/(app)/dashboard/referral-reports/': {
      id: '/(app)/dashboard/referral-reports/'
      path: '/'
      fullPath: '/dashboard/referral-reports/'
      preLoaderRoute: typeof appDashboardReferralReportsIndexImport
      parentRoute: typeof appDashboardReferralReportsRouteImport
    }
    '/(app)/dashboard/reservation-ledger/': {
      id: '/(app)/dashboard/reservation-ledger/'
      path: '/'
      fullPath: '/dashboard/reservation-ledger/'
      preLoaderRoute: typeof appDashboardReservationLedgerIndexImport
      parentRoute: typeof appDashboardReservationLedgerRouteImport
    }
    '/(app)/faq/complaints/': {
      id: '/(app)/faq/complaints/'
      path: '/'
      fullPath: '/faq/complaints/'
      preLoaderRoute: typeof appFaqComplaintsIndexImport
      parentRoute: typeof appFaqComplaintsRouteImport
    }
    '/(app)/faq/inquiry/': {
      id: '/(app)/faq/inquiry/'
      path: '/'
      fullPath: '/faq/inquiry/'
      preLoaderRoute: typeof appFaqInquiryIndexImport
      parentRoute: typeof appFaqInquiryRouteImport
    }
    '/(app)/faq/review-ratings/': {
      id: '/(app)/faq/review-ratings/'
      path: '/'
      fullPath: '/faq/review-ratings/'
      preLoaderRoute: typeof appFaqReviewRatingsIndexImport
      parentRoute: typeof appFaqReviewRatingsRouteImport
    }
    '/(app)/logs-management/access-logs/': {
      id: '/(app)/logs-management/access-logs/'
      path: '/access-logs'
      fullPath: '/logs-management/access-logs'
      preLoaderRoute: typeof appLogsManagementAccessLogsIndexImport
      parentRoute: typeof appLogsManagementRouteImport
    }
    '/(app)/logs-management/api-logs/': {
      id: '/(app)/logs-management/api-logs/'
      path: '/api-logs'
      fullPath: '/logs-management/api-logs'
      preLoaderRoute: typeof appLogsManagementApiLogsIndexImport
      parentRoute: typeof appLogsManagementRouteImport
    }
    '/(app)/logs-management/email-logs/': {
      id: '/(app)/logs-management/email-logs/'
      path: '/'
      fullPath: '/logs-management/email-logs/'
      preLoaderRoute: typeof appLogsManagementEmailLogsIndexImport
      parentRoute: typeof appLogsManagementEmailLogsRouteImport
    }
    '/(app)/logs-management/sms-logs/': {
      id: '/(app)/logs-management/sms-logs/'
      path: '/'
      fullPath: '/logs-management/sms-logs/'
      preLoaderRoute: typeof appLogsManagementSmsLogsIndexImport
      parentRoute: typeof appLogsManagementSmsLogsRouteImport
    }
    '/(app)/logs-management/static-data-type/': {
      id: '/(app)/logs-management/static-data-type/'
      path: '/'
      fullPath: '/logs-management/static-data-type/'
      preLoaderRoute: typeof appLogsManagementStaticDataTypeIndexImport
      parentRoute: typeof appLogsManagementStaticDataTypeRouteImport
    }
    '/(app)/payment-management/account-information/': {
      id: '/(app)/payment-management/account-information/'
      path: '/'
      fullPath: '/payment-management/account-information/'
      preLoaderRoute: typeof appPaymentManagementAccountInformationIndexImport
      parentRoute: typeof appPaymentManagementAccountInformationRouteImport
    }
    '/(app)/payment-management/admin-payment-setup/': {
      id: '/(app)/payment-management/admin-payment-setup/'
      path: '/admin-payment-setup'
      fullPath: '/payment-management/admin-payment-setup'
      preLoaderRoute: typeof appPaymentManagementAdminPaymentSetupIndexImport
      parentRoute: typeof appPaymentManagementRouteImport
    }
    '/(app)/payment-management/affiliate-log/': {
      id: '/(app)/payment-management/affiliate-log/'
      path: '/'
      fullPath: '/payment-management/affiliate-log/'
      preLoaderRoute: typeof appPaymentManagementAffiliateLogIndexImport
      parentRoute: typeof appPaymentManagementAffiliateLogRouteImport
    }
    '/(app)/payment-management/customer-payment-logs/': {
      id: '/(app)/payment-management/customer-payment-logs/'
      path: '/'
      fullPath: '/payment-management/customer-payment-logs/'
      preLoaderRoute: typeof appPaymentManagementCustomerPaymentLogsIndexImport
      parentRoute: typeof appPaymentManagementCustomerPaymentLogsRouteImport
    }
    '/(app)/payment-management/overview/': {
      id: '/(app)/payment-management/overview/'
      path: '/'
      fullPath: '/payment-management/overview/'
      preLoaderRoute: typeof appPaymentManagementOverviewIndexImport
      parentRoute: typeof appPaymentManagementOverviewRouteImport
    }
    '/(app)/payment-management/store-payment-log/': {
      id: '/(app)/payment-management/store-payment-log/'
      path: '/'
      fullPath: '/payment-management/store-payment-log/'
      preLoaderRoute: typeof appPaymentManagementStorePaymentLogIndexImport
      parentRoute: typeof appPaymentManagementStorePaymentLogRouteImport
    }
    '/(app)/points-management/points-balance-statement/': {
      id: '/(app)/points-management/points-balance-statement/'
      path: '/'
      fullPath: '/points-management/points-balance-statement/'
      preLoaderRoute: typeof appPointsManagementPointsBalanceStatementIndexImport
      parentRoute: typeof appPointsManagementPointsBalanceStatementRouteImport
    }
    '/(app)/points-management/points-configuration/': {
      id: '/(app)/points-management/points-configuration/'
      path: '/'
      fullPath: '/points-management/points-configuration/'
      preLoaderRoute: typeof appPointsManagementPointsConfigurationIndexImport
      parentRoute: typeof appPointsManagementPointsConfigurationRouteImport
    }
    '/(app)/points-management/points-request/': {
      id: '/(app)/points-management/points-request/'
      path: '/points-request'
      fullPath: '/points-management/points-request'
      preLoaderRoute: typeof appPointsManagementPointsRequestIndexImport
      parentRoute: typeof appPointsManagementRouteImport
    }
    '/(app)/points-management/points-transfer/': {
      id: '/(app)/points-management/points-transfer/'
      path: '/'
      fullPath: '/points-management/points-transfer/'
      preLoaderRoute: typeof appPointsManagementPointsTransferIndexImport
      parentRoute: typeof appPointsManagementPointsTransferRouteImport
    }
    '/(app)/points-management/system-transfer/': {
      id: '/(app)/points-management/system-transfer/'
      path: '/'
      fullPath: '/points-management/system-transfer/'
      preLoaderRoute: typeof appPointsManagementSystemTransferIndexImport
      parentRoute: typeof appPointsManagementSystemTransferRouteImport
    }
    '/(app)/promos-offer/advertisement/': {
      id: '/(app)/promos-offer/advertisement/'
      path: '/'
      fullPath: '/promos-offer/advertisement/'
      preLoaderRoute: typeof appPromosOfferAdvertisementIndexImport
      parentRoute: typeof appPromosOfferAdvertisementRouteImport
    }
    '/(app)/promos-offer/promotional-banner/': {
      id: '/(app)/promos-offer/promotional-banner/'
      path: '/'
      fullPath: '/promos-offer/promotional-banner/'
      preLoaderRoute: typeof appPromosOfferPromotionalBannerIndexImport
      parentRoute: typeof appPromosOfferPromotionalBannerRouteImport
    }
    '/(app)/recommendation-management/editors-pick/': {
      id: '/(app)/recommendation-management/editors-pick/'
      path: '/'
      fullPath: '/recommendation-management/editors-pick/'
      preLoaderRoute: typeof appRecommendationManagementEditorsPickIndexImport
      parentRoute: typeof appRecommendationManagementEditorsPickRouteImport
    }
    '/(app)/recommendation-management/main-page/': {
      id: '/(app)/recommendation-management/main-page/'
      path: '/'
      fullPath: '/recommendation-management/main-page/'
      preLoaderRoute: typeof appRecommendationManagementMainPageIndexImport
      parentRoute: typeof appRecommendationManagementMainPageRouteImport
    }
    '/(app)/store-information/basic-stores/': {
      id: '/(app)/store-information/basic-stores/'
      path: '/'
      fullPath: '/store-information/basic-stores/'
      preLoaderRoute: typeof appStoreInformationBasicStoresIndexImport
      parentRoute: typeof appStoreInformationBasicStoresRouteImport
    }
    '/(app)/store-information/premium-stores/': {
      id: '/(app)/store-information/premium-stores/'
      path: '/'
      fullPath: '/store-information/premium-stores/'
      preLoaderRoute: typeof appStoreInformationPremiumStoresIndexImport
      parentRoute: typeof appStoreInformationPremiumStoresRouteImport
    }
    '/(app)/users/admin/': {
      id: '/(app)/users/admin/'
      path: '/'
      fullPath: '/users/admin/'
      preLoaderRoute: typeof appUsersAdminIndexImport
      parentRoute: typeof appUsersAdminRouteImport
    }
    '/(app)/users/affiliates/': {
      id: '/(app)/users/affiliates/'
      path: '/'
      fullPath: '/users/affiliates/'
      preLoaderRoute: typeof appUsersAffiliatesIndexImport
      parentRoute: typeof appUsersAffiliatesRouteImport
    }
    '/(app)/users/customers/': {
      id: '/(app)/users/customers/'
      path: '/'
      fullPath: '/users/customers/'
      preLoaderRoute: typeof appUsersCustomersIndexImport
      parentRoute: typeof appUsersCustomersRouteImport
    }
    '/(app)/users/roles/': {
      id: '/(app)/users/roles/'
      path: '/'
      fullPath: '/users/roles/'
      preLoaderRoute: typeof appUsersRolesIndexImport
      parentRoute: typeof appUsersRolesRouteImport
    }
    '/(app)/users/store-owners/': {
      id: '/(app)/users/store-owners/'
      path: '/'
      fullPath: '/users/store-owners/'
      preLoaderRoute: typeof appUsersStoreOwnersIndexImport
      parentRoute: typeof appUsersStoreOwnersRouteImport
    }
    '/(app)/configuration-management/charges/$categoryId/slabs': {
      id: '/(app)/configuration-management/charges/$categoryId/slabs'
      path: '/slabs'
      fullPath: '/configuration-management/charges/$categoryId/slabs'
      preLoaderRoute: typeof appConfigurationManagementChargesCategoryIdSlabsRouteImport
      parentRoute: typeof appConfigurationManagementChargesCategoryIdRouteImport
    }
    '/(app)/points-management/points-configuration/customer/$programId': {
      id: '/(app)/points-management/points-configuration/customer/$programId'
      path: '/customer/$programId'
      fullPath: '/points-management/points-configuration/customer/$programId'
      preLoaderRoute: typeof appPointsManagementPointsConfigurationCustomerProgramIdRouteImport
      parentRoute: typeof appPointsManagementPointsConfigurationRouteImport
    }
    '/(app)/recommendation-management/main-page/$store-list/$host-list': {
      id: '/(app)/recommendation-management/main-page/$store-list/$host-list'
      path: '/$host-list'
      fullPath: '/recommendation-management/main-page/$store-list/$host-list'
      preLoaderRoute: typeof appRecommendationManagementMainPageStoreListHostListRouteImport
      parentRoute: typeof appRecommendationManagementMainPageStoreListRouteImport
    }
    '/(app)/store-information/basic-stores/host-management/$clubid': {
      id: '/(app)/store-information/basic-stores/host-management/$clubid'
      path: '/host-management/$clubid'
      fullPath: '/store-information/basic-stores/host-management/$clubid'
      preLoaderRoute: typeof appStoreInformationBasicStoresHostManagementClubidRouteImport
      parentRoute: typeof appStoreInformationBasicStoresRouteImport
    }
    '/(app)/store-information/premium-stores/gallery/$store-gallery': {
      id: '/(app)/store-information/premium-stores/gallery/$store-gallery'
      path: '/gallery/$store-gallery'
      fullPath: '/store-information/premium-stores/gallery/$store-gallery'
      preLoaderRoute: typeof appStoreInformationPremiumStoresGalleryStoreGalleryRouteImport
      parentRoute: typeof appStoreInformationPremiumStoresRouteImport
    }
    '/(app)/store-information/premium-stores/host-management/$clubid': {
      id: '/(app)/store-information/premium-stores/host-management/$clubid'
      path: '/host-management/$clubid'
      fullPath: '/store-information/premium-stores/host-management/$clubid'
      preLoaderRoute: typeof appStoreInformationPremiumStoresHostManagementClubidRouteImport
      parentRoute: typeof appStoreInformationPremiumStoresRouteImport
    }
    '/(app)/store-information/premium-stores/host-management/gallery': {
      id: '/(app)/store-information/premium-stores/host-management/gallery'
      path: '/host-management/gallery'
      fullPath: '/store-information/premium-stores/host-management/gallery'
      preLoaderRoute: typeof appStoreInformationPremiumStoresHostManagementGalleryRouteImport
      parentRoute: typeof appStoreInformationPremiumStoresRouteImport
    }
    '/(app)/store-information/premium-stores/plan-management/$clubid': {
      id: '/(app)/store-information/premium-stores/plan-management/$clubid'
      path: '/$clubid'
      fullPath: '/store-information/premium-stores/plan-management/$clubid'
      preLoaderRoute: typeof appStoreInformationPremiumStoresPlanManagementClubidRouteImport
      parentRoute: typeof appStoreInformationPremiumStoresPlanManagementRouteImport
    }
    '/(app)/configuration-management/group-management/$sub-group/$club-gallery': {
      id: '/(app)/configuration-management/group-management/$sub-group/$club-gallery'
      path: '/$club-gallery'
      fullPath: '/configuration-management/group-management/$sub-group/$club-gallery'
      preLoaderRoute: typeof appConfigurationManagementGroupManagementSubGroupClubGalleryImport
      parentRoute: typeof appConfigurationManagementGroupManagementSubGroupRouteImport
    }
    '/(app)/users/roles/privilege/$roleId': {
      id: '/(app)/users/roles/privilege/$roleId'
      path: '/privilege/$roleId'
      fullPath: '/users/roles/privilege/$roleId'
      preLoaderRoute: typeof appUsersRolesPrivilegeRoleIdImport
      parentRoute: typeof appUsersRolesRouteImport
    }
    '/(app)/configuration-management/charges/$categoryId/': {
      id: '/(app)/configuration-management/charges/$categoryId/'
      path: '/'
      fullPath: '/configuration-management/charges/$categoryId/'
      preLoaderRoute: typeof appConfigurationManagementChargesCategoryIdIndexImport
      parentRoute: typeof appConfigurationManagementChargesCategoryIdRouteImport
    }
    '/(app)/configuration-management/commissions/$categoryId/': {
      id: '/(app)/configuration-management/commissions/$categoryId/'
      path: '/'
      fullPath: '/configuration-management/commissions/$categoryId/'
      preLoaderRoute: typeof appConfigurationManagementCommissionsCategoryIdIndexImport
      parentRoute: typeof appConfigurationManagementCommissionsCategoryIdRouteImport
    }
    '/(app)/configuration-management/discount-management/$discountCategory/': {
      id: '/(app)/configuration-management/discount-management/$discountCategory/'
      path: '/'
      fullPath: '/configuration-management/discount-management/$discountCategory/'
      preLoaderRoute: typeof appConfigurationManagementDiscountManagementDiscountCategoryIndexImport
      parentRoute: typeof appConfigurationManagementDiscountManagementDiscountCategoryRouteImport
    }
    '/(app)/configuration-management/group-management/$sub-group/': {
      id: '/(app)/configuration-management/group-management/$sub-group/'
      path: '/'
      fullPath: '/configuration-management/group-management/$sub-group/'
      preLoaderRoute: typeof appConfigurationManagementGroupManagementSubGroupIndexImport
      parentRoute: typeof appConfigurationManagementGroupManagementSubGroupRouteImport
    }
    '/(app)/logs-management/static-data-type/$staticDataTypeName/': {
      id: '/(app)/logs-management/static-data-type/$staticDataTypeName/'
      path: '/'
      fullPath: '/logs-management/static-data-type/$staticDataTypeName/'
      preLoaderRoute: typeof appLogsManagementStaticDataTypeStaticDataTypeNameIndexImport
      parentRoute: typeof appLogsManagementStaticDataTypeStaticDataTypeNameRouteImport
    }
    '/(app)/payment-management/store-payment-log/$storeId/': {
      id: '/(app)/payment-management/store-payment-log/$storeId/'
      path: '/'
      fullPath: '/payment-management/store-payment-log/$storeId/'
      preLoaderRoute: typeof appPaymentManagementStorePaymentLogStoreIdIndexImport
      parentRoute: typeof appPaymentManagementStorePaymentLogStoreIdRouteImport
    }
    '/(app)/recommendation-management/main-page/$store-list/': {
      id: '/(app)/recommendation-management/main-page/$store-list/'
      path: '/'
      fullPath: '/recommendation-management/main-page/$store-list/'
      preLoaderRoute: typeof appRecommendationManagementMainPageStoreListIndexImport
      parentRoute: typeof appRecommendationManagementMainPageStoreListRouteImport
    }
    '/(app)/store-information/basic-stores/$manage-store/': {
      id: '/(app)/store-information/basic-stores/$manage-store/'
      path: '/'
      fullPath: '/store-information/basic-stores/$manage-store/'
      preLoaderRoute: typeof appStoreInformationBasicStoresManageStoreIndexImport
      parentRoute: typeof appStoreInformationBasicStoresManageStoreRouteImport
    }
    '/(app)/store-information/basic-stores/add-store/': {
      id: '/(app)/store-information/basic-stores/add-store/'
      path: '/'
      fullPath: '/store-information/basic-stores/add-store/'
      preLoaderRoute: typeof appStoreInformationBasicStoresAddStoreIndexImport
      parentRoute: typeof appStoreInformationBasicStoresAddStoreRouteImport
    }
    '/(app)/store-information/premium-stores/$manage-premium-store/': {
      id: '/(app)/store-information/premium-stores/$manage-premium-store/'
      path: '/'
      fullPath: '/store-information/premium-stores/$manage-premium-store/'
      preLoaderRoute: typeof appStoreInformationPremiumStoresManagePremiumStoreIndexImport
      parentRoute: typeof appStoreInformationPremiumStoresManagePremiumStoreRouteImport
    }
    '/(app)/store-information/premium-stores/add-premium-store/': {
      id: '/(app)/store-information/premium-stores/add-premium-store/'
      path: '/'
      fullPath: '/store-information/premium-stores/add-premium-store/'
      preLoaderRoute: typeof appStoreInformationPremiumStoresAddPremiumStoreIndexImport
      parentRoute: typeof appStoreInformationPremiumStoresAddPremiumStoreRouteImport
    }
    '/(app)/store-information/basic-stores/host-management/$clubid/$manage-host': {
      id: '/(app)/store-information/basic-stores/host-management/$clubid/$manage-host'
      path: '/$manage-host'
      fullPath: '/store-information/basic-stores/host-management/$clubid/$manage-host'
      preLoaderRoute: typeof appStoreInformationBasicStoresHostManagementClubidManageHostRouteImport
      parentRoute: typeof appStoreInformationBasicStoresHostManagementClubidRouteImport
    }
    '/(app)/store-information/basic-stores/host-management/$clubid/add-host': {
      id: '/(app)/store-information/basic-stores/host-management/$clubid/add-host'
      path: '/add-host'
      fullPath: '/store-information/basic-stores/host-management/$clubid/add-host'
      preLoaderRoute: typeof appStoreInformationBasicStoresHostManagementClubidAddHostRouteImport
      parentRoute: typeof appStoreInformationBasicStoresHostManagementClubidRouteImport
    }
    '/(app)/store-information/basic-stores/host-management/$clubid/gallery': {
      id: '/(app)/store-information/basic-stores/host-management/$clubid/gallery'
      path: '/gallery'
      fullPath: '/store-information/basic-stores/host-management/$clubid/gallery'
      preLoaderRoute: typeof appStoreInformationBasicStoresHostManagementClubidGalleryRouteImport
      parentRoute: typeof appStoreInformationBasicStoresHostManagementClubidRouteImport
    }
    '/(app)/store-information/premium-stores/host-management/$clubid/$manage-host': {
      id: '/(app)/store-information/premium-stores/host-management/$clubid/$manage-host'
      path: '/$manage-host'
      fullPath: '/store-information/premium-stores/host-management/$clubid/$manage-host'
      preLoaderRoute: typeof appStoreInformationPremiumStoresHostManagementClubidManageHostRouteImport
      parentRoute: typeof appStoreInformationPremiumStoresHostManagementClubidRouteImport
    }
    '/(app)/store-information/premium-stores/host-management/$clubid/add-host': {
      id: '/(app)/store-information/premium-stores/host-management/$clubid/add-host'
      path: '/add-host'
      fullPath: '/store-information/premium-stores/host-management/$clubid/add-host'
      preLoaderRoute: typeof appStoreInformationPremiumStoresHostManagementClubidAddHostRouteImport
      parentRoute: typeof appStoreInformationPremiumStoresHostManagementClubidRouteImport
    }
    '/(app)/store-information/premium-stores/host-management/$clubid/gallery': {
      id: '/(app)/store-information/premium-stores/host-management/$clubid/gallery'
      path: '/gallery'
      fullPath: '/store-information/premium-stores/host-management/$clubid/gallery'
      preLoaderRoute: typeof appStoreInformationPremiumStoresHostManagementClubidGalleryRouteImport
      parentRoute: typeof appStoreInformationPremiumStoresHostManagementClubidRouteImport
    }
    '/(app)/store-information/premium-stores/host-management/gallery/$host-gallery': {
      id: '/(app)/store-information/premium-stores/host-management/gallery/$host-gallery'
      path: '/$host-gallery'
      fullPath: '/store-information/premium-stores/host-management/gallery/$host-gallery'
      preLoaderRoute: typeof appStoreInformationPremiumStoresHostManagementGalleryHostGalleryRouteImport
      parentRoute: typeof appStoreInformationPremiumStoresHostManagementGalleryRouteImport
    }
    '/(app)/points-management/points-configuration/affiliate/$pointCategoryId/slabs': {
      id: '/(app)/points-management/points-configuration/affiliate/$pointCategoryId/slabs'
      path: '/affiliate/$pointCategoryId/slabs'
      fullPath: '/points-management/points-configuration/affiliate/$pointCategoryId/slabs'
      preLoaderRoute: typeof appPointsManagementPointsConfigurationAffiliatePointCategoryIdSlabsImport
      parentRoute: typeof appPointsManagementPointsConfigurationRouteImport
    }
    '/(app)/configuration-management/charges/$categoryId/slabs/': {
      id: '/(app)/configuration-management/charges/$categoryId/slabs/'
      path: '/'
      fullPath: '/configuration-management/charges/$categoryId/slabs/'
      preLoaderRoute: typeof appConfigurationManagementChargesCategoryIdSlabsIndexImport
      parentRoute: typeof appConfigurationManagementChargesCategoryIdSlabsRouteImport
    }
    '/(app)/dashboard/referral-reports/$reportType/$referrerId/': {
      id: '/(app)/dashboard/referral-reports/$reportType/$referrerId/'
      path: '/$reportType/$referrerId'
      fullPath: '/dashboard/referral-reports/$reportType/$referrerId'
      preLoaderRoute: typeof appDashboardReferralReportsReportTypeReferrerIdIndexImport
      parentRoute: typeof appDashboardReferralReportsRouteImport
    }
    '/(app)/points-management/points-configuration/customer/$programId/': {
      id: '/(app)/points-management/points-configuration/customer/$programId/'
      path: '/'
      fullPath: '/points-management/points-configuration/customer/$programId/'
      preLoaderRoute: typeof appPointsManagementPointsConfigurationCustomerProgramIdIndexImport
      parentRoute: typeof appPointsManagementPointsConfigurationCustomerProgramIdRouteImport
    }
    '/(app)/recommendation-management/main-page/$store-list/$host-list/': {
      id: '/(app)/recommendation-management/main-page/$store-list/$host-list/'
      path: '/'
      fullPath: '/recommendation-management/main-page/$store-list/$host-list/'
      preLoaderRoute: typeof appRecommendationManagementMainPageStoreListHostListIndexImport
      parentRoute: typeof appRecommendationManagementMainPageStoreListHostListRouteImport
    }
    '/(app)/store-information/basic-stores/host-management/$clubid/': {
      id: '/(app)/store-information/basic-stores/host-management/$clubid/'
      path: '/'
      fullPath: '/store-information/basic-stores/host-management/$clubid/'
      preLoaderRoute: typeof appStoreInformationBasicStoresHostManagementClubidIndexImport
      parentRoute: typeof appStoreInformationBasicStoresHostManagementClubidRouteImport
    }
    '/(app)/store-information/basic-stores/switch-store/$id/': {
      id: '/(app)/store-information/basic-stores/switch-store/$id/'
      path: '/$id'
      fullPath: '/store-information/basic-stores/switch-store/$id'
      preLoaderRoute: typeof appStoreInformationBasicStoresSwitchStoreIdIndexImport
      parentRoute: typeof appStoreInformationBasicStoresSwitchStoreRouteImport
    }
    '/(app)/store-information/premium-stores/gallery/$store-gallery/': {
      id: '/(app)/store-information/premium-stores/gallery/$store-gallery/'
      path: '/'
      fullPath: '/store-information/premium-stores/gallery/$store-gallery/'
      preLoaderRoute: typeof appStoreInformationPremiumStoresGalleryStoreGalleryIndexImport
      parentRoute: typeof appStoreInformationPremiumStoresGalleryStoreGalleryRouteImport
    }
    '/(app)/store-information/premium-stores/host-management/$clubid/': {
      id: '/(app)/store-information/premium-stores/host-management/$clubid/'
      path: '/'
      fullPath: '/store-information/premium-stores/host-management/$clubid/'
      preLoaderRoute: typeof appStoreInformationPremiumStoresHostManagementClubidIndexImport
      parentRoute: typeof appStoreInformationPremiumStoresHostManagementClubidRouteImport
    }
    '/(app)/store-information/premium-stores/plan-management/$clubid/': {
      id: '/(app)/store-information/premium-stores/plan-management/$clubid/'
      path: '/'
      fullPath: '/store-information/premium-stores/plan-management/$clubid/'
      preLoaderRoute: typeof appStoreInformationPremiumStoresPlanManagementClubidIndexImport
      parentRoute: typeof appStoreInformationPremiumStoresPlanManagementClubidRouteImport
    }
    '/(app)/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery': {
      id: '/(app)/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery'
      path: '/$host-gallery'
      fullPath: '/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery'
      preLoaderRoute: typeof appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryRouteImport
      parentRoute: typeof appStoreInformationBasicStoresHostManagementClubidGalleryRouteImport
    }
    '/(app)/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery': {
      id: '/(app)/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery'
      path: '/$host-gallery'
      fullPath: '/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery'
      preLoaderRoute: typeof appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryRouteImport
      parentRoute: typeof appStoreInformationPremiumStoresHostManagementClubidGalleryRouteImport
    }
    '/(app)/store-information/basic-stores/host-management/$clubid/$manage-host/': {
      id: '/(app)/store-information/basic-stores/host-management/$clubid/$manage-host/'
      path: '/'
      fullPath: '/store-information/basic-stores/host-management/$clubid/$manage-host/'
      preLoaderRoute: typeof appStoreInformationBasicStoresHostManagementClubidManageHostIndexImport
      parentRoute: typeof appStoreInformationBasicStoresHostManagementClubidManageHostRouteImport
    }
    '/(app)/store-information/basic-stores/host-management/$clubid/add-host/': {
      id: '/(app)/store-information/basic-stores/host-management/$clubid/add-host/'
      path: '/'
      fullPath: '/store-information/basic-stores/host-management/$clubid/add-host/'
      preLoaderRoute: typeof appStoreInformationBasicStoresHostManagementClubidAddHostIndexImport
      parentRoute: typeof appStoreInformationBasicStoresHostManagementClubidAddHostRouteImport
    }
    '/(app)/store-information/premium-stores/host-management/$clubid/$manage-host/': {
      id: '/(app)/store-information/premium-stores/host-management/$clubid/$manage-host/'
      path: '/'
      fullPath: '/store-information/premium-stores/host-management/$clubid/$manage-host/'
      preLoaderRoute: typeof appStoreInformationPremiumStoresHostManagementClubidManageHostIndexImport
      parentRoute: typeof appStoreInformationPremiumStoresHostManagementClubidManageHostRouteImport
    }
    '/(app)/store-information/premium-stores/host-management/$clubid/add-host/': {
      id: '/(app)/store-information/premium-stores/host-management/$clubid/add-host/'
      path: '/'
      fullPath: '/store-information/premium-stores/host-management/$clubid/add-host/'
      preLoaderRoute: typeof appStoreInformationPremiumStoresHostManagementClubidAddHostIndexImport
      parentRoute: typeof appStoreInformationPremiumStoresHostManagementClubidAddHostRouteImport
    }
    '/(app)/store-information/premium-stores/host-management/gallery/$host-gallery/': {
      id: '/(app)/store-information/premium-stores/host-management/gallery/$host-gallery/'
      path: '/'
      fullPath: '/store-information/premium-stores/host-management/gallery/$host-gallery/'
      preLoaderRoute: typeof appStoreInformationPremiumStoresHostManagementGalleryHostGalleryIndexImport
      parentRoute: typeof appStoreInformationPremiumStoresHostManagementGalleryHostGalleryRouteImport
    }
    '/(app)/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery/': {
      id: '/(app)/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery/'
      path: '/'
      fullPath: '/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery/'
      preLoaderRoute: typeof appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryIndexImport
      parentRoute: typeof appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryRouteImport
    }
    '/(app)/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery/': {
      id: '/(app)/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery/'
      path: '/'
      fullPath: '/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery/'
      preLoaderRoute: typeof appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryIndexImport
      parentRoute: typeof appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryRouteImport
    }
  }
}

// Create and export the route tree

interface appAccountProfileRouteRouteChildren {
  appAccountProfileIndexRoute: typeof appAccountProfileIndexRoute
}

const appAccountProfileRouteRouteChildren: appAccountProfileRouteRouteChildren =
  {
    appAccountProfileIndexRoute: appAccountProfileIndexRoute,
  }

const appAccountProfileRouteRouteWithChildren =
  appAccountProfileRouteRoute._addFileChildren(
    appAccountProfileRouteRouteChildren,
  )

interface appAccountRouteRouteChildren {
  appAccountProfileRouteRoute: typeof appAccountProfileRouteRouteWithChildren
  appAccountLanguageRoute: typeof appAccountLanguageRoute
  appAccountIndexRoute: typeof appAccountIndexRoute
}

const appAccountRouteRouteChildren: appAccountRouteRouteChildren = {
  appAccountProfileRouteRoute: appAccountProfileRouteRouteWithChildren,
  appAccountLanguageRoute: appAccountLanguageRoute,
  appAccountIndexRoute: appAccountIndexRoute,
}

const appAccountRouteRouteWithChildren = appAccountRouteRoute._addFileChildren(
  appAccountRouteRouteChildren,
)

interface appConfigurationManagementChargesCategoryIdSlabsRouteRouteChildren {
  appConfigurationManagementChargesCategoryIdSlabsIndexRoute: typeof appConfigurationManagementChargesCategoryIdSlabsIndexRoute
}

const appConfigurationManagementChargesCategoryIdSlabsRouteRouteChildren: appConfigurationManagementChargesCategoryIdSlabsRouteRouteChildren =
  {
    appConfigurationManagementChargesCategoryIdSlabsIndexRoute:
      appConfigurationManagementChargesCategoryIdSlabsIndexRoute,
  }

const appConfigurationManagementChargesCategoryIdSlabsRouteRouteWithChildren =
  appConfigurationManagementChargesCategoryIdSlabsRouteRoute._addFileChildren(
    appConfigurationManagementChargesCategoryIdSlabsRouteRouteChildren,
  )

interface appConfigurationManagementChargesCategoryIdRouteRouteChildren {
  appConfigurationManagementChargesCategoryIdSlabsRouteRoute: typeof appConfigurationManagementChargesCategoryIdSlabsRouteRouteWithChildren
  appConfigurationManagementChargesCategoryIdIndexRoute: typeof appConfigurationManagementChargesCategoryIdIndexRoute
}

const appConfigurationManagementChargesCategoryIdRouteRouteChildren: appConfigurationManagementChargesCategoryIdRouteRouteChildren =
  {
    appConfigurationManagementChargesCategoryIdSlabsRouteRoute:
      appConfigurationManagementChargesCategoryIdSlabsRouteRouteWithChildren,
    appConfigurationManagementChargesCategoryIdIndexRoute:
      appConfigurationManagementChargesCategoryIdIndexRoute,
  }

const appConfigurationManagementChargesCategoryIdRouteRouteWithChildren =
  appConfigurationManagementChargesCategoryIdRouteRoute._addFileChildren(
    appConfigurationManagementChargesCategoryIdRouteRouteChildren,
  )

interface appConfigurationManagementChargesRouteRouteChildren {
  appConfigurationManagementChargesCategoryIdRouteRoute: typeof appConfigurationManagementChargesCategoryIdRouteRouteWithChildren
  appConfigurationManagementChargesIndexRoute: typeof appConfigurationManagementChargesIndexRoute
}

const appConfigurationManagementChargesRouteRouteChildren: appConfigurationManagementChargesRouteRouteChildren =
  {
    appConfigurationManagementChargesCategoryIdRouteRoute:
      appConfigurationManagementChargesCategoryIdRouteRouteWithChildren,
    appConfigurationManagementChargesIndexRoute:
      appConfigurationManagementChargesIndexRoute,
  }

const appConfigurationManagementChargesRouteRouteWithChildren =
  appConfigurationManagementChargesRouteRoute._addFileChildren(
    appConfigurationManagementChargesRouteRouteChildren,
  )

interface appConfigurationManagementCommissionsCategoryIdRouteRouteChildren {
  appConfigurationManagementCommissionsCategoryIdIndexRoute: typeof appConfigurationManagementCommissionsCategoryIdIndexRoute
}

const appConfigurationManagementCommissionsCategoryIdRouteRouteChildren: appConfigurationManagementCommissionsCategoryIdRouteRouteChildren =
  {
    appConfigurationManagementCommissionsCategoryIdIndexRoute:
      appConfigurationManagementCommissionsCategoryIdIndexRoute,
  }

const appConfigurationManagementCommissionsCategoryIdRouteRouteWithChildren =
  appConfigurationManagementCommissionsCategoryIdRouteRoute._addFileChildren(
    appConfigurationManagementCommissionsCategoryIdRouteRouteChildren,
  )

interface appConfigurationManagementCommissionsRouteRouteChildren {
  appConfigurationManagementCommissionsCategoryIdRouteRoute: typeof appConfigurationManagementCommissionsCategoryIdRouteRouteWithChildren
  appConfigurationManagementCommissionsIndexRoute: typeof appConfigurationManagementCommissionsIndexRoute
}

const appConfigurationManagementCommissionsRouteRouteChildren: appConfigurationManagementCommissionsRouteRouteChildren =
  {
    appConfigurationManagementCommissionsCategoryIdRouteRoute:
      appConfigurationManagementCommissionsCategoryIdRouteRouteWithChildren,
    appConfigurationManagementCommissionsIndexRoute:
      appConfigurationManagementCommissionsIndexRoute,
  }

const appConfigurationManagementCommissionsRouteRouteWithChildren =
  appConfigurationManagementCommissionsRouteRoute._addFileChildren(
    appConfigurationManagementCommissionsRouteRouteChildren,
  )

interface appConfigurationManagementDiscountManagementDiscountCategoryRouteRouteChildren {
  appConfigurationManagementDiscountManagementDiscountCategoryIndexRoute: typeof appConfigurationManagementDiscountManagementDiscountCategoryIndexRoute
}

const appConfigurationManagementDiscountManagementDiscountCategoryRouteRouteChildren: appConfigurationManagementDiscountManagementDiscountCategoryRouteRouteChildren =
  {
    appConfigurationManagementDiscountManagementDiscountCategoryIndexRoute:
      appConfigurationManagementDiscountManagementDiscountCategoryIndexRoute,
  }

const appConfigurationManagementDiscountManagementDiscountCategoryRouteRouteWithChildren =
  appConfigurationManagementDiscountManagementDiscountCategoryRouteRoute._addFileChildren(
    appConfigurationManagementDiscountManagementDiscountCategoryRouteRouteChildren,
  )

interface appConfigurationManagementDiscountManagementRouteRouteChildren {
  appConfigurationManagementDiscountManagementDiscountCategoryRouteRoute: typeof appConfigurationManagementDiscountManagementDiscountCategoryRouteRouteWithChildren
  appConfigurationManagementDiscountManagementIndexRoute: typeof appConfigurationManagementDiscountManagementIndexRoute
}

const appConfigurationManagementDiscountManagementRouteRouteChildren: appConfigurationManagementDiscountManagementRouteRouteChildren =
  {
    appConfigurationManagementDiscountManagementDiscountCategoryRouteRoute:
      appConfigurationManagementDiscountManagementDiscountCategoryRouteRouteWithChildren,
    appConfigurationManagementDiscountManagementIndexRoute:
      appConfigurationManagementDiscountManagementIndexRoute,
  }

const appConfigurationManagementDiscountManagementRouteRouteWithChildren =
  appConfigurationManagementDiscountManagementRouteRoute._addFileChildren(
    appConfigurationManagementDiscountManagementRouteRouteChildren,
  )

interface appConfigurationManagementGroupManagementSubGroupRouteRouteChildren {
  appConfigurationManagementGroupManagementSubGroupClubGalleryRoute: typeof appConfigurationManagementGroupManagementSubGroupClubGalleryRoute
  appConfigurationManagementGroupManagementSubGroupIndexRoute: typeof appConfigurationManagementGroupManagementSubGroupIndexRoute
}

const appConfigurationManagementGroupManagementSubGroupRouteRouteChildren: appConfigurationManagementGroupManagementSubGroupRouteRouteChildren =
  {
    appConfigurationManagementGroupManagementSubGroupClubGalleryRoute:
      appConfigurationManagementGroupManagementSubGroupClubGalleryRoute,
    appConfigurationManagementGroupManagementSubGroupIndexRoute:
      appConfigurationManagementGroupManagementSubGroupIndexRoute,
  }

const appConfigurationManagementGroupManagementSubGroupRouteRouteWithChildren =
  appConfigurationManagementGroupManagementSubGroupRouteRoute._addFileChildren(
    appConfigurationManagementGroupManagementSubGroupRouteRouteChildren,
  )

interface appConfigurationManagementGroupManagementRouteRouteChildren {
  appConfigurationManagementGroupManagementSubGroupRouteRoute: typeof appConfigurationManagementGroupManagementSubGroupRouteRouteWithChildren
  appConfigurationManagementGroupManagementIndexRoute: typeof appConfigurationManagementGroupManagementIndexRoute
}

const appConfigurationManagementGroupManagementRouteRouteChildren: appConfigurationManagementGroupManagementRouteRouteChildren =
  {
    appConfigurationManagementGroupManagementSubGroupRouteRoute:
      appConfigurationManagementGroupManagementSubGroupRouteRouteWithChildren,
    appConfigurationManagementGroupManagementIndexRoute:
      appConfigurationManagementGroupManagementIndexRoute,
  }

const appConfigurationManagementGroupManagementRouteRouteWithChildren =
  appConfigurationManagementGroupManagementRouteRoute._addFileChildren(
    appConfigurationManagementGroupManagementRouteRouteChildren,
  )

interface appConfigurationManagementHoslogPlansRouteRouteChildren {
  appConfigurationManagementHoslogPlansIndexRoute: typeof appConfigurationManagementHoslogPlansIndexRoute
}

const appConfigurationManagementHoslogPlansRouteRouteChildren: appConfigurationManagementHoslogPlansRouteRouteChildren =
  {
    appConfigurationManagementHoslogPlansIndexRoute:
      appConfigurationManagementHoslogPlansIndexRoute,
  }

const appConfigurationManagementHoslogPlansRouteRouteWithChildren =
  appConfigurationManagementHoslogPlansRouteRoute._addFileChildren(
    appConfigurationManagementHoslogPlansRouteRouteChildren,
  )

interface appConfigurationManagementLocationRouteRouteChildren {
  appConfigurationManagementLocationIndexRoute: typeof appConfigurationManagementLocationIndexRoute
}

const appConfigurationManagementLocationRouteRouteChildren: appConfigurationManagementLocationRouteRouteChildren =
  {
    appConfigurationManagementLocationIndexRoute:
      appConfigurationManagementLocationIndexRoute,
  }

const appConfigurationManagementLocationRouteRouteWithChildren =
  appConfigurationManagementLocationRouteRoute._addFileChildren(
    appConfigurationManagementLocationRouteRouteChildren,
  )

interface appConfigurationManagementWithdrawalsSetupRouteRouteChildren {
  appConfigurationManagementWithdrawalsSetupIndexRoute: typeof appConfigurationManagementWithdrawalsSetupIndexRoute
}

const appConfigurationManagementWithdrawalsSetupRouteRouteChildren: appConfigurationManagementWithdrawalsSetupRouteRouteChildren =
  {
    appConfigurationManagementWithdrawalsSetupIndexRoute:
      appConfigurationManagementWithdrawalsSetupIndexRoute,
  }

const appConfigurationManagementWithdrawalsSetupRouteRouteWithChildren =
  appConfigurationManagementWithdrawalsSetupRouteRoute._addFileChildren(
    appConfigurationManagementWithdrawalsSetupRouteRouteChildren,
  )

interface appConfigurationManagementRouteRouteChildren {
  appConfigurationManagementChargesRouteRoute: typeof appConfigurationManagementChargesRouteRouteWithChildren
  appConfigurationManagementCommissionsRouteRoute: typeof appConfigurationManagementCommissionsRouteRouteWithChildren
  appConfigurationManagementDiscountManagementRouteRoute: typeof appConfigurationManagementDiscountManagementRouteRouteWithChildren
  appConfigurationManagementGroupManagementRouteRoute: typeof appConfigurationManagementGroupManagementRouteRouteWithChildren
  appConfigurationManagementHoslogPlansRouteRoute: typeof appConfigurationManagementHoslogPlansRouteRouteWithChildren
  appConfigurationManagementLocationRouteRoute: typeof appConfigurationManagementLocationRouteRouteWithChildren
  appConfigurationManagementWithdrawalsSetupRouteRoute: typeof appConfigurationManagementWithdrawalsSetupRouteRouteWithChildren
  appConfigurationManagementIndexRoute: typeof appConfigurationManagementIndexRoute
}

const appConfigurationManagementRouteRouteChildren: appConfigurationManagementRouteRouteChildren =
  {
    appConfigurationManagementChargesRouteRoute:
      appConfigurationManagementChargesRouteRouteWithChildren,
    appConfigurationManagementCommissionsRouteRoute:
      appConfigurationManagementCommissionsRouteRouteWithChildren,
    appConfigurationManagementDiscountManagementRouteRoute:
      appConfigurationManagementDiscountManagementRouteRouteWithChildren,
    appConfigurationManagementGroupManagementRouteRoute:
      appConfigurationManagementGroupManagementRouteRouteWithChildren,
    appConfigurationManagementHoslogPlansRouteRoute:
      appConfigurationManagementHoslogPlansRouteRouteWithChildren,
    appConfigurationManagementLocationRouteRoute:
      appConfigurationManagementLocationRouteRouteWithChildren,
    appConfigurationManagementWithdrawalsSetupRouteRoute:
      appConfigurationManagementWithdrawalsSetupRouteRouteWithChildren,
    appConfigurationManagementIndexRoute: appConfigurationManagementIndexRoute,
  }

const appConfigurationManagementRouteRouteWithChildren =
  appConfigurationManagementRouteRoute._addFileChildren(
    appConfigurationManagementRouteRouteChildren,
  )

interface appDashboardConversionAnalyticsRouteRouteChildren {
  appDashboardConversionAnalyticsIndexRoute: typeof appDashboardConversionAnalyticsIndexRoute
}

const appDashboardConversionAnalyticsRouteRouteChildren: appDashboardConversionAnalyticsRouteRouteChildren =
  {
    appDashboardConversionAnalyticsIndexRoute:
      appDashboardConversionAnalyticsIndexRoute,
  }

const appDashboardConversionAnalyticsRouteRouteWithChildren =
  appDashboardConversionAnalyticsRouteRoute._addFileChildren(
    appDashboardConversionAnalyticsRouteRouteChildren,
  )

interface appDashboardReferralReportsRouteRouteChildren {
  appDashboardReferralReportsIndexRoute: typeof appDashboardReferralReportsIndexRoute
  appDashboardReferralReportsReportTypeReferrerIdIndexRoute: typeof appDashboardReferralReportsReportTypeReferrerIdIndexRoute
}

const appDashboardReferralReportsRouteRouteChildren: appDashboardReferralReportsRouteRouteChildren =
  {
    appDashboardReferralReportsIndexRoute:
      appDashboardReferralReportsIndexRoute,
    appDashboardReferralReportsReportTypeReferrerIdIndexRoute:
      appDashboardReferralReportsReportTypeReferrerIdIndexRoute,
  }

const appDashboardReferralReportsRouteRouteWithChildren =
  appDashboardReferralReportsRouteRoute._addFileChildren(
    appDashboardReferralReportsRouteRouteChildren,
  )

interface appDashboardReservationLedgerRouteRouteChildren {
  appDashboardReservationLedgerIndexRoute: typeof appDashboardReservationLedgerIndexRoute
}

const appDashboardReservationLedgerRouteRouteChildren: appDashboardReservationLedgerRouteRouteChildren =
  {
    appDashboardReservationLedgerIndexRoute:
      appDashboardReservationLedgerIndexRoute,
  }

const appDashboardReservationLedgerRouteRouteWithChildren =
  appDashboardReservationLedgerRouteRoute._addFileChildren(
    appDashboardReservationLedgerRouteRouteChildren,
  )

interface appDashboardRouteRouteChildren {
  appDashboardConversionAnalyticsRouteRoute: typeof appDashboardConversionAnalyticsRouteRouteWithChildren
  appDashboardReferralReportsRouteRoute: typeof appDashboardReferralReportsRouteRouteWithChildren
  appDashboardReservationLedgerRouteRoute: typeof appDashboardReservationLedgerRouteRouteWithChildren
  appDashboardOverviewRoute: typeof appDashboardOverviewRoute
  appDashboardSalesPerformanceRoute: typeof appDashboardSalesPerformanceRoute
  appDashboardIndexRoute: typeof appDashboardIndexRoute
}

const appDashboardRouteRouteChildren: appDashboardRouteRouteChildren = {
  appDashboardConversionAnalyticsRouteRoute:
    appDashboardConversionAnalyticsRouteRouteWithChildren,
  appDashboardReferralReportsRouteRoute:
    appDashboardReferralReportsRouteRouteWithChildren,
  appDashboardReservationLedgerRouteRoute:
    appDashboardReservationLedgerRouteRouteWithChildren,
  appDashboardOverviewRoute: appDashboardOverviewRoute,
  appDashboardSalesPerformanceRoute: appDashboardSalesPerformanceRoute,
  appDashboardIndexRoute: appDashboardIndexRoute,
}

const appDashboardRouteRouteWithChildren =
  appDashboardRouteRoute._addFileChildren(appDashboardRouteRouteChildren)

interface appFaqComplaintsRouteRouteChildren {
  appFaqComplaintsIndexRoute: typeof appFaqComplaintsIndexRoute
}

const appFaqComplaintsRouteRouteChildren: appFaqComplaintsRouteRouteChildren = {
  appFaqComplaintsIndexRoute: appFaqComplaintsIndexRoute,
}

const appFaqComplaintsRouteRouteWithChildren =
  appFaqComplaintsRouteRoute._addFileChildren(
    appFaqComplaintsRouteRouteChildren,
  )

interface appFaqInquiryRouteRouteChildren {
  appFaqInquiryIndexRoute: typeof appFaqInquiryIndexRoute
}

const appFaqInquiryRouteRouteChildren: appFaqInquiryRouteRouteChildren = {
  appFaqInquiryIndexRoute: appFaqInquiryIndexRoute,
}

const appFaqInquiryRouteRouteWithChildren =
  appFaqInquiryRouteRoute._addFileChildren(appFaqInquiryRouteRouteChildren)

interface appFaqReviewRatingsRouteRouteChildren {
  appFaqReviewRatingsIndexRoute: typeof appFaqReviewRatingsIndexRoute
}

const appFaqReviewRatingsRouteRouteChildren: appFaqReviewRatingsRouteRouteChildren =
  {
    appFaqReviewRatingsIndexRoute: appFaqReviewRatingsIndexRoute,
  }

const appFaqReviewRatingsRouteRouteWithChildren =
  appFaqReviewRatingsRouteRoute._addFileChildren(
    appFaqReviewRatingsRouteRouteChildren,
  )

interface appFaqRouteRouteChildren {
  appFaqComplaintsRouteRoute: typeof appFaqComplaintsRouteRouteWithChildren
  appFaqInquiryRouteRoute: typeof appFaqInquiryRouteRouteWithChildren
  appFaqReviewRatingsRouteRoute: typeof appFaqReviewRatingsRouteRouteWithChildren
  appFaqIndexRoute: typeof appFaqIndexRoute
}

const appFaqRouteRouteChildren: appFaqRouteRouteChildren = {
  appFaqComplaintsRouteRoute: appFaqComplaintsRouteRouteWithChildren,
  appFaqInquiryRouteRoute: appFaqInquiryRouteRouteWithChildren,
  appFaqReviewRatingsRouteRoute: appFaqReviewRatingsRouteRouteWithChildren,
  appFaqIndexRoute: appFaqIndexRoute,
}

const appFaqRouteRouteWithChildren = appFaqRouteRoute._addFileChildren(
  appFaqRouteRouteChildren,
)

interface appLogsManagementEmailLogsRouteRouteChildren {
  appLogsManagementEmailLogsIndexRoute: typeof appLogsManagementEmailLogsIndexRoute
}

const appLogsManagementEmailLogsRouteRouteChildren: appLogsManagementEmailLogsRouteRouteChildren =
  {
    appLogsManagementEmailLogsIndexRoute: appLogsManagementEmailLogsIndexRoute,
  }

const appLogsManagementEmailLogsRouteRouteWithChildren =
  appLogsManagementEmailLogsRouteRoute._addFileChildren(
    appLogsManagementEmailLogsRouteRouteChildren,
  )

interface appLogsManagementSmsLogsRouteRouteChildren {
  appLogsManagementSmsLogsIndexRoute: typeof appLogsManagementSmsLogsIndexRoute
}

const appLogsManagementSmsLogsRouteRouteChildren: appLogsManagementSmsLogsRouteRouteChildren =
  {
    appLogsManagementSmsLogsIndexRoute: appLogsManagementSmsLogsIndexRoute,
  }

const appLogsManagementSmsLogsRouteRouteWithChildren =
  appLogsManagementSmsLogsRouteRoute._addFileChildren(
    appLogsManagementSmsLogsRouteRouteChildren,
  )

interface appLogsManagementStaticDataTypeStaticDataTypeNameRouteRouteChildren {
  appLogsManagementStaticDataTypeStaticDataTypeNameIndexRoute: typeof appLogsManagementStaticDataTypeStaticDataTypeNameIndexRoute
}

const appLogsManagementStaticDataTypeStaticDataTypeNameRouteRouteChildren: appLogsManagementStaticDataTypeStaticDataTypeNameRouteRouteChildren =
  {
    appLogsManagementStaticDataTypeStaticDataTypeNameIndexRoute:
      appLogsManagementStaticDataTypeStaticDataTypeNameIndexRoute,
  }

const appLogsManagementStaticDataTypeStaticDataTypeNameRouteRouteWithChildren =
  appLogsManagementStaticDataTypeStaticDataTypeNameRouteRoute._addFileChildren(
    appLogsManagementStaticDataTypeStaticDataTypeNameRouteRouteChildren,
  )

interface appLogsManagementStaticDataTypeRouteRouteChildren {
  appLogsManagementStaticDataTypeStaticDataTypeNameRouteRoute: typeof appLogsManagementStaticDataTypeStaticDataTypeNameRouteRouteWithChildren
  appLogsManagementStaticDataTypeIndexRoute: typeof appLogsManagementStaticDataTypeIndexRoute
}

const appLogsManagementStaticDataTypeRouteRouteChildren: appLogsManagementStaticDataTypeRouteRouteChildren =
  {
    appLogsManagementStaticDataTypeStaticDataTypeNameRouteRoute:
      appLogsManagementStaticDataTypeStaticDataTypeNameRouteRouteWithChildren,
    appLogsManagementStaticDataTypeIndexRoute:
      appLogsManagementStaticDataTypeIndexRoute,
  }

const appLogsManagementStaticDataTypeRouteRouteWithChildren =
  appLogsManagementStaticDataTypeRouteRoute._addFileChildren(
    appLogsManagementStaticDataTypeRouteRouteChildren,
  )

interface appLogsManagementRouteRouteChildren {
  appLogsManagementEmailLogsRouteRoute: typeof appLogsManagementEmailLogsRouteRouteWithChildren
  appLogsManagementSmsLogsRouteRoute: typeof appLogsManagementSmsLogsRouteRouteWithChildren
  appLogsManagementStaticDataTypeRouteRoute: typeof appLogsManagementStaticDataTypeRouteRouteWithChildren
  appLogsManagementIndexRoute: typeof appLogsManagementIndexRoute
  appLogsManagementAccessLogsIndexRoute: typeof appLogsManagementAccessLogsIndexRoute
  appLogsManagementApiLogsIndexRoute: typeof appLogsManagementApiLogsIndexRoute
}

const appLogsManagementRouteRouteChildren: appLogsManagementRouteRouteChildren =
  {
    appLogsManagementEmailLogsRouteRoute:
      appLogsManagementEmailLogsRouteRouteWithChildren,
    appLogsManagementSmsLogsRouteRoute:
      appLogsManagementSmsLogsRouteRouteWithChildren,
    appLogsManagementStaticDataTypeRouteRoute:
      appLogsManagementStaticDataTypeRouteRouteWithChildren,
    appLogsManagementIndexRoute: appLogsManagementIndexRoute,
    appLogsManagementAccessLogsIndexRoute:
      appLogsManagementAccessLogsIndexRoute,
    appLogsManagementApiLogsIndexRoute: appLogsManagementApiLogsIndexRoute,
  }

const appLogsManagementRouteRouteWithChildren =
  appLogsManagementRouteRoute._addFileChildren(
    appLogsManagementRouteRouteChildren,
  )

interface appPaymentManagementAccountInformationRouteRouteChildren {
  appPaymentManagementAccountInformationIndexRoute: typeof appPaymentManagementAccountInformationIndexRoute
}

const appPaymentManagementAccountInformationRouteRouteChildren: appPaymentManagementAccountInformationRouteRouteChildren =
  {
    appPaymentManagementAccountInformationIndexRoute:
      appPaymentManagementAccountInformationIndexRoute,
  }

const appPaymentManagementAccountInformationRouteRouteWithChildren =
  appPaymentManagementAccountInformationRouteRoute._addFileChildren(
    appPaymentManagementAccountInformationRouteRouteChildren,
  )

interface appPaymentManagementAffiliateLogRouteRouteChildren {
  appPaymentManagementAffiliateLogMonthlyReportRoute: typeof appPaymentManagementAffiliateLogMonthlyReportRoute
  appPaymentManagementAffiliateLogIndexRoute: typeof appPaymentManagementAffiliateLogIndexRoute
}

const appPaymentManagementAffiliateLogRouteRouteChildren: appPaymentManagementAffiliateLogRouteRouteChildren =
  {
    appPaymentManagementAffiliateLogMonthlyReportRoute:
      appPaymentManagementAffiliateLogMonthlyReportRoute,
    appPaymentManagementAffiliateLogIndexRoute:
      appPaymentManagementAffiliateLogIndexRoute,
  }

const appPaymentManagementAffiliateLogRouteRouteWithChildren =
  appPaymentManagementAffiliateLogRouteRoute._addFileChildren(
    appPaymentManagementAffiliateLogRouteRouteChildren,
  )

interface appPaymentManagementCustomerPaymentLogsRouteRouteChildren {
  appPaymentManagementCustomerPaymentLogsIndexRoute: typeof appPaymentManagementCustomerPaymentLogsIndexRoute
}

const appPaymentManagementCustomerPaymentLogsRouteRouteChildren: appPaymentManagementCustomerPaymentLogsRouteRouteChildren =
  {
    appPaymentManagementCustomerPaymentLogsIndexRoute:
      appPaymentManagementCustomerPaymentLogsIndexRoute,
  }

const appPaymentManagementCustomerPaymentLogsRouteRouteWithChildren =
  appPaymentManagementCustomerPaymentLogsRouteRoute._addFileChildren(
    appPaymentManagementCustomerPaymentLogsRouteRouteChildren,
  )

interface appPaymentManagementOverviewRouteRouteChildren {
  appPaymentManagementOverviewIndexRoute: typeof appPaymentManagementOverviewIndexRoute
}

const appPaymentManagementOverviewRouteRouteChildren: appPaymentManagementOverviewRouteRouteChildren =
  {
    appPaymentManagementOverviewIndexRoute:
      appPaymentManagementOverviewIndexRoute,
  }

const appPaymentManagementOverviewRouteRouteWithChildren =
  appPaymentManagementOverviewRouteRoute._addFileChildren(
    appPaymentManagementOverviewRouteRouteChildren,
  )

interface appPaymentManagementStorePaymentLogStoreIdRouteRouteChildren {
  appPaymentManagementStorePaymentLogStoreIdIndexRoute: typeof appPaymentManagementStorePaymentLogStoreIdIndexRoute
}

const appPaymentManagementStorePaymentLogStoreIdRouteRouteChildren: appPaymentManagementStorePaymentLogStoreIdRouteRouteChildren =
  {
    appPaymentManagementStorePaymentLogStoreIdIndexRoute:
      appPaymentManagementStorePaymentLogStoreIdIndexRoute,
  }

const appPaymentManagementStorePaymentLogStoreIdRouteRouteWithChildren =
  appPaymentManagementStorePaymentLogStoreIdRouteRoute._addFileChildren(
    appPaymentManagementStorePaymentLogStoreIdRouteRouteChildren,
  )

interface appPaymentManagementStorePaymentLogRouteRouteChildren {
  appPaymentManagementStorePaymentLogStoreIdRouteRoute: typeof appPaymentManagementStorePaymentLogStoreIdRouteRouteWithChildren
  appPaymentManagementStorePaymentLogIndexRoute: typeof appPaymentManagementStorePaymentLogIndexRoute
}

const appPaymentManagementStorePaymentLogRouteRouteChildren: appPaymentManagementStorePaymentLogRouteRouteChildren =
  {
    appPaymentManagementStorePaymentLogStoreIdRouteRoute:
      appPaymentManagementStorePaymentLogStoreIdRouteRouteWithChildren,
    appPaymentManagementStorePaymentLogIndexRoute:
      appPaymentManagementStorePaymentLogIndexRoute,
  }

const appPaymentManagementStorePaymentLogRouteRouteWithChildren =
  appPaymentManagementStorePaymentLogRouteRoute._addFileChildren(
    appPaymentManagementStorePaymentLogRouteRouteChildren,
  )

interface appPaymentManagementRouteRouteChildren {
  appPaymentManagementAccountInformationRouteRoute: typeof appPaymentManagementAccountInformationRouteRouteWithChildren
  appPaymentManagementAffiliateLogRouteRoute: typeof appPaymentManagementAffiliateLogRouteRouteWithChildren
  appPaymentManagementCustomerPaymentLogsRouteRoute: typeof appPaymentManagementCustomerPaymentLogsRouteRouteWithChildren
  appPaymentManagementOverviewRouteRoute: typeof appPaymentManagementOverviewRouteRouteWithChildren
  appPaymentManagementStorePaymentLogRouteRoute: typeof appPaymentManagementStorePaymentLogRouteRouteWithChildren
  appPaymentManagementIndexRoute: typeof appPaymentManagementIndexRoute
  appPaymentManagementAdminPaymentSetupAddBankInformationRoute: typeof appPaymentManagementAdminPaymentSetupAddBankInformationRoute
  appPaymentManagementAdminPaymentSetupIndexRoute: typeof appPaymentManagementAdminPaymentSetupIndexRoute
}

const appPaymentManagementRouteRouteChildren: appPaymentManagementRouteRouteChildren =
  {
    appPaymentManagementAccountInformationRouteRoute:
      appPaymentManagementAccountInformationRouteRouteWithChildren,
    appPaymentManagementAffiliateLogRouteRoute:
      appPaymentManagementAffiliateLogRouteRouteWithChildren,
    appPaymentManagementCustomerPaymentLogsRouteRoute:
      appPaymentManagementCustomerPaymentLogsRouteRouteWithChildren,
    appPaymentManagementOverviewRouteRoute:
      appPaymentManagementOverviewRouteRouteWithChildren,
    appPaymentManagementStorePaymentLogRouteRoute:
      appPaymentManagementStorePaymentLogRouteRouteWithChildren,
    appPaymentManagementIndexRoute: appPaymentManagementIndexRoute,
    appPaymentManagementAdminPaymentSetupAddBankInformationRoute:
      appPaymentManagementAdminPaymentSetupAddBankInformationRoute,
    appPaymentManagementAdminPaymentSetupIndexRoute:
      appPaymentManagementAdminPaymentSetupIndexRoute,
  }

const appPaymentManagementRouteRouteWithChildren =
  appPaymentManagementRouteRoute._addFileChildren(
    appPaymentManagementRouteRouteChildren,
  )

interface appPointsManagementPointsBalanceStatementRouteRouteChildren {
  appPointsManagementPointsBalanceStatementIndexRoute: typeof appPointsManagementPointsBalanceStatementIndexRoute
}

const appPointsManagementPointsBalanceStatementRouteRouteChildren: appPointsManagementPointsBalanceStatementRouteRouteChildren =
  {
    appPointsManagementPointsBalanceStatementIndexRoute:
      appPointsManagementPointsBalanceStatementIndexRoute,
  }

const appPointsManagementPointsBalanceStatementRouteRouteWithChildren =
  appPointsManagementPointsBalanceStatementRouteRoute._addFileChildren(
    appPointsManagementPointsBalanceStatementRouteRouteChildren,
  )

interface appPointsManagementPointsConfigurationCustomerProgramIdRouteRouteChildren {
  appPointsManagementPointsConfigurationCustomerProgramIdIndexRoute: typeof appPointsManagementPointsConfigurationCustomerProgramIdIndexRoute
}

const appPointsManagementPointsConfigurationCustomerProgramIdRouteRouteChildren: appPointsManagementPointsConfigurationCustomerProgramIdRouteRouteChildren =
  {
    appPointsManagementPointsConfigurationCustomerProgramIdIndexRoute:
      appPointsManagementPointsConfigurationCustomerProgramIdIndexRoute,
  }

const appPointsManagementPointsConfigurationCustomerProgramIdRouteRouteWithChildren =
  appPointsManagementPointsConfigurationCustomerProgramIdRouteRoute._addFileChildren(
    appPointsManagementPointsConfigurationCustomerProgramIdRouteRouteChildren,
  )

interface appPointsManagementPointsConfigurationRouteRouteChildren {
  appPointsManagementPointsConfigurationIndexRoute: typeof appPointsManagementPointsConfigurationIndexRoute
  appPointsManagementPointsConfigurationCustomerProgramIdRouteRoute: typeof appPointsManagementPointsConfigurationCustomerProgramIdRouteRouteWithChildren
  appPointsManagementPointsConfigurationAffiliatePointCategoryIdSlabsRoute: typeof appPointsManagementPointsConfigurationAffiliatePointCategoryIdSlabsRoute
}

const appPointsManagementPointsConfigurationRouteRouteChildren: appPointsManagementPointsConfigurationRouteRouteChildren =
  {
    appPointsManagementPointsConfigurationIndexRoute:
      appPointsManagementPointsConfigurationIndexRoute,
    appPointsManagementPointsConfigurationCustomerProgramIdRouteRoute:
      appPointsManagementPointsConfigurationCustomerProgramIdRouteRouteWithChildren,
    appPointsManagementPointsConfigurationAffiliatePointCategoryIdSlabsRoute:
      appPointsManagementPointsConfigurationAffiliatePointCategoryIdSlabsRoute,
  }

const appPointsManagementPointsConfigurationRouteRouteWithChildren =
  appPointsManagementPointsConfigurationRouteRoute._addFileChildren(
    appPointsManagementPointsConfigurationRouteRouteChildren,
  )

interface appPointsManagementPointsTransferRouteRouteChildren {
  appPointsManagementPointsTransferIndexRoute: typeof appPointsManagementPointsTransferIndexRoute
}

const appPointsManagementPointsTransferRouteRouteChildren: appPointsManagementPointsTransferRouteRouteChildren =
  {
    appPointsManagementPointsTransferIndexRoute:
      appPointsManagementPointsTransferIndexRoute,
  }

const appPointsManagementPointsTransferRouteRouteWithChildren =
  appPointsManagementPointsTransferRouteRoute._addFileChildren(
    appPointsManagementPointsTransferRouteRouteChildren,
  )

interface appPointsManagementSystemTransferRouteRouteChildren {
  appPointsManagementSystemTransferIndexRoute: typeof appPointsManagementSystemTransferIndexRoute
}

const appPointsManagementSystemTransferRouteRouteChildren: appPointsManagementSystemTransferRouteRouteChildren =
  {
    appPointsManagementSystemTransferIndexRoute:
      appPointsManagementSystemTransferIndexRoute,
  }

const appPointsManagementSystemTransferRouteRouteWithChildren =
  appPointsManagementSystemTransferRouteRoute._addFileChildren(
    appPointsManagementSystemTransferRouteRouteChildren,
  )

interface appPointsManagementRouteRouteChildren {
  appPointsManagementPointsBalanceStatementRouteRoute: typeof appPointsManagementPointsBalanceStatementRouteRouteWithChildren
  appPointsManagementPointsConfigurationRouteRoute: typeof appPointsManagementPointsConfigurationRouteRouteWithChildren
  appPointsManagementPointsTransferRouteRoute: typeof appPointsManagementPointsTransferRouteRouteWithChildren
  appPointsManagementSystemTransferRouteRoute: typeof appPointsManagementSystemTransferRouteRouteWithChildren
  appPointsManagementIndexRoute: typeof appPointsManagementIndexRoute
  appPointsManagementPointsRequestIndexRoute: typeof appPointsManagementPointsRequestIndexRoute
}

const appPointsManagementRouteRouteChildren: appPointsManagementRouteRouteChildren =
  {
    appPointsManagementPointsBalanceStatementRouteRoute:
      appPointsManagementPointsBalanceStatementRouteRouteWithChildren,
    appPointsManagementPointsConfigurationRouteRoute:
      appPointsManagementPointsConfigurationRouteRouteWithChildren,
    appPointsManagementPointsTransferRouteRoute:
      appPointsManagementPointsTransferRouteRouteWithChildren,
    appPointsManagementSystemTransferRouteRoute:
      appPointsManagementSystemTransferRouteRouteWithChildren,
    appPointsManagementIndexRoute: appPointsManagementIndexRoute,
    appPointsManagementPointsRequestIndexRoute:
      appPointsManagementPointsRequestIndexRoute,
  }

const appPointsManagementRouteRouteWithChildren =
  appPointsManagementRouteRoute._addFileChildren(
    appPointsManagementRouteRouteChildren,
  )

interface appPromosOfferAdvertisementRouteRouteChildren {
  appPromosOfferAdvertisementIndexRoute: typeof appPromosOfferAdvertisementIndexRoute
}

const appPromosOfferAdvertisementRouteRouteChildren: appPromosOfferAdvertisementRouteRouteChildren =
  {
    appPromosOfferAdvertisementIndexRoute:
      appPromosOfferAdvertisementIndexRoute,
  }

const appPromosOfferAdvertisementRouteRouteWithChildren =
  appPromosOfferAdvertisementRouteRoute._addFileChildren(
    appPromosOfferAdvertisementRouteRouteChildren,
  )

interface appPromosOfferPromotionalBannerRouteRouteChildren {
  appPromosOfferPromotionalBannerIndexRoute: typeof appPromosOfferPromotionalBannerIndexRoute
}

const appPromosOfferPromotionalBannerRouteRouteChildren: appPromosOfferPromotionalBannerRouteRouteChildren =
  {
    appPromosOfferPromotionalBannerIndexRoute:
      appPromosOfferPromotionalBannerIndexRoute,
  }

const appPromosOfferPromotionalBannerRouteRouteWithChildren =
  appPromosOfferPromotionalBannerRouteRoute._addFileChildren(
    appPromosOfferPromotionalBannerRouteRouteChildren,
  )

interface appPromosOfferRouteRouteChildren {
  appPromosOfferAdvertisementRouteRoute: typeof appPromosOfferAdvertisementRouteRouteWithChildren
  appPromosOfferPromotionalBannerRouteRoute: typeof appPromosOfferPromotionalBannerRouteRouteWithChildren
  appPromosOfferOfferRoute: typeof appPromosOfferOfferRoute
  appPromosOfferIndexRoute: typeof appPromosOfferIndexRoute
}

const appPromosOfferRouteRouteChildren: appPromosOfferRouteRouteChildren = {
  appPromosOfferAdvertisementRouteRoute:
    appPromosOfferAdvertisementRouteRouteWithChildren,
  appPromosOfferPromotionalBannerRouteRoute:
    appPromosOfferPromotionalBannerRouteRouteWithChildren,
  appPromosOfferOfferRoute: appPromosOfferOfferRoute,
  appPromosOfferIndexRoute: appPromosOfferIndexRoute,
}

const appPromosOfferRouteRouteWithChildren =
  appPromosOfferRouteRoute._addFileChildren(appPromosOfferRouteRouteChildren)

interface appRecommendationManagementEditorsPickRouteRouteChildren {
  appRecommendationManagementEditorsPickIndexRoute: typeof appRecommendationManagementEditorsPickIndexRoute
}

const appRecommendationManagementEditorsPickRouteRouteChildren: appRecommendationManagementEditorsPickRouteRouteChildren =
  {
    appRecommendationManagementEditorsPickIndexRoute:
      appRecommendationManagementEditorsPickIndexRoute,
  }

const appRecommendationManagementEditorsPickRouteRouteWithChildren =
  appRecommendationManagementEditorsPickRouteRoute._addFileChildren(
    appRecommendationManagementEditorsPickRouteRouteChildren,
  )

interface appRecommendationManagementMainPageStoreListHostListRouteRouteChildren {
  appRecommendationManagementMainPageStoreListHostListIndexRoute: typeof appRecommendationManagementMainPageStoreListHostListIndexRoute
}

const appRecommendationManagementMainPageStoreListHostListRouteRouteChildren: appRecommendationManagementMainPageStoreListHostListRouteRouteChildren =
  {
    appRecommendationManagementMainPageStoreListHostListIndexRoute:
      appRecommendationManagementMainPageStoreListHostListIndexRoute,
  }

const appRecommendationManagementMainPageStoreListHostListRouteRouteWithChildren =
  appRecommendationManagementMainPageStoreListHostListRouteRoute._addFileChildren(
    appRecommendationManagementMainPageStoreListHostListRouteRouteChildren,
  )

interface appRecommendationManagementMainPageStoreListRouteRouteChildren {
  appRecommendationManagementMainPageStoreListHostListRouteRoute: typeof appRecommendationManagementMainPageStoreListHostListRouteRouteWithChildren
  appRecommendationManagementMainPageStoreListIndexRoute: typeof appRecommendationManagementMainPageStoreListIndexRoute
}

const appRecommendationManagementMainPageStoreListRouteRouteChildren: appRecommendationManagementMainPageStoreListRouteRouteChildren =
  {
    appRecommendationManagementMainPageStoreListHostListRouteRoute:
      appRecommendationManagementMainPageStoreListHostListRouteRouteWithChildren,
    appRecommendationManagementMainPageStoreListIndexRoute:
      appRecommendationManagementMainPageStoreListIndexRoute,
  }

const appRecommendationManagementMainPageStoreListRouteRouteWithChildren =
  appRecommendationManagementMainPageStoreListRouteRoute._addFileChildren(
    appRecommendationManagementMainPageStoreListRouteRouteChildren,
  )

interface appRecommendationManagementMainPageRouteRouteChildren {
  appRecommendationManagementMainPageStoreListRouteRoute: typeof appRecommendationManagementMainPageStoreListRouteRouteWithChildren
  appRecommendationManagementMainPageIndexRoute: typeof appRecommendationManagementMainPageIndexRoute
}

const appRecommendationManagementMainPageRouteRouteChildren: appRecommendationManagementMainPageRouteRouteChildren =
  {
    appRecommendationManagementMainPageStoreListRouteRoute:
      appRecommendationManagementMainPageStoreListRouteRouteWithChildren,
    appRecommendationManagementMainPageIndexRoute:
      appRecommendationManagementMainPageIndexRoute,
  }

const appRecommendationManagementMainPageRouteRouteWithChildren =
  appRecommendationManagementMainPageRouteRoute._addFileChildren(
    appRecommendationManagementMainPageRouteRouteChildren,
  )

interface appRecommendationManagementRouteRouteChildren {
  appRecommendationManagementEditorsPickRouteRoute: typeof appRecommendationManagementEditorsPickRouteRouteWithChildren
  appRecommendationManagementMainPageRouteRoute: typeof appRecommendationManagementMainPageRouteRouteWithChildren
  appRecommendationManagementIndexRoute: typeof appRecommendationManagementIndexRoute
}

const appRecommendationManagementRouteRouteChildren: appRecommendationManagementRouteRouteChildren =
  {
    appRecommendationManagementEditorsPickRouteRoute:
      appRecommendationManagementEditorsPickRouteRouteWithChildren,
    appRecommendationManagementMainPageRouteRoute:
      appRecommendationManagementMainPageRouteRouteWithChildren,
    appRecommendationManagementIndexRoute:
      appRecommendationManagementIndexRoute,
  }

const appRecommendationManagementRouteRouteWithChildren =
  appRecommendationManagementRouteRoute._addFileChildren(
    appRecommendationManagementRouteRouteChildren,
  )

interface appStoreInformationBasicStoresManageStoreRouteRouteChildren {
  appStoreInformationBasicStoresManageStoreIndexRoute: typeof appStoreInformationBasicStoresManageStoreIndexRoute
}

const appStoreInformationBasicStoresManageStoreRouteRouteChildren: appStoreInformationBasicStoresManageStoreRouteRouteChildren =
  {
    appStoreInformationBasicStoresManageStoreIndexRoute:
      appStoreInformationBasicStoresManageStoreIndexRoute,
  }

const appStoreInformationBasicStoresManageStoreRouteRouteWithChildren =
  appStoreInformationBasicStoresManageStoreRouteRoute._addFileChildren(
    appStoreInformationBasicStoresManageStoreRouteRouteChildren,
  )

interface appStoreInformationBasicStoresAddStoreRouteRouteChildren {
  appStoreInformationBasicStoresAddStoreIndexRoute: typeof appStoreInformationBasicStoresAddStoreIndexRoute
}

const appStoreInformationBasicStoresAddStoreRouteRouteChildren: appStoreInformationBasicStoresAddStoreRouteRouteChildren =
  {
    appStoreInformationBasicStoresAddStoreIndexRoute:
      appStoreInformationBasicStoresAddStoreIndexRoute,
  }

const appStoreInformationBasicStoresAddStoreRouteRouteWithChildren =
  appStoreInformationBasicStoresAddStoreRouteRoute._addFileChildren(
    appStoreInformationBasicStoresAddStoreRouteRouteChildren,
  )

interface appStoreInformationBasicStoresSwitchStoreRouteRouteChildren {
  appStoreInformationBasicStoresSwitchStoreIdIndexRoute: typeof appStoreInformationBasicStoresSwitchStoreIdIndexRoute
}

const appStoreInformationBasicStoresSwitchStoreRouteRouteChildren: appStoreInformationBasicStoresSwitchStoreRouteRouteChildren =
  {
    appStoreInformationBasicStoresSwitchStoreIdIndexRoute:
      appStoreInformationBasicStoresSwitchStoreIdIndexRoute,
  }

const appStoreInformationBasicStoresSwitchStoreRouteRouteWithChildren =
  appStoreInformationBasicStoresSwitchStoreRouteRoute._addFileChildren(
    appStoreInformationBasicStoresSwitchStoreRouteRouteChildren,
  )

interface appStoreInformationBasicStoresHostManagementClubidManageHostRouteRouteChildren {
  appStoreInformationBasicStoresHostManagementClubidManageHostIndexRoute: typeof appStoreInformationBasicStoresHostManagementClubidManageHostIndexRoute
}

const appStoreInformationBasicStoresHostManagementClubidManageHostRouteRouteChildren: appStoreInformationBasicStoresHostManagementClubidManageHostRouteRouteChildren =
  {
    appStoreInformationBasicStoresHostManagementClubidManageHostIndexRoute:
      appStoreInformationBasicStoresHostManagementClubidManageHostIndexRoute,
  }

const appStoreInformationBasicStoresHostManagementClubidManageHostRouteRouteWithChildren =
  appStoreInformationBasicStoresHostManagementClubidManageHostRouteRoute._addFileChildren(
    appStoreInformationBasicStoresHostManagementClubidManageHostRouteRouteChildren,
  )

interface appStoreInformationBasicStoresHostManagementClubidAddHostRouteRouteChildren {
  appStoreInformationBasicStoresHostManagementClubidAddHostIndexRoute: typeof appStoreInformationBasicStoresHostManagementClubidAddHostIndexRoute
}

const appStoreInformationBasicStoresHostManagementClubidAddHostRouteRouteChildren: appStoreInformationBasicStoresHostManagementClubidAddHostRouteRouteChildren =
  {
    appStoreInformationBasicStoresHostManagementClubidAddHostIndexRoute:
      appStoreInformationBasicStoresHostManagementClubidAddHostIndexRoute,
  }

const appStoreInformationBasicStoresHostManagementClubidAddHostRouteRouteWithChildren =
  appStoreInformationBasicStoresHostManagementClubidAddHostRouteRoute._addFileChildren(
    appStoreInformationBasicStoresHostManagementClubidAddHostRouteRouteChildren,
  )

interface appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryRouteRouteChildren {
  appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryIndexRoute: typeof appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryIndexRoute
}

const appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryRouteRouteChildren: appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryRouteRouteChildren =
  {
    appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryIndexRoute:
      appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryIndexRoute,
  }

const appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryRouteRouteWithChildren =
  appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryRouteRoute._addFileChildren(
    appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryRouteRouteChildren,
  )

interface appStoreInformationBasicStoresHostManagementClubidGalleryRouteRouteChildren {
  appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryRouteRoute: typeof appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryRouteRouteWithChildren
}

const appStoreInformationBasicStoresHostManagementClubidGalleryRouteRouteChildren: appStoreInformationBasicStoresHostManagementClubidGalleryRouteRouteChildren =
  {
    appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryRouteRoute:
      appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryRouteRouteWithChildren,
  }

const appStoreInformationBasicStoresHostManagementClubidGalleryRouteRouteWithChildren =
  appStoreInformationBasicStoresHostManagementClubidGalleryRouteRoute._addFileChildren(
    appStoreInformationBasicStoresHostManagementClubidGalleryRouteRouteChildren,
  )

interface appStoreInformationBasicStoresHostManagementClubidRouteRouteChildren {
  appStoreInformationBasicStoresHostManagementClubidManageHostRouteRoute: typeof appStoreInformationBasicStoresHostManagementClubidManageHostRouteRouteWithChildren
  appStoreInformationBasicStoresHostManagementClubidAddHostRouteRoute: typeof appStoreInformationBasicStoresHostManagementClubidAddHostRouteRouteWithChildren
  appStoreInformationBasicStoresHostManagementClubidGalleryRouteRoute: typeof appStoreInformationBasicStoresHostManagementClubidGalleryRouteRouteWithChildren
  appStoreInformationBasicStoresHostManagementClubidIndexRoute: typeof appStoreInformationBasicStoresHostManagementClubidIndexRoute
}

const appStoreInformationBasicStoresHostManagementClubidRouteRouteChildren: appStoreInformationBasicStoresHostManagementClubidRouteRouteChildren =
  {
    appStoreInformationBasicStoresHostManagementClubidManageHostRouteRoute:
      appStoreInformationBasicStoresHostManagementClubidManageHostRouteRouteWithChildren,
    appStoreInformationBasicStoresHostManagementClubidAddHostRouteRoute:
      appStoreInformationBasicStoresHostManagementClubidAddHostRouteRouteWithChildren,
    appStoreInformationBasicStoresHostManagementClubidGalleryRouteRoute:
      appStoreInformationBasicStoresHostManagementClubidGalleryRouteRouteWithChildren,
    appStoreInformationBasicStoresHostManagementClubidIndexRoute:
      appStoreInformationBasicStoresHostManagementClubidIndexRoute,
  }

const appStoreInformationBasicStoresHostManagementClubidRouteRouteWithChildren =
  appStoreInformationBasicStoresHostManagementClubidRouteRoute._addFileChildren(
    appStoreInformationBasicStoresHostManagementClubidRouteRouteChildren,
  )

interface appStoreInformationBasicStoresRouteRouteChildren {
  appStoreInformationBasicStoresManageStoreRouteRoute: typeof appStoreInformationBasicStoresManageStoreRouteRouteWithChildren
  appStoreInformationBasicStoresAddStoreRouteRoute: typeof appStoreInformationBasicStoresAddStoreRouteRouteWithChildren
  appStoreInformationBasicStoresSwitchStoreRouteRoute: typeof appStoreInformationBasicStoresSwitchStoreRouteRouteWithChildren
  appStoreInformationBasicStoresIndexRoute: typeof appStoreInformationBasicStoresIndexRoute
  appStoreInformationBasicStoresHostManagementClubidRouteRoute: typeof appStoreInformationBasicStoresHostManagementClubidRouteRouteWithChildren
}

const appStoreInformationBasicStoresRouteRouteChildren: appStoreInformationBasicStoresRouteRouteChildren =
  {
    appStoreInformationBasicStoresManageStoreRouteRoute:
      appStoreInformationBasicStoresManageStoreRouteRouteWithChildren,
    appStoreInformationBasicStoresAddStoreRouteRoute:
      appStoreInformationBasicStoresAddStoreRouteRouteWithChildren,
    appStoreInformationBasicStoresSwitchStoreRouteRoute:
      appStoreInformationBasicStoresSwitchStoreRouteRouteWithChildren,
    appStoreInformationBasicStoresIndexRoute:
      appStoreInformationBasicStoresIndexRoute,
    appStoreInformationBasicStoresHostManagementClubidRouteRoute:
      appStoreInformationBasicStoresHostManagementClubidRouteRouteWithChildren,
  }

const appStoreInformationBasicStoresRouteRouteWithChildren =
  appStoreInformationBasicStoresRouteRoute._addFileChildren(
    appStoreInformationBasicStoresRouteRouteChildren,
  )

interface appStoreInformationPremiumStoresManagePremiumStoreRouteRouteChildren {
  appStoreInformationPremiumStoresManagePremiumStoreIndexRoute: typeof appStoreInformationPremiumStoresManagePremiumStoreIndexRoute
}

const appStoreInformationPremiumStoresManagePremiumStoreRouteRouteChildren: appStoreInformationPremiumStoresManagePremiumStoreRouteRouteChildren =
  {
    appStoreInformationPremiumStoresManagePremiumStoreIndexRoute:
      appStoreInformationPremiumStoresManagePremiumStoreIndexRoute,
  }

const appStoreInformationPremiumStoresManagePremiumStoreRouteRouteWithChildren =
  appStoreInformationPremiumStoresManagePremiumStoreRouteRoute._addFileChildren(
    appStoreInformationPremiumStoresManagePremiumStoreRouteRouteChildren,
  )

interface appStoreInformationPremiumStoresAddPremiumStoreRouteRouteChildren {
  appStoreInformationPremiumStoresAddPremiumStoreIndexRoute: typeof appStoreInformationPremiumStoresAddPremiumStoreIndexRoute
}

const appStoreInformationPremiumStoresAddPremiumStoreRouteRouteChildren: appStoreInformationPremiumStoresAddPremiumStoreRouteRouteChildren =
  {
    appStoreInformationPremiumStoresAddPremiumStoreIndexRoute:
      appStoreInformationPremiumStoresAddPremiumStoreIndexRoute,
  }

const appStoreInformationPremiumStoresAddPremiumStoreRouteRouteWithChildren =
  appStoreInformationPremiumStoresAddPremiumStoreRouteRoute._addFileChildren(
    appStoreInformationPremiumStoresAddPremiumStoreRouteRouteChildren,
  )

interface appStoreInformationPremiumStoresPlanManagementClubidRouteRouteChildren {
  appStoreInformationPremiumStoresPlanManagementClubidIndexRoute: typeof appStoreInformationPremiumStoresPlanManagementClubidIndexRoute
}

const appStoreInformationPremiumStoresPlanManagementClubidRouteRouteChildren: appStoreInformationPremiumStoresPlanManagementClubidRouteRouteChildren =
  {
    appStoreInformationPremiumStoresPlanManagementClubidIndexRoute:
      appStoreInformationPremiumStoresPlanManagementClubidIndexRoute,
  }

const appStoreInformationPremiumStoresPlanManagementClubidRouteRouteWithChildren =
  appStoreInformationPremiumStoresPlanManagementClubidRouteRoute._addFileChildren(
    appStoreInformationPremiumStoresPlanManagementClubidRouteRouteChildren,
  )

interface appStoreInformationPremiumStoresPlanManagementRouteRouteChildren {
  appStoreInformationPremiumStoresPlanManagementClubidRouteRoute: typeof appStoreInformationPremiumStoresPlanManagementClubidRouteRouteWithChildren
}

const appStoreInformationPremiumStoresPlanManagementRouteRouteChildren: appStoreInformationPremiumStoresPlanManagementRouteRouteChildren =
  {
    appStoreInformationPremiumStoresPlanManagementClubidRouteRoute:
      appStoreInformationPremiumStoresPlanManagementClubidRouteRouteWithChildren,
  }

const appStoreInformationPremiumStoresPlanManagementRouteRouteWithChildren =
  appStoreInformationPremiumStoresPlanManagementRouteRoute._addFileChildren(
    appStoreInformationPremiumStoresPlanManagementRouteRouteChildren,
  )

interface appStoreInformationPremiumStoresGalleryStoreGalleryRouteRouteChildren {
  appStoreInformationPremiumStoresGalleryStoreGalleryIndexRoute: typeof appStoreInformationPremiumStoresGalleryStoreGalleryIndexRoute
}

const appStoreInformationPremiumStoresGalleryStoreGalleryRouteRouteChildren: appStoreInformationPremiumStoresGalleryStoreGalleryRouteRouteChildren =
  {
    appStoreInformationPremiumStoresGalleryStoreGalleryIndexRoute:
      appStoreInformationPremiumStoresGalleryStoreGalleryIndexRoute,
  }

const appStoreInformationPremiumStoresGalleryStoreGalleryRouteRouteWithChildren =
  appStoreInformationPremiumStoresGalleryStoreGalleryRouteRoute._addFileChildren(
    appStoreInformationPremiumStoresGalleryStoreGalleryRouteRouteChildren,
  )

interface appStoreInformationPremiumStoresHostManagementClubidManageHostRouteRouteChildren {
  appStoreInformationPremiumStoresHostManagementClubidManageHostIndexRoute: typeof appStoreInformationPremiumStoresHostManagementClubidManageHostIndexRoute
}

const appStoreInformationPremiumStoresHostManagementClubidManageHostRouteRouteChildren: appStoreInformationPremiumStoresHostManagementClubidManageHostRouteRouteChildren =
  {
    appStoreInformationPremiumStoresHostManagementClubidManageHostIndexRoute:
      appStoreInformationPremiumStoresHostManagementClubidManageHostIndexRoute,
  }

const appStoreInformationPremiumStoresHostManagementClubidManageHostRouteRouteWithChildren =
  appStoreInformationPremiumStoresHostManagementClubidManageHostRouteRoute._addFileChildren(
    appStoreInformationPremiumStoresHostManagementClubidManageHostRouteRouteChildren,
  )

interface appStoreInformationPremiumStoresHostManagementClubidAddHostRouteRouteChildren {
  appStoreInformationPremiumStoresHostManagementClubidAddHostIndexRoute: typeof appStoreInformationPremiumStoresHostManagementClubidAddHostIndexRoute
}

const appStoreInformationPremiumStoresHostManagementClubidAddHostRouteRouteChildren: appStoreInformationPremiumStoresHostManagementClubidAddHostRouteRouteChildren =
  {
    appStoreInformationPremiumStoresHostManagementClubidAddHostIndexRoute:
      appStoreInformationPremiumStoresHostManagementClubidAddHostIndexRoute,
  }

const appStoreInformationPremiumStoresHostManagementClubidAddHostRouteRouteWithChildren =
  appStoreInformationPremiumStoresHostManagementClubidAddHostRouteRoute._addFileChildren(
    appStoreInformationPremiumStoresHostManagementClubidAddHostRouteRouteChildren,
  )

interface appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryRouteRouteChildren {
  appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryIndexRoute: typeof appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryIndexRoute
}

const appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryRouteRouteChildren: appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryRouteRouteChildren =
  {
    appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryIndexRoute:
      appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryIndexRoute,
  }

const appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryRouteRouteWithChildren =
  appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryRouteRoute._addFileChildren(
    appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryRouteRouteChildren,
  )

interface appStoreInformationPremiumStoresHostManagementClubidGalleryRouteRouteChildren {
  appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryRouteRoute: typeof appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryRouteRouteWithChildren
}

const appStoreInformationPremiumStoresHostManagementClubidGalleryRouteRouteChildren: appStoreInformationPremiumStoresHostManagementClubidGalleryRouteRouteChildren =
  {
    appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryRouteRoute:
      appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryRouteRouteWithChildren,
  }

const appStoreInformationPremiumStoresHostManagementClubidGalleryRouteRouteWithChildren =
  appStoreInformationPremiumStoresHostManagementClubidGalleryRouteRoute._addFileChildren(
    appStoreInformationPremiumStoresHostManagementClubidGalleryRouteRouteChildren,
  )

interface appStoreInformationPremiumStoresHostManagementClubidRouteRouteChildren {
  appStoreInformationPremiumStoresHostManagementClubidManageHostRouteRoute: typeof appStoreInformationPremiumStoresHostManagementClubidManageHostRouteRouteWithChildren
  appStoreInformationPremiumStoresHostManagementClubidAddHostRouteRoute: typeof appStoreInformationPremiumStoresHostManagementClubidAddHostRouteRouteWithChildren
  appStoreInformationPremiumStoresHostManagementClubidGalleryRouteRoute: typeof appStoreInformationPremiumStoresHostManagementClubidGalleryRouteRouteWithChildren
  appStoreInformationPremiumStoresHostManagementClubidIndexRoute: typeof appStoreInformationPremiumStoresHostManagementClubidIndexRoute
}

const appStoreInformationPremiumStoresHostManagementClubidRouteRouteChildren: appStoreInformationPremiumStoresHostManagementClubidRouteRouteChildren =
  {
    appStoreInformationPremiumStoresHostManagementClubidManageHostRouteRoute:
      appStoreInformationPremiumStoresHostManagementClubidManageHostRouteRouteWithChildren,
    appStoreInformationPremiumStoresHostManagementClubidAddHostRouteRoute:
      appStoreInformationPremiumStoresHostManagementClubidAddHostRouteRouteWithChildren,
    appStoreInformationPremiumStoresHostManagementClubidGalleryRouteRoute:
      appStoreInformationPremiumStoresHostManagementClubidGalleryRouteRouteWithChildren,
    appStoreInformationPremiumStoresHostManagementClubidIndexRoute:
      appStoreInformationPremiumStoresHostManagementClubidIndexRoute,
  }

const appStoreInformationPremiumStoresHostManagementClubidRouteRouteWithChildren =
  appStoreInformationPremiumStoresHostManagementClubidRouteRoute._addFileChildren(
    appStoreInformationPremiumStoresHostManagementClubidRouteRouteChildren,
  )

interface appStoreInformationPremiumStoresHostManagementGalleryHostGalleryRouteRouteChildren {
  appStoreInformationPremiumStoresHostManagementGalleryHostGalleryIndexRoute: typeof appStoreInformationPremiumStoresHostManagementGalleryHostGalleryIndexRoute
}

const appStoreInformationPremiumStoresHostManagementGalleryHostGalleryRouteRouteChildren: appStoreInformationPremiumStoresHostManagementGalleryHostGalleryRouteRouteChildren =
  {
    appStoreInformationPremiumStoresHostManagementGalleryHostGalleryIndexRoute:
      appStoreInformationPremiumStoresHostManagementGalleryHostGalleryIndexRoute,
  }

const appStoreInformationPremiumStoresHostManagementGalleryHostGalleryRouteRouteWithChildren =
  appStoreInformationPremiumStoresHostManagementGalleryHostGalleryRouteRoute._addFileChildren(
    appStoreInformationPremiumStoresHostManagementGalleryHostGalleryRouteRouteChildren,
  )

interface appStoreInformationPremiumStoresHostManagementGalleryRouteRouteChildren {
  appStoreInformationPremiumStoresHostManagementGalleryHostGalleryRouteRoute: typeof appStoreInformationPremiumStoresHostManagementGalleryHostGalleryRouteRouteWithChildren
}

const appStoreInformationPremiumStoresHostManagementGalleryRouteRouteChildren: appStoreInformationPremiumStoresHostManagementGalleryRouteRouteChildren =
  {
    appStoreInformationPremiumStoresHostManagementGalleryHostGalleryRouteRoute:
      appStoreInformationPremiumStoresHostManagementGalleryHostGalleryRouteRouteWithChildren,
  }

const appStoreInformationPremiumStoresHostManagementGalleryRouteRouteWithChildren =
  appStoreInformationPremiumStoresHostManagementGalleryRouteRoute._addFileChildren(
    appStoreInformationPremiumStoresHostManagementGalleryRouteRouteChildren,
  )

interface appStoreInformationPremiumStoresRouteRouteChildren {
  appStoreInformationPremiumStoresManagePremiumStoreRouteRoute: typeof appStoreInformationPremiumStoresManagePremiumStoreRouteRouteWithChildren
  appStoreInformationPremiumStoresAddPremiumStoreRouteRoute: typeof appStoreInformationPremiumStoresAddPremiumStoreRouteRouteWithChildren
  appStoreInformationPremiumStoresPlanManagementRouteRoute: typeof appStoreInformationPremiumStoresPlanManagementRouteRouteWithChildren
  appStoreInformationPremiumStoresIndexRoute: typeof appStoreInformationPremiumStoresIndexRoute
  appStoreInformationPremiumStoresGalleryStoreGalleryRouteRoute: typeof appStoreInformationPremiumStoresGalleryStoreGalleryRouteRouteWithChildren
  appStoreInformationPremiumStoresHostManagementClubidRouteRoute: typeof appStoreInformationPremiumStoresHostManagementClubidRouteRouteWithChildren
  appStoreInformationPremiumStoresHostManagementGalleryRouteRoute: typeof appStoreInformationPremiumStoresHostManagementGalleryRouteRouteWithChildren
}

const appStoreInformationPremiumStoresRouteRouteChildren: appStoreInformationPremiumStoresRouteRouteChildren =
  {
    appStoreInformationPremiumStoresManagePremiumStoreRouteRoute:
      appStoreInformationPremiumStoresManagePremiumStoreRouteRouteWithChildren,
    appStoreInformationPremiumStoresAddPremiumStoreRouteRoute:
      appStoreInformationPremiumStoresAddPremiumStoreRouteRouteWithChildren,
    appStoreInformationPremiumStoresPlanManagementRouteRoute:
      appStoreInformationPremiumStoresPlanManagementRouteRouteWithChildren,
    appStoreInformationPremiumStoresIndexRoute:
      appStoreInformationPremiumStoresIndexRoute,
    appStoreInformationPremiumStoresGalleryStoreGalleryRouteRoute:
      appStoreInformationPremiumStoresGalleryStoreGalleryRouteRouteWithChildren,
    appStoreInformationPremiumStoresHostManagementClubidRouteRoute:
      appStoreInformationPremiumStoresHostManagementClubidRouteRouteWithChildren,
    appStoreInformationPremiumStoresHostManagementGalleryRouteRoute:
      appStoreInformationPremiumStoresHostManagementGalleryRouteRouteWithChildren,
  }

const appStoreInformationPremiumStoresRouteRouteWithChildren =
  appStoreInformationPremiumStoresRouteRoute._addFileChildren(
    appStoreInformationPremiumStoresRouteRouteChildren,
  )

interface appStoreInformationRouteRouteChildren {
  appStoreInformationBasicStoresRouteRoute: typeof appStoreInformationBasicStoresRouteRouteWithChildren
  appStoreInformationPremiumStoresRouteRoute: typeof appStoreInformationPremiumStoresRouteRouteWithChildren
  appStoreInformationSwitchStoreRouteRoute: typeof appStoreInformationSwitchStoreRouteRoute
  appStoreInformationIndexRoute: typeof appStoreInformationIndexRoute
}

const appStoreInformationRouteRouteChildren: appStoreInformationRouteRouteChildren =
  {
    appStoreInformationBasicStoresRouteRoute:
      appStoreInformationBasicStoresRouteRouteWithChildren,
    appStoreInformationPremiumStoresRouteRoute:
      appStoreInformationPremiumStoresRouteRouteWithChildren,
    appStoreInformationSwitchStoreRouteRoute:
      appStoreInformationSwitchStoreRouteRoute,
    appStoreInformationIndexRoute: appStoreInformationIndexRoute,
  }

const appStoreInformationRouteRouteWithChildren =
  appStoreInformationRouteRoute._addFileChildren(
    appStoreInformationRouteRouteChildren,
  )

interface appUsersAdminRouteRouteChildren {
  appUsersAdminIndexRoute: typeof appUsersAdminIndexRoute
}

const appUsersAdminRouteRouteChildren: appUsersAdminRouteRouteChildren = {
  appUsersAdminIndexRoute: appUsersAdminIndexRoute,
}

const appUsersAdminRouteRouteWithChildren =
  appUsersAdminRouteRoute._addFileChildren(appUsersAdminRouteRouteChildren)

interface appUsersAffiliatesRouteRouteChildren {
  appUsersAffiliatesAffiliateIdRoute: typeof appUsersAffiliatesAffiliateIdRoute
  appUsersAffiliatesIndexRoute: typeof appUsersAffiliatesIndexRoute
}

const appUsersAffiliatesRouteRouteChildren: appUsersAffiliatesRouteRouteChildren =
  {
    appUsersAffiliatesAffiliateIdRoute: appUsersAffiliatesAffiliateIdRoute,
    appUsersAffiliatesIndexRoute: appUsersAffiliatesIndexRoute,
  }

const appUsersAffiliatesRouteRouteWithChildren =
  appUsersAffiliatesRouteRoute._addFileChildren(
    appUsersAffiliatesRouteRouteChildren,
  )

interface appUsersCustomersRouteRouteChildren {
  appUsersCustomersCustomerIdRoute: typeof appUsersCustomersCustomerIdRoute
  appUsersCustomersIndexRoute: typeof appUsersCustomersIndexRoute
}

const appUsersCustomersRouteRouteChildren: appUsersCustomersRouteRouteChildren =
  {
    appUsersCustomersCustomerIdRoute: appUsersCustomersCustomerIdRoute,
    appUsersCustomersIndexRoute: appUsersCustomersIndexRoute,
  }

const appUsersCustomersRouteRouteWithChildren =
  appUsersCustomersRouteRoute._addFileChildren(
    appUsersCustomersRouteRouteChildren,
  )

interface appUsersRolesRouteRouteChildren {
  appUsersRolesIndexRoute: typeof appUsersRolesIndexRoute
  appUsersRolesPrivilegeRoleIdRoute: typeof appUsersRolesPrivilegeRoleIdRoute
}

const appUsersRolesRouteRouteChildren: appUsersRolesRouteRouteChildren = {
  appUsersRolesIndexRoute: appUsersRolesIndexRoute,
  appUsersRolesPrivilegeRoleIdRoute: appUsersRolesPrivilegeRoleIdRoute,
}

const appUsersRolesRouteRouteWithChildren =
  appUsersRolesRouteRoute._addFileChildren(appUsersRolesRouteRouteChildren)

interface appUsersStoreOwnersRouteRouteChildren {
  appUsersStoreOwnersIndexRoute: typeof appUsersStoreOwnersIndexRoute
}

const appUsersStoreOwnersRouteRouteChildren: appUsersStoreOwnersRouteRouteChildren =
  {
    appUsersStoreOwnersIndexRoute: appUsersStoreOwnersIndexRoute,
  }

const appUsersStoreOwnersRouteRouteWithChildren =
  appUsersStoreOwnersRouteRoute._addFileChildren(
    appUsersStoreOwnersRouteRouteChildren,
  )

interface appUsersRouteRouteChildren {
  appUsersAdminRouteRoute: typeof appUsersAdminRouteRouteWithChildren
  appUsersAffiliatesRouteRoute: typeof appUsersAffiliatesRouteRouteWithChildren
  appUsersCustomersRouteRoute: typeof appUsersCustomersRouteRouteWithChildren
  appUsersRolesRouteRoute: typeof appUsersRolesRouteRouteWithChildren
  appUsersStoreOwnersRouteRoute: typeof appUsersStoreOwnersRouteRouteWithChildren
  appUsersIndexRoute: typeof appUsersIndexRoute
}

const appUsersRouteRouteChildren: appUsersRouteRouteChildren = {
  appUsersAdminRouteRoute: appUsersAdminRouteRouteWithChildren,
  appUsersAffiliatesRouteRoute: appUsersAffiliatesRouteRouteWithChildren,
  appUsersCustomersRouteRoute: appUsersCustomersRouteRouteWithChildren,
  appUsersRolesRouteRoute: appUsersRolesRouteRouteWithChildren,
  appUsersStoreOwnersRouteRoute: appUsersStoreOwnersRouteRouteWithChildren,
  appUsersIndexRoute: appUsersIndexRoute,
}

const appUsersRouteRouteWithChildren = appUsersRouteRoute._addFileChildren(
  appUsersRouteRouteChildren,
)

interface appRouteRouteChildren {
  appAccountRouteRoute: typeof appAccountRouteRouteWithChildren
  appConfigurationManagementRouteRoute: typeof appConfigurationManagementRouteRouteWithChildren
  appDashboardRouteRoute: typeof appDashboardRouteRouteWithChildren
  appFaqRouteRoute: typeof appFaqRouteRouteWithChildren
  appLogsManagementRouteRoute: typeof appLogsManagementRouteRouteWithChildren
  appPaymentManagementRouteRoute: typeof appPaymentManagementRouteRouteWithChildren
  appPointsManagementRouteRoute: typeof appPointsManagementRouteRouteWithChildren
  appPromosOfferRouteRoute: typeof appPromosOfferRouteRouteWithChildren
  appRecommendationManagementRouteRoute: typeof appRecommendationManagementRouteRouteWithChildren
  appStoreInformationRouteRoute: typeof appStoreInformationRouteRouteWithChildren
  appUsersRouteRoute: typeof appUsersRouteRouteWithChildren
  appForbiddenRoute: typeof appForbiddenRoute
}

const appRouteRouteChildren: appRouteRouteChildren = {
  appAccountRouteRoute: appAccountRouteRouteWithChildren,
  appConfigurationManagementRouteRoute:
    appConfigurationManagementRouteRouteWithChildren,
  appDashboardRouteRoute: appDashboardRouteRouteWithChildren,
  appFaqRouteRoute: appFaqRouteRouteWithChildren,
  appLogsManagementRouteRoute: appLogsManagementRouteRouteWithChildren,
  appPaymentManagementRouteRoute: appPaymentManagementRouteRouteWithChildren,
  appPointsManagementRouteRoute: appPointsManagementRouteRouteWithChildren,
  appPromosOfferRouteRoute: appPromosOfferRouteRouteWithChildren,
  appRecommendationManagementRouteRoute:
    appRecommendationManagementRouteRouteWithChildren,
  appStoreInformationRouteRoute: appStoreInformationRouteRouteWithChildren,
  appUsersRouteRoute: appUsersRouteRouteWithChildren,
  appForbiddenRoute: appForbiddenRoute,
}

const appRouteRouteWithChildren = appRouteRoute._addFileChildren(
  appRouteRouteChildren,
)

interface IndexRouteChildren {
  appRouteRoute: typeof appRouteRouteWithChildren
}

const IndexRouteChildren: IndexRouteChildren = {
  appRouteRoute: appRouteRouteWithChildren,
}

const IndexRouteWithChildren = IndexRoute._addFileChildren(IndexRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof appRouteRouteWithChildren
  '/account': typeof appAccountRouteRouteWithChildren
  '/configuration-management': typeof appConfigurationManagementRouteRouteWithChildren
  '/dashboard': typeof appDashboardRouteRouteWithChildren
  '/faq': typeof appFaqRouteRouteWithChildren
  '/logs-management': typeof appLogsManagementRouteRouteWithChildren
  '/payment-management': typeof appPaymentManagementRouteRouteWithChildren
  '/points-management': typeof appPointsManagementRouteRouteWithChildren
  '/promos-offer': typeof appPromosOfferRouteRouteWithChildren
  '/recommendation-management': typeof appRecommendationManagementRouteRouteWithChildren
  '/store-information': typeof appStoreInformationRouteRouteWithChildren
  '/users': typeof appUsersRouteRouteWithChildren
  '/forbidden': typeof appForbiddenRoute
  '/login': typeof authLoginRoute
  '/account/profile': typeof appAccountProfileRouteRouteWithChildren
  '/configuration-management/charges': typeof appConfigurationManagementChargesRouteRouteWithChildren
  '/configuration-management/commissions': typeof appConfigurationManagementCommissionsRouteRouteWithChildren
  '/configuration-management/discount-management': typeof appConfigurationManagementDiscountManagementRouteRouteWithChildren
  '/configuration-management/group-management': typeof appConfigurationManagementGroupManagementRouteRouteWithChildren
  '/configuration-management/hoslog-plans': typeof appConfigurationManagementHoslogPlansRouteRouteWithChildren
  '/configuration-management/location': typeof appConfigurationManagementLocationRouteRouteWithChildren
  '/configuration-management/withdrawals-setup': typeof appConfigurationManagementWithdrawalsSetupRouteRouteWithChildren
  '/dashboard/conversion-analytics': typeof appDashboardConversionAnalyticsRouteRouteWithChildren
  '/dashboard/referral-reports': typeof appDashboardReferralReportsRouteRouteWithChildren
  '/dashboard/reservation-ledger': typeof appDashboardReservationLedgerRouteRouteWithChildren
  '/faq/complaints': typeof appFaqComplaintsRouteRouteWithChildren
  '/faq/inquiry': typeof appFaqInquiryRouteRouteWithChildren
  '/faq/review-ratings': typeof appFaqReviewRatingsRouteRouteWithChildren
  '/logs-management/email-logs': typeof appLogsManagementEmailLogsRouteRouteWithChildren
  '/logs-management/sms-logs': typeof appLogsManagementSmsLogsRouteRouteWithChildren
  '/logs-management/static-data-type': typeof appLogsManagementStaticDataTypeRouteRouteWithChildren
  '/payment-management/account-information': typeof appPaymentManagementAccountInformationRouteRouteWithChildren
  '/payment-management/affiliate-log': typeof appPaymentManagementAffiliateLogRouteRouteWithChildren
  '/payment-management/customer-payment-logs': typeof appPaymentManagementCustomerPaymentLogsRouteRouteWithChildren
  '/payment-management/overview': typeof appPaymentManagementOverviewRouteRouteWithChildren
  '/payment-management/store-payment-log': typeof appPaymentManagementStorePaymentLogRouteRouteWithChildren
  '/points-management/points-balance-statement': typeof appPointsManagementPointsBalanceStatementRouteRouteWithChildren
  '/points-management/points-configuration': typeof appPointsManagementPointsConfigurationRouteRouteWithChildren
  '/points-management/points-transfer': typeof appPointsManagementPointsTransferRouteRouteWithChildren
  '/points-management/system-transfer': typeof appPointsManagementSystemTransferRouteRouteWithChildren
  '/promos-offer/advertisement': typeof appPromosOfferAdvertisementRouteRouteWithChildren
  '/promos-offer/promotional-banner': typeof appPromosOfferPromotionalBannerRouteRouteWithChildren
  '/recommendation-management/editors-pick': typeof appRecommendationManagementEditorsPickRouteRouteWithChildren
  '/recommendation-management/main-page': typeof appRecommendationManagementMainPageRouteRouteWithChildren
  '/store-information/basic-stores': typeof appStoreInformationBasicStoresRouteRouteWithChildren
  '/store-information/premium-stores': typeof appStoreInformationPremiumStoresRouteRouteWithChildren
  '/store-information/switch-store': typeof appStoreInformationSwitchStoreRouteRoute
  '/users/admin': typeof appUsersAdminRouteRouteWithChildren
  '/users/affiliates': typeof appUsersAffiliatesRouteRouteWithChildren
  '/users/customers': typeof appUsersCustomersRouteRouteWithChildren
  '/users/roles': typeof appUsersRolesRouteRouteWithChildren
  '/users/store-owners': typeof appUsersStoreOwnersRouteRouteWithChildren
  '/account/language': typeof appAccountLanguageRoute
  '/dashboard/overview': typeof appDashboardOverviewRoute
  '/dashboard/sales-performance': typeof appDashboardSalesPerformanceRoute
  '/promos-offer/offer': typeof appPromosOfferOfferRoute
  '/account/': typeof appAccountIndexRoute
  '/configuration-management/': typeof appConfigurationManagementIndexRoute
  '/dashboard/': typeof appDashboardIndexRoute
  '/faq/': typeof appFaqIndexRoute
  '/logs-management/': typeof appLogsManagementIndexRoute
  '/payment-management/': typeof appPaymentManagementIndexRoute
  '/points-management/': typeof appPointsManagementIndexRoute
  '/promos-offer/': typeof appPromosOfferIndexRoute
  '/recommendation-management/': typeof appRecommendationManagementIndexRoute
  '/store-information/': typeof appStoreInformationIndexRoute
  '/users/': typeof appUsersIndexRoute
  '/configuration-management/charges/$categoryId': typeof appConfigurationManagementChargesCategoryIdRouteRouteWithChildren
  '/configuration-management/commissions/$categoryId': typeof appConfigurationManagementCommissionsCategoryIdRouteRouteWithChildren
  '/configuration-management/discount-management/$discountCategory': typeof appConfigurationManagementDiscountManagementDiscountCategoryRouteRouteWithChildren
  '/configuration-management/group-management/$sub-group': typeof appConfigurationManagementGroupManagementSubGroupRouteRouteWithChildren
  '/logs-management/static-data-type/$staticDataTypeName': typeof appLogsManagementStaticDataTypeStaticDataTypeNameRouteRouteWithChildren
  '/payment-management/store-payment-log/$storeId': typeof appPaymentManagementStorePaymentLogStoreIdRouteRouteWithChildren
  '/recommendation-management/main-page/$store-list': typeof appRecommendationManagementMainPageStoreListRouteRouteWithChildren
  '/store-information/basic-stores/$manage-store': typeof appStoreInformationBasicStoresManageStoreRouteRouteWithChildren
  '/store-information/basic-stores/add-store': typeof appStoreInformationBasicStoresAddStoreRouteRouteWithChildren
  '/store-information/basic-stores/switch-store': typeof appStoreInformationBasicStoresSwitchStoreRouteRouteWithChildren
  '/store-information/premium-stores/$manage-premium-store': typeof appStoreInformationPremiumStoresManagePremiumStoreRouteRouteWithChildren
  '/store-information/premium-stores/add-premium-store': typeof appStoreInformationPremiumStoresAddPremiumStoreRouteRouteWithChildren
  '/store-information/premium-stores/plan-management': typeof appStoreInformationPremiumStoresPlanManagementRouteRouteWithChildren
  '/payment-management/admin-payment-setup/add-bank-information': typeof appPaymentManagementAdminPaymentSetupAddBankInformationRoute
  '/payment-management/affiliate-log/$monthly-report': typeof appPaymentManagementAffiliateLogMonthlyReportRoute
  '/users/affiliates/$affiliateId': typeof appUsersAffiliatesAffiliateIdRoute
  '/users/customers/$customerId': typeof appUsersCustomersCustomerIdRoute
  '/account/profile/': typeof appAccountProfileIndexRoute
  '/configuration-management/charges/': typeof appConfigurationManagementChargesIndexRoute
  '/configuration-management/commissions/': typeof appConfigurationManagementCommissionsIndexRoute
  '/configuration-management/discount-management/': typeof appConfigurationManagementDiscountManagementIndexRoute
  '/configuration-management/group-management/': typeof appConfigurationManagementGroupManagementIndexRoute
  '/configuration-management/hoslog-plans/': typeof appConfigurationManagementHoslogPlansIndexRoute
  '/configuration-management/location/': typeof appConfigurationManagementLocationIndexRoute
  '/configuration-management/withdrawals-setup/': typeof appConfigurationManagementWithdrawalsSetupIndexRoute
  '/dashboard/conversion-analytics/': typeof appDashboardConversionAnalyticsIndexRoute
  '/dashboard/referral-reports/': typeof appDashboardReferralReportsIndexRoute
  '/dashboard/reservation-ledger/': typeof appDashboardReservationLedgerIndexRoute
  '/faq/complaints/': typeof appFaqComplaintsIndexRoute
  '/faq/inquiry/': typeof appFaqInquiryIndexRoute
  '/faq/review-ratings/': typeof appFaqReviewRatingsIndexRoute
  '/logs-management/access-logs': typeof appLogsManagementAccessLogsIndexRoute
  '/logs-management/api-logs': typeof appLogsManagementApiLogsIndexRoute
  '/logs-management/email-logs/': typeof appLogsManagementEmailLogsIndexRoute
  '/logs-management/sms-logs/': typeof appLogsManagementSmsLogsIndexRoute
  '/logs-management/static-data-type/': typeof appLogsManagementStaticDataTypeIndexRoute
  '/payment-management/account-information/': typeof appPaymentManagementAccountInformationIndexRoute
  '/payment-management/admin-payment-setup': typeof appPaymentManagementAdminPaymentSetupIndexRoute
  '/payment-management/affiliate-log/': typeof appPaymentManagementAffiliateLogIndexRoute
  '/payment-management/customer-payment-logs/': typeof appPaymentManagementCustomerPaymentLogsIndexRoute
  '/payment-management/overview/': typeof appPaymentManagementOverviewIndexRoute
  '/payment-management/store-payment-log/': typeof appPaymentManagementStorePaymentLogIndexRoute
  '/points-management/points-balance-statement/': typeof appPointsManagementPointsBalanceStatementIndexRoute
  '/points-management/points-configuration/': typeof appPointsManagementPointsConfigurationIndexRoute
  '/points-management/points-request': typeof appPointsManagementPointsRequestIndexRoute
  '/points-management/points-transfer/': typeof appPointsManagementPointsTransferIndexRoute
  '/points-management/system-transfer/': typeof appPointsManagementSystemTransferIndexRoute
  '/promos-offer/advertisement/': typeof appPromosOfferAdvertisementIndexRoute
  '/promos-offer/promotional-banner/': typeof appPromosOfferPromotionalBannerIndexRoute
  '/recommendation-management/editors-pick/': typeof appRecommendationManagementEditorsPickIndexRoute
  '/recommendation-management/main-page/': typeof appRecommendationManagementMainPageIndexRoute
  '/store-information/basic-stores/': typeof appStoreInformationBasicStoresIndexRoute
  '/store-information/premium-stores/': typeof appStoreInformationPremiumStoresIndexRoute
  '/users/admin/': typeof appUsersAdminIndexRoute
  '/users/affiliates/': typeof appUsersAffiliatesIndexRoute
  '/users/customers/': typeof appUsersCustomersIndexRoute
  '/users/roles/': typeof appUsersRolesIndexRoute
  '/users/store-owners/': typeof appUsersStoreOwnersIndexRoute
  '/configuration-management/charges/$categoryId/slabs': typeof appConfigurationManagementChargesCategoryIdSlabsRouteRouteWithChildren
  '/points-management/points-configuration/customer/$programId': typeof appPointsManagementPointsConfigurationCustomerProgramIdRouteRouteWithChildren
  '/recommendation-management/main-page/$store-list/$host-list': typeof appRecommendationManagementMainPageStoreListHostListRouteRouteWithChildren
  '/store-information/basic-stores/host-management/$clubid': typeof appStoreInformationBasicStoresHostManagementClubidRouteRouteWithChildren
  '/store-information/premium-stores/gallery/$store-gallery': typeof appStoreInformationPremiumStoresGalleryStoreGalleryRouteRouteWithChildren
  '/store-information/premium-stores/host-management/$clubid': typeof appStoreInformationPremiumStoresHostManagementClubidRouteRouteWithChildren
  '/store-information/premium-stores/host-management/gallery': typeof appStoreInformationPremiumStoresHostManagementGalleryRouteRouteWithChildren
  '/store-information/premium-stores/plan-management/$clubid': typeof appStoreInformationPremiumStoresPlanManagementClubidRouteRouteWithChildren
  '/configuration-management/group-management/$sub-group/$club-gallery': typeof appConfigurationManagementGroupManagementSubGroupClubGalleryRoute
  '/users/roles/privilege/$roleId': typeof appUsersRolesPrivilegeRoleIdRoute
  '/configuration-management/charges/$categoryId/': typeof appConfigurationManagementChargesCategoryIdIndexRoute
  '/configuration-management/commissions/$categoryId/': typeof appConfigurationManagementCommissionsCategoryIdIndexRoute
  '/configuration-management/discount-management/$discountCategory/': typeof appConfigurationManagementDiscountManagementDiscountCategoryIndexRoute
  '/configuration-management/group-management/$sub-group/': typeof appConfigurationManagementGroupManagementSubGroupIndexRoute
  '/logs-management/static-data-type/$staticDataTypeName/': typeof appLogsManagementStaticDataTypeStaticDataTypeNameIndexRoute
  '/payment-management/store-payment-log/$storeId/': typeof appPaymentManagementStorePaymentLogStoreIdIndexRoute
  '/recommendation-management/main-page/$store-list/': typeof appRecommendationManagementMainPageStoreListIndexRoute
  '/store-information/basic-stores/$manage-store/': typeof appStoreInformationBasicStoresManageStoreIndexRoute
  '/store-information/basic-stores/add-store/': typeof appStoreInformationBasicStoresAddStoreIndexRoute
  '/store-information/premium-stores/$manage-premium-store/': typeof appStoreInformationPremiumStoresManagePremiumStoreIndexRoute
  '/store-information/premium-stores/add-premium-store/': typeof appStoreInformationPremiumStoresAddPremiumStoreIndexRoute
  '/store-information/basic-stores/host-management/$clubid/$manage-host': typeof appStoreInformationBasicStoresHostManagementClubidManageHostRouteRouteWithChildren
  '/store-information/basic-stores/host-management/$clubid/add-host': typeof appStoreInformationBasicStoresHostManagementClubidAddHostRouteRouteWithChildren
  '/store-information/basic-stores/host-management/$clubid/gallery': typeof appStoreInformationBasicStoresHostManagementClubidGalleryRouteRouteWithChildren
  '/store-information/premium-stores/host-management/$clubid/$manage-host': typeof appStoreInformationPremiumStoresHostManagementClubidManageHostRouteRouteWithChildren
  '/store-information/premium-stores/host-management/$clubid/add-host': typeof appStoreInformationPremiumStoresHostManagementClubidAddHostRouteRouteWithChildren
  '/store-information/premium-stores/host-management/$clubid/gallery': typeof appStoreInformationPremiumStoresHostManagementClubidGalleryRouteRouteWithChildren
  '/store-information/premium-stores/host-management/gallery/$host-gallery': typeof appStoreInformationPremiumStoresHostManagementGalleryHostGalleryRouteRouteWithChildren
  '/points-management/points-configuration/affiliate/$pointCategoryId/slabs': typeof appPointsManagementPointsConfigurationAffiliatePointCategoryIdSlabsRoute
  '/configuration-management/charges/$categoryId/slabs/': typeof appConfigurationManagementChargesCategoryIdSlabsIndexRoute
  '/dashboard/referral-reports/$reportType/$referrerId': typeof appDashboardReferralReportsReportTypeReferrerIdIndexRoute
  '/points-management/points-configuration/customer/$programId/': typeof appPointsManagementPointsConfigurationCustomerProgramIdIndexRoute
  '/recommendation-management/main-page/$store-list/$host-list/': typeof appRecommendationManagementMainPageStoreListHostListIndexRoute
  '/store-information/basic-stores/host-management/$clubid/': typeof appStoreInformationBasicStoresHostManagementClubidIndexRoute
  '/store-information/basic-stores/switch-store/$id': typeof appStoreInformationBasicStoresSwitchStoreIdIndexRoute
  '/store-information/premium-stores/gallery/$store-gallery/': typeof appStoreInformationPremiumStoresGalleryStoreGalleryIndexRoute
  '/store-information/premium-stores/host-management/$clubid/': typeof appStoreInformationPremiumStoresHostManagementClubidIndexRoute
  '/store-information/premium-stores/plan-management/$clubid/': typeof appStoreInformationPremiumStoresPlanManagementClubidIndexRoute
  '/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery': typeof appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryRouteRouteWithChildren
  '/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery': typeof appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryRouteRouteWithChildren
  '/store-information/basic-stores/host-management/$clubid/$manage-host/': typeof appStoreInformationBasicStoresHostManagementClubidManageHostIndexRoute
  '/store-information/basic-stores/host-management/$clubid/add-host/': typeof appStoreInformationBasicStoresHostManagementClubidAddHostIndexRoute
  '/store-information/premium-stores/host-management/$clubid/$manage-host/': typeof appStoreInformationPremiumStoresHostManagementClubidManageHostIndexRoute
  '/store-information/premium-stores/host-management/$clubid/add-host/': typeof appStoreInformationPremiumStoresHostManagementClubidAddHostIndexRoute
  '/store-information/premium-stores/host-management/gallery/$host-gallery/': typeof appStoreInformationPremiumStoresHostManagementGalleryHostGalleryIndexRoute
  '/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery/': typeof appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryIndexRoute
  '/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery/': typeof appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof appRouteRouteWithChildren
  '/forbidden': typeof appForbiddenRoute
  '/login': typeof authLoginRoute
  '/store-information/switch-store': typeof appStoreInformationSwitchStoreRouteRoute
  '/account/language': typeof appAccountLanguageRoute
  '/dashboard/overview': typeof appDashboardOverviewRoute
  '/dashboard/sales-performance': typeof appDashboardSalesPerformanceRoute
  '/promos-offer/offer': typeof appPromosOfferOfferRoute
  '/account': typeof appAccountIndexRoute
  '/configuration-management': typeof appConfigurationManagementIndexRoute
  '/dashboard': typeof appDashboardIndexRoute
  '/faq': typeof appFaqIndexRoute
  '/logs-management': typeof appLogsManagementIndexRoute
  '/payment-management': typeof appPaymentManagementIndexRoute
  '/points-management': typeof appPointsManagementIndexRoute
  '/promos-offer': typeof appPromosOfferIndexRoute
  '/recommendation-management': typeof appRecommendationManagementIndexRoute
  '/store-information': typeof appStoreInformationIndexRoute
  '/users': typeof appUsersIndexRoute
  '/store-information/basic-stores/switch-store': typeof appStoreInformationBasicStoresSwitchStoreRouteRouteWithChildren
  '/store-information/premium-stores/plan-management': typeof appStoreInformationPremiumStoresPlanManagementRouteRouteWithChildren
  '/payment-management/admin-payment-setup/add-bank-information': typeof appPaymentManagementAdminPaymentSetupAddBankInformationRoute
  '/payment-management/affiliate-log/$monthly-report': typeof appPaymentManagementAffiliateLogMonthlyReportRoute
  '/users/affiliates/$affiliateId': typeof appUsersAffiliatesAffiliateIdRoute
  '/users/customers/$customerId': typeof appUsersCustomersCustomerIdRoute
  '/account/profile': typeof appAccountProfileIndexRoute
  '/configuration-management/charges': typeof appConfigurationManagementChargesIndexRoute
  '/configuration-management/commissions': typeof appConfigurationManagementCommissionsIndexRoute
  '/configuration-management/discount-management': typeof appConfigurationManagementDiscountManagementIndexRoute
  '/configuration-management/group-management': typeof appConfigurationManagementGroupManagementIndexRoute
  '/configuration-management/hoslog-plans': typeof appConfigurationManagementHoslogPlansIndexRoute
  '/configuration-management/location': typeof appConfigurationManagementLocationIndexRoute
  '/configuration-management/withdrawals-setup': typeof appConfigurationManagementWithdrawalsSetupIndexRoute
  '/dashboard/conversion-analytics': typeof appDashboardConversionAnalyticsIndexRoute
  '/dashboard/referral-reports': typeof appDashboardReferralReportsIndexRoute
  '/dashboard/reservation-ledger': typeof appDashboardReservationLedgerIndexRoute
  '/faq/complaints': typeof appFaqComplaintsIndexRoute
  '/faq/inquiry': typeof appFaqInquiryIndexRoute
  '/faq/review-ratings': typeof appFaqReviewRatingsIndexRoute
  '/logs-management/access-logs': typeof appLogsManagementAccessLogsIndexRoute
  '/logs-management/api-logs': typeof appLogsManagementApiLogsIndexRoute
  '/logs-management/email-logs': typeof appLogsManagementEmailLogsIndexRoute
  '/logs-management/sms-logs': typeof appLogsManagementSmsLogsIndexRoute
  '/logs-management/static-data-type': typeof appLogsManagementStaticDataTypeIndexRoute
  '/payment-management/account-information': typeof appPaymentManagementAccountInformationIndexRoute
  '/payment-management/admin-payment-setup': typeof appPaymentManagementAdminPaymentSetupIndexRoute
  '/payment-management/affiliate-log': typeof appPaymentManagementAffiliateLogIndexRoute
  '/payment-management/customer-payment-logs': typeof appPaymentManagementCustomerPaymentLogsIndexRoute
  '/payment-management/overview': typeof appPaymentManagementOverviewIndexRoute
  '/payment-management/store-payment-log': typeof appPaymentManagementStorePaymentLogIndexRoute
  '/points-management/points-balance-statement': typeof appPointsManagementPointsBalanceStatementIndexRoute
  '/points-management/points-configuration': typeof appPointsManagementPointsConfigurationIndexRoute
  '/points-management/points-request': typeof appPointsManagementPointsRequestIndexRoute
  '/points-management/points-transfer': typeof appPointsManagementPointsTransferIndexRoute
  '/points-management/system-transfer': typeof appPointsManagementSystemTransferIndexRoute
  '/promos-offer/advertisement': typeof appPromosOfferAdvertisementIndexRoute
  '/promos-offer/promotional-banner': typeof appPromosOfferPromotionalBannerIndexRoute
  '/recommendation-management/editors-pick': typeof appRecommendationManagementEditorsPickIndexRoute
  '/recommendation-management/main-page': typeof appRecommendationManagementMainPageIndexRoute
  '/store-information/basic-stores': typeof appStoreInformationBasicStoresIndexRoute
  '/store-information/premium-stores': typeof appStoreInformationPremiumStoresIndexRoute
  '/users/admin': typeof appUsersAdminIndexRoute
  '/users/affiliates': typeof appUsersAffiliatesIndexRoute
  '/users/customers': typeof appUsersCustomersIndexRoute
  '/users/roles': typeof appUsersRolesIndexRoute
  '/users/store-owners': typeof appUsersStoreOwnersIndexRoute
  '/store-information/premium-stores/host-management/gallery': typeof appStoreInformationPremiumStoresHostManagementGalleryRouteRouteWithChildren
  '/configuration-management/group-management/$sub-group/$club-gallery': typeof appConfigurationManagementGroupManagementSubGroupClubGalleryRoute
  '/users/roles/privilege/$roleId': typeof appUsersRolesPrivilegeRoleIdRoute
  '/configuration-management/charges/$categoryId': typeof appConfigurationManagementChargesCategoryIdIndexRoute
  '/configuration-management/commissions/$categoryId': typeof appConfigurationManagementCommissionsCategoryIdIndexRoute
  '/configuration-management/discount-management/$discountCategory': typeof appConfigurationManagementDiscountManagementDiscountCategoryIndexRoute
  '/configuration-management/group-management/$sub-group': typeof appConfigurationManagementGroupManagementSubGroupIndexRoute
  '/logs-management/static-data-type/$staticDataTypeName': typeof appLogsManagementStaticDataTypeStaticDataTypeNameIndexRoute
  '/payment-management/store-payment-log/$storeId': typeof appPaymentManagementStorePaymentLogStoreIdIndexRoute
  '/recommendation-management/main-page/$store-list': typeof appRecommendationManagementMainPageStoreListIndexRoute
  '/store-information/basic-stores/$manage-store': typeof appStoreInformationBasicStoresManageStoreIndexRoute
  '/store-information/basic-stores/add-store': typeof appStoreInformationBasicStoresAddStoreIndexRoute
  '/store-information/premium-stores/$manage-premium-store': typeof appStoreInformationPremiumStoresManagePremiumStoreIndexRoute
  '/store-information/premium-stores/add-premium-store': typeof appStoreInformationPremiumStoresAddPremiumStoreIndexRoute
  '/store-information/basic-stores/host-management/$clubid/gallery': typeof appStoreInformationBasicStoresHostManagementClubidGalleryRouteRouteWithChildren
  '/store-information/premium-stores/host-management/$clubid/gallery': typeof appStoreInformationPremiumStoresHostManagementClubidGalleryRouteRouteWithChildren
  '/points-management/points-configuration/affiliate/$pointCategoryId/slabs': typeof appPointsManagementPointsConfigurationAffiliatePointCategoryIdSlabsRoute
  '/configuration-management/charges/$categoryId/slabs': typeof appConfigurationManagementChargesCategoryIdSlabsIndexRoute
  '/dashboard/referral-reports/$reportType/$referrerId': typeof appDashboardReferralReportsReportTypeReferrerIdIndexRoute
  '/points-management/points-configuration/customer/$programId': typeof appPointsManagementPointsConfigurationCustomerProgramIdIndexRoute
  '/recommendation-management/main-page/$store-list/$host-list': typeof appRecommendationManagementMainPageStoreListHostListIndexRoute
  '/store-information/basic-stores/host-management/$clubid': typeof appStoreInformationBasicStoresHostManagementClubidIndexRoute
  '/store-information/basic-stores/switch-store/$id': typeof appStoreInformationBasicStoresSwitchStoreIdIndexRoute
  '/store-information/premium-stores/gallery/$store-gallery': typeof appStoreInformationPremiumStoresGalleryStoreGalleryIndexRoute
  '/store-information/premium-stores/host-management/$clubid': typeof appStoreInformationPremiumStoresHostManagementClubidIndexRoute
  '/store-information/premium-stores/plan-management/$clubid': typeof appStoreInformationPremiumStoresPlanManagementClubidIndexRoute
  '/store-information/basic-stores/host-management/$clubid/$manage-host': typeof appStoreInformationBasicStoresHostManagementClubidManageHostIndexRoute
  '/store-information/basic-stores/host-management/$clubid/add-host': typeof appStoreInformationBasicStoresHostManagementClubidAddHostIndexRoute
  '/store-information/premium-stores/host-management/$clubid/$manage-host': typeof appStoreInformationPremiumStoresHostManagementClubidManageHostIndexRoute
  '/store-information/premium-stores/host-management/$clubid/add-host': typeof appStoreInformationPremiumStoresHostManagementClubidAddHostIndexRoute
  '/store-information/premium-stores/host-management/gallery/$host-gallery': typeof appStoreInformationPremiumStoresHostManagementGalleryHostGalleryIndexRoute
  '/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery': typeof appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryIndexRoute
  '/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery': typeof appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRouteWithChildren
  '/(app)': typeof appRouteRouteWithChildren
  '/(app)/account': typeof appAccountRouteRouteWithChildren
  '/(app)/configuration-management': typeof appConfigurationManagementRouteRouteWithChildren
  '/(app)/dashboard': typeof appDashboardRouteRouteWithChildren
  '/(app)/faq': typeof appFaqRouteRouteWithChildren
  '/(app)/logs-management': typeof appLogsManagementRouteRouteWithChildren
  '/(app)/payment-management': typeof appPaymentManagementRouteRouteWithChildren
  '/(app)/points-management': typeof appPointsManagementRouteRouteWithChildren
  '/(app)/promos-offer': typeof appPromosOfferRouteRouteWithChildren
  '/(app)/recommendation-management': typeof appRecommendationManagementRouteRouteWithChildren
  '/(app)/store-information': typeof appStoreInformationRouteRouteWithChildren
  '/(app)/users': typeof appUsersRouteRouteWithChildren
  '/(app)/forbidden': typeof appForbiddenRoute
  '/(auth)/login': typeof authLoginRoute
  '/(app)/account/profile': typeof appAccountProfileRouteRouteWithChildren
  '/(app)/configuration-management/charges': typeof appConfigurationManagementChargesRouteRouteWithChildren
  '/(app)/configuration-management/commissions': typeof appConfigurationManagementCommissionsRouteRouteWithChildren
  '/(app)/configuration-management/discount-management': typeof appConfigurationManagementDiscountManagementRouteRouteWithChildren
  '/(app)/configuration-management/group-management': typeof appConfigurationManagementGroupManagementRouteRouteWithChildren
  '/(app)/configuration-management/hoslog-plans': typeof appConfigurationManagementHoslogPlansRouteRouteWithChildren
  '/(app)/configuration-management/location': typeof appConfigurationManagementLocationRouteRouteWithChildren
  '/(app)/configuration-management/withdrawals-setup': typeof appConfigurationManagementWithdrawalsSetupRouteRouteWithChildren
  '/(app)/dashboard/conversion-analytics': typeof appDashboardConversionAnalyticsRouteRouteWithChildren
  '/(app)/dashboard/referral-reports': typeof appDashboardReferralReportsRouteRouteWithChildren
  '/(app)/dashboard/reservation-ledger': typeof appDashboardReservationLedgerRouteRouteWithChildren
  '/(app)/faq/complaints': typeof appFaqComplaintsRouteRouteWithChildren
  '/(app)/faq/inquiry': typeof appFaqInquiryRouteRouteWithChildren
  '/(app)/faq/review-ratings': typeof appFaqReviewRatingsRouteRouteWithChildren
  '/(app)/logs-management/email-logs': typeof appLogsManagementEmailLogsRouteRouteWithChildren
  '/(app)/logs-management/sms-logs': typeof appLogsManagementSmsLogsRouteRouteWithChildren
  '/(app)/logs-management/static-data-type': typeof appLogsManagementStaticDataTypeRouteRouteWithChildren
  '/(app)/payment-management/account-information': typeof appPaymentManagementAccountInformationRouteRouteWithChildren
  '/(app)/payment-management/affiliate-log': typeof appPaymentManagementAffiliateLogRouteRouteWithChildren
  '/(app)/payment-management/customer-payment-logs': typeof appPaymentManagementCustomerPaymentLogsRouteRouteWithChildren
  '/(app)/payment-management/overview': typeof appPaymentManagementOverviewRouteRouteWithChildren
  '/(app)/payment-management/store-payment-log': typeof appPaymentManagementStorePaymentLogRouteRouteWithChildren
  '/(app)/points-management/points-balance-statement': typeof appPointsManagementPointsBalanceStatementRouteRouteWithChildren
  '/(app)/points-management/points-configuration': typeof appPointsManagementPointsConfigurationRouteRouteWithChildren
  '/(app)/points-management/points-transfer': typeof appPointsManagementPointsTransferRouteRouteWithChildren
  '/(app)/points-management/system-transfer': typeof appPointsManagementSystemTransferRouteRouteWithChildren
  '/(app)/promos-offer/advertisement': typeof appPromosOfferAdvertisementRouteRouteWithChildren
  '/(app)/promos-offer/promotional-banner': typeof appPromosOfferPromotionalBannerRouteRouteWithChildren
  '/(app)/recommendation-management/editors-pick': typeof appRecommendationManagementEditorsPickRouteRouteWithChildren
  '/(app)/recommendation-management/main-page': typeof appRecommendationManagementMainPageRouteRouteWithChildren
  '/(app)/store-information/basic-stores': typeof appStoreInformationBasicStoresRouteRouteWithChildren
  '/(app)/store-information/premium-stores': typeof appStoreInformationPremiumStoresRouteRouteWithChildren
  '/(app)/store-information/switch-store': typeof appStoreInformationSwitchStoreRouteRoute
  '/(app)/users/admin': typeof appUsersAdminRouteRouteWithChildren
  '/(app)/users/affiliates': typeof appUsersAffiliatesRouteRouteWithChildren
  '/(app)/users/customers': typeof appUsersCustomersRouteRouteWithChildren
  '/(app)/users/roles': typeof appUsersRolesRouteRouteWithChildren
  '/(app)/users/store-owners': typeof appUsersStoreOwnersRouteRouteWithChildren
  '/(app)/account/language': typeof appAccountLanguageRoute
  '/(app)/dashboard/overview': typeof appDashboardOverviewRoute
  '/(app)/dashboard/sales-performance': typeof appDashboardSalesPerformanceRoute
  '/(app)/promos-offer/offer': typeof appPromosOfferOfferRoute
  '/(app)/account/': typeof appAccountIndexRoute
  '/(app)/configuration-management/': typeof appConfigurationManagementIndexRoute
  '/(app)/dashboard/': typeof appDashboardIndexRoute
  '/(app)/faq/': typeof appFaqIndexRoute
  '/(app)/logs-management/': typeof appLogsManagementIndexRoute
  '/(app)/payment-management/': typeof appPaymentManagementIndexRoute
  '/(app)/points-management/': typeof appPointsManagementIndexRoute
  '/(app)/promos-offer/': typeof appPromosOfferIndexRoute
  '/(app)/recommendation-management/': typeof appRecommendationManagementIndexRoute
  '/(app)/store-information/': typeof appStoreInformationIndexRoute
  '/(app)/users/': typeof appUsersIndexRoute
  '/(app)/configuration-management/charges/$categoryId': typeof appConfigurationManagementChargesCategoryIdRouteRouteWithChildren
  '/(app)/configuration-management/commissions/$categoryId': typeof appConfigurationManagementCommissionsCategoryIdRouteRouteWithChildren
  '/(app)/configuration-management/discount-management/$discountCategory': typeof appConfigurationManagementDiscountManagementDiscountCategoryRouteRouteWithChildren
  '/(app)/configuration-management/group-management/$sub-group': typeof appConfigurationManagementGroupManagementSubGroupRouteRouteWithChildren
  '/(app)/logs-management/static-data-type/$staticDataTypeName': typeof appLogsManagementStaticDataTypeStaticDataTypeNameRouteRouteWithChildren
  '/(app)/payment-management/store-payment-log/$storeId': typeof appPaymentManagementStorePaymentLogStoreIdRouteRouteWithChildren
  '/(app)/recommendation-management/main-page/$store-list': typeof appRecommendationManagementMainPageStoreListRouteRouteWithChildren
  '/(app)/store-information/basic-stores/$manage-store': typeof appStoreInformationBasicStoresManageStoreRouteRouteWithChildren
  '/(app)/store-information/basic-stores/add-store': typeof appStoreInformationBasicStoresAddStoreRouteRouteWithChildren
  '/(app)/store-information/basic-stores/switch-store': typeof appStoreInformationBasicStoresSwitchStoreRouteRouteWithChildren
  '/(app)/store-information/premium-stores/$manage-premium-store': typeof appStoreInformationPremiumStoresManagePremiumStoreRouteRouteWithChildren
  '/(app)/store-information/premium-stores/add-premium-store': typeof appStoreInformationPremiumStoresAddPremiumStoreRouteRouteWithChildren
  '/(app)/store-information/premium-stores/plan-management': typeof appStoreInformationPremiumStoresPlanManagementRouteRouteWithChildren
  '/(app)/payment-management/admin-payment-setup/add-bank-information': typeof appPaymentManagementAdminPaymentSetupAddBankInformationRoute
  '/(app)/payment-management/affiliate-log/$monthly-report': typeof appPaymentManagementAffiliateLogMonthlyReportRoute
  '/(app)/users/affiliates/$affiliateId': typeof appUsersAffiliatesAffiliateIdRoute
  '/(app)/users/customers/$customerId': typeof appUsersCustomersCustomerIdRoute
  '/(app)/account/profile/': typeof appAccountProfileIndexRoute
  '/(app)/configuration-management/charges/': typeof appConfigurationManagementChargesIndexRoute
  '/(app)/configuration-management/commissions/': typeof appConfigurationManagementCommissionsIndexRoute
  '/(app)/configuration-management/discount-management/': typeof appConfigurationManagementDiscountManagementIndexRoute
  '/(app)/configuration-management/group-management/': typeof appConfigurationManagementGroupManagementIndexRoute
  '/(app)/configuration-management/hoslog-plans/': typeof appConfigurationManagementHoslogPlansIndexRoute
  '/(app)/configuration-management/location/': typeof appConfigurationManagementLocationIndexRoute
  '/(app)/configuration-management/withdrawals-setup/': typeof appConfigurationManagementWithdrawalsSetupIndexRoute
  '/(app)/dashboard/conversion-analytics/': typeof appDashboardConversionAnalyticsIndexRoute
  '/(app)/dashboard/referral-reports/': typeof appDashboardReferralReportsIndexRoute
  '/(app)/dashboard/reservation-ledger/': typeof appDashboardReservationLedgerIndexRoute
  '/(app)/faq/complaints/': typeof appFaqComplaintsIndexRoute
  '/(app)/faq/inquiry/': typeof appFaqInquiryIndexRoute
  '/(app)/faq/review-ratings/': typeof appFaqReviewRatingsIndexRoute
  '/(app)/logs-management/access-logs/': typeof appLogsManagementAccessLogsIndexRoute
  '/(app)/logs-management/api-logs/': typeof appLogsManagementApiLogsIndexRoute
  '/(app)/logs-management/email-logs/': typeof appLogsManagementEmailLogsIndexRoute
  '/(app)/logs-management/sms-logs/': typeof appLogsManagementSmsLogsIndexRoute
  '/(app)/logs-management/static-data-type/': typeof appLogsManagementStaticDataTypeIndexRoute
  '/(app)/payment-management/account-information/': typeof appPaymentManagementAccountInformationIndexRoute
  '/(app)/payment-management/admin-payment-setup/': typeof appPaymentManagementAdminPaymentSetupIndexRoute
  '/(app)/payment-management/affiliate-log/': typeof appPaymentManagementAffiliateLogIndexRoute
  '/(app)/payment-management/customer-payment-logs/': typeof appPaymentManagementCustomerPaymentLogsIndexRoute
  '/(app)/payment-management/overview/': typeof appPaymentManagementOverviewIndexRoute
  '/(app)/payment-management/store-payment-log/': typeof appPaymentManagementStorePaymentLogIndexRoute
  '/(app)/points-management/points-balance-statement/': typeof appPointsManagementPointsBalanceStatementIndexRoute
  '/(app)/points-management/points-configuration/': typeof appPointsManagementPointsConfigurationIndexRoute
  '/(app)/points-management/points-request/': typeof appPointsManagementPointsRequestIndexRoute
  '/(app)/points-management/points-transfer/': typeof appPointsManagementPointsTransferIndexRoute
  '/(app)/points-management/system-transfer/': typeof appPointsManagementSystemTransferIndexRoute
  '/(app)/promos-offer/advertisement/': typeof appPromosOfferAdvertisementIndexRoute
  '/(app)/promos-offer/promotional-banner/': typeof appPromosOfferPromotionalBannerIndexRoute
  '/(app)/recommendation-management/editors-pick/': typeof appRecommendationManagementEditorsPickIndexRoute
  '/(app)/recommendation-management/main-page/': typeof appRecommendationManagementMainPageIndexRoute
  '/(app)/store-information/basic-stores/': typeof appStoreInformationBasicStoresIndexRoute
  '/(app)/store-information/premium-stores/': typeof appStoreInformationPremiumStoresIndexRoute
  '/(app)/users/admin/': typeof appUsersAdminIndexRoute
  '/(app)/users/affiliates/': typeof appUsersAffiliatesIndexRoute
  '/(app)/users/customers/': typeof appUsersCustomersIndexRoute
  '/(app)/users/roles/': typeof appUsersRolesIndexRoute
  '/(app)/users/store-owners/': typeof appUsersStoreOwnersIndexRoute
  '/(app)/configuration-management/charges/$categoryId/slabs': typeof appConfigurationManagementChargesCategoryIdSlabsRouteRouteWithChildren
  '/(app)/points-management/points-configuration/customer/$programId': typeof appPointsManagementPointsConfigurationCustomerProgramIdRouteRouteWithChildren
  '/(app)/recommendation-management/main-page/$store-list/$host-list': typeof appRecommendationManagementMainPageStoreListHostListRouteRouteWithChildren
  '/(app)/store-information/basic-stores/host-management/$clubid': typeof appStoreInformationBasicStoresHostManagementClubidRouteRouteWithChildren
  '/(app)/store-information/premium-stores/gallery/$store-gallery': typeof appStoreInformationPremiumStoresGalleryStoreGalleryRouteRouteWithChildren
  '/(app)/store-information/premium-stores/host-management/$clubid': typeof appStoreInformationPremiumStoresHostManagementClubidRouteRouteWithChildren
  '/(app)/store-information/premium-stores/host-management/gallery': typeof appStoreInformationPremiumStoresHostManagementGalleryRouteRouteWithChildren
  '/(app)/store-information/premium-stores/plan-management/$clubid': typeof appStoreInformationPremiumStoresPlanManagementClubidRouteRouteWithChildren
  '/(app)/configuration-management/group-management/$sub-group/$club-gallery': typeof appConfigurationManagementGroupManagementSubGroupClubGalleryRoute
  '/(app)/users/roles/privilege/$roleId': typeof appUsersRolesPrivilegeRoleIdRoute
  '/(app)/configuration-management/charges/$categoryId/': typeof appConfigurationManagementChargesCategoryIdIndexRoute
  '/(app)/configuration-management/commissions/$categoryId/': typeof appConfigurationManagementCommissionsCategoryIdIndexRoute
  '/(app)/configuration-management/discount-management/$discountCategory/': typeof appConfigurationManagementDiscountManagementDiscountCategoryIndexRoute
  '/(app)/configuration-management/group-management/$sub-group/': typeof appConfigurationManagementGroupManagementSubGroupIndexRoute
  '/(app)/logs-management/static-data-type/$staticDataTypeName/': typeof appLogsManagementStaticDataTypeStaticDataTypeNameIndexRoute
  '/(app)/payment-management/store-payment-log/$storeId/': typeof appPaymentManagementStorePaymentLogStoreIdIndexRoute
  '/(app)/recommendation-management/main-page/$store-list/': typeof appRecommendationManagementMainPageStoreListIndexRoute
  '/(app)/store-information/basic-stores/$manage-store/': typeof appStoreInformationBasicStoresManageStoreIndexRoute
  '/(app)/store-information/basic-stores/add-store/': typeof appStoreInformationBasicStoresAddStoreIndexRoute
  '/(app)/store-information/premium-stores/$manage-premium-store/': typeof appStoreInformationPremiumStoresManagePremiumStoreIndexRoute
  '/(app)/store-information/premium-stores/add-premium-store/': typeof appStoreInformationPremiumStoresAddPremiumStoreIndexRoute
  '/(app)/store-information/basic-stores/host-management/$clubid/$manage-host': typeof appStoreInformationBasicStoresHostManagementClubidManageHostRouteRouteWithChildren
  '/(app)/store-information/basic-stores/host-management/$clubid/add-host': typeof appStoreInformationBasicStoresHostManagementClubidAddHostRouteRouteWithChildren
  '/(app)/store-information/basic-stores/host-management/$clubid/gallery': typeof appStoreInformationBasicStoresHostManagementClubidGalleryRouteRouteWithChildren
  '/(app)/store-information/premium-stores/host-management/$clubid/$manage-host': typeof appStoreInformationPremiumStoresHostManagementClubidManageHostRouteRouteWithChildren
  '/(app)/store-information/premium-stores/host-management/$clubid/add-host': typeof appStoreInformationPremiumStoresHostManagementClubidAddHostRouteRouteWithChildren
  '/(app)/store-information/premium-stores/host-management/$clubid/gallery': typeof appStoreInformationPremiumStoresHostManagementClubidGalleryRouteRouteWithChildren
  '/(app)/store-information/premium-stores/host-management/gallery/$host-gallery': typeof appStoreInformationPremiumStoresHostManagementGalleryHostGalleryRouteRouteWithChildren
  '/(app)/points-management/points-configuration/affiliate/$pointCategoryId/slabs': typeof appPointsManagementPointsConfigurationAffiliatePointCategoryIdSlabsRoute
  '/(app)/configuration-management/charges/$categoryId/slabs/': typeof appConfigurationManagementChargesCategoryIdSlabsIndexRoute
  '/(app)/dashboard/referral-reports/$reportType/$referrerId/': typeof appDashboardReferralReportsReportTypeReferrerIdIndexRoute
  '/(app)/points-management/points-configuration/customer/$programId/': typeof appPointsManagementPointsConfigurationCustomerProgramIdIndexRoute
  '/(app)/recommendation-management/main-page/$store-list/$host-list/': typeof appRecommendationManagementMainPageStoreListHostListIndexRoute
  '/(app)/store-information/basic-stores/host-management/$clubid/': typeof appStoreInformationBasicStoresHostManagementClubidIndexRoute
  '/(app)/store-information/basic-stores/switch-store/$id/': typeof appStoreInformationBasicStoresSwitchStoreIdIndexRoute
  '/(app)/store-information/premium-stores/gallery/$store-gallery/': typeof appStoreInformationPremiumStoresGalleryStoreGalleryIndexRoute
  '/(app)/store-information/premium-stores/host-management/$clubid/': typeof appStoreInformationPremiumStoresHostManagementClubidIndexRoute
  '/(app)/store-information/premium-stores/plan-management/$clubid/': typeof appStoreInformationPremiumStoresPlanManagementClubidIndexRoute
  '/(app)/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery': typeof appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryRouteRouteWithChildren
  '/(app)/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery': typeof appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryRouteRouteWithChildren
  '/(app)/store-information/basic-stores/host-management/$clubid/$manage-host/': typeof appStoreInformationBasicStoresHostManagementClubidManageHostIndexRoute
  '/(app)/store-information/basic-stores/host-management/$clubid/add-host/': typeof appStoreInformationBasicStoresHostManagementClubidAddHostIndexRoute
  '/(app)/store-information/premium-stores/host-management/$clubid/$manage-host/': typeof appStoreInformationPremiumStoresHostManagementClubidManageHostIndexRoute
  '/(app)/store-information/premium-stores/host-management/$clubid/add-host/': typeof appStoreInformationPremiumStoresHostManagementClubidAddHostIndexRoute
  '/(app)/store-information/premium-stores/host-management/gallery/$host-gallery/': typeof appStoreInformationPremiumStoresHostManagementGalleryHostGalleryIndexRoute
  '/(app)/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery/': typeof appStoreInformationBasicStoresHostManagementClubidGalleryHostGalleryIndexRoute
  '/(app)/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery/': typeof appStoreInformationPremiumStoresHostManagementClubidGalleryHostGalleryIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/configuration-management'
    | '/dashboard'
    | '/faq'
    | '/logs-management'
    | '/payment-management'
    | '/points-management'
    | '/promos-offer'
    | '/recommendation-management'
    | '/store-information'
    | '/users'
    | '/forbidden'
    | '/login'
    | '/account/profile'
    | '/configuration-management/charges'
    | '/configuration-management/commissions'
    | '/configuration-management/discount-management'
    | '/configuration-management/group-management'
    | '/configuration-management/hoslog-plans'
    | '/configuration-management/location'
    | '/configuration-management/withdrawals-setup'
    | '/dashboard/conversion-analytics'
    | '/dashboard/referral-reports'
    | '/dashboard/reservation-ledger'
    | '/faq/complaints'
    | '/faq/inquiry'
    | '/faq/review-ratings'
    | '/logs-management/email-logs'
    | '/logs-management/sms-logs'
    | '/logs-management/static-data-type'
    | '/payment-management/account-information'
    | '/payment-management/affiliate-log'
    | '/payment-management/customer-payment-logs'
    | '/payment-management/overview'
    | '/payment-management/store-payment-log'
    | '/points-management/points-balance-statement'
    | '/points-management/points-configuration'
    | '/points-management/points-transfer'
    | '/points-management/system-transfer'
    | '/promos-offer/advertisement'
    | '/promos-offer/promotional-banner'
    | '/recommendation-management/editors-pick'
    | '/recommendation-management/main-page'
    | '/store-information/basic-stores'
    | '/store-information/premium-stores'
    | '/store-information/switch-store'
    | '/users/admin'
    | '/users/affiliates'
    | '/users/customers'
    | '/users/roles'
    | '/users/store-owners'
    | '/account/language'
    | '/dashboard/overview'
    | '/dashboard/sales-performance'
    | '/promos-offer/offer'
    | '/account/'
    | '/configuration-management/'
    | '/dashboard/'
    | '/faq/'
    | '/logs-management/'
    | '/payment-management/'
    | '/points-management/'
    | '/promos-offer/'
    | '/recommendation-management/'
    | '/store-information/'
    | '/users/'
    | '/configuration-management/charges/$categoryId'
    | '/configuration-management/commissions/$categoryId'
    | '/configuration-management/discount-management/$discountCategory'
    | '/configuration-management/group-management/$sub-group'
    | '/logs-management/static-data-type/$staticDataTypeName'
    | '/payment-management/store-payment-log/$storeId'
    | '/recommendation-management/main-page/$store-list'
    | '/store-information/basic-stores/$manage-store'
    | '/store-information/basic-stores/add-store'
    | '/store-information/basic-stores/switch-store'
    | '/store-information/premium-stores/$manage-premium-store'
    | '/store-information/premium-stores/add-premium-store'
    | '/store-information/premium-stores/plan-management'
    | '/payment-management/admin-payment-setup/add-bank-information'
    | '/payment-management/affiliate-log/$monthly-report'
    | '/users/affiliates/$affiliateId'
    | '/users/customers/$customerId'
    | '/account/profile/'
    | '/configuration-management/charges/'
    | '/configuration-management/commissions/'
    | '/configuration-management/discount-management/'
    | '/configuration-management/group-management/'
    | '/configuration-management/hoslog-plans/'
    | '/configuration-management/location/'
    | '/configuration-management/withdrawals-setup/'
    | '/dashboard/conversion-analytics/'
    | '/dashboard/referral-reports/'
    | '/dashboard/reservation-ledger/'
    | '/faq/complaints/'
    | '/faq/inquiry/'
    | '/faq/review-ratings/'
    | '/logs-management/access-logs'
    | '/logs-management/api-logs'
    | '/logs-management/email-logs/'
    | '/logs-management/sms-logs/'
    | '/logs-management/static-data-type/'
    | '/payment-management/account-information/'
    | '/payment-management/admin-payment-setup'
    | '/payment-management/affiliate-log/'
    | '/payment-management/customer-payment-logs/'
    | '/payment-management/overview/'
    | '/payment-management/store-payment-log/'
    | '/points-management/points-balance-statement/'
    | '/points-management/points-configuration/'
    | '/points-management/points-request'
    | '/points-management/points-transfer/'
    | '/points-management/system-transfer/'
    | '/promos-offer/advertisement/'
    | '/promos-offer/promotional-banner/'
    | '/recommendation-management/editors-pick/'
    | '/recommendation-management/main-page/'
    | '/store-information/basic-stores/'
    | '/store-information/premium-stores/'
    | '/users/admin/'
    | '/users/affiliates/'
    | '/users/customers/'
    | '/users/roles/'
    | '/users/store-owners/'
    | '/configuration-management/charges/$categoryId/slabs'
    | '/points-management/points-configuration/customer/$programId'
    | '/recommendation-management/main-page/$store-list/$host-list'
    | '/store-information/basic-stores/host-management/$clubid'
    | '/store-information/premium-stores/gallery/$store-gallery'
    | '/store-information/premium-stores/host-management/$clubid'
    | '/store-information/premium-stores/host-management/gallery'
    | '/store-information/premium-stores/plan-management/$clubid'
    | '/configuration-management/group-management/$sub-group/$club-gallery'
    | '/users/roles/privilege/$roleId'
    | '/configuration-management/charges/$categoryId/'
    | '/configuration-management/commissions/$categoryId/'
    | '/configuration-management/discount-management/$discountCategory/'
    | '/configuration-management/group-management/$sub-group/'
    | '/logs-management/static-data-type/$staticDataTypeName/'
    | '/payment-management/store-payment-log/$storeId/'
    | '/recommendation-management/main-page/$store-list/'
    | '/store-information/basic-stores/$manage-store/'
    | '/store-information/basic-stores/add-store/'
    | '/store-information/premium-stores/$manage-premium-store/'
    | '/store-information/premium-stores/add-premium-store/'
    | '/store-information/basic-stores/host-management/$clubid/$manage-host'
    | '/store-information/basic-stores/host-management/$clubid/add-host'
    | '/store-information/basic-stores/host-management/$clubid/gallery'
    | '/store-information/premium-stores/host-management/$clubid/$manage-host'
    | '/store-information/premium-stores/host-management/$clubid/add-host'
    | '/store-information/premium-stores/host-management/$clubid/gallery'
    | '/store-information/premium-stores/host-management/gallery/$host-gallery'
    | '/points-management/points-configuration/affiliate/$pointCategoryId/slabs'
    | '/configuration-management/charges/$categoryId/slabs/'
    | '/dashboard/referral-reports/$reportType/$referrerId'
    | '/points-management/points-configuration/customer/$programId/'
    | '/recommendation-management/main-page/$store-list/$host-list/'
    | '/store-information/basic-stores/host-management/$clubid/'
    | '/store-information/basic-stores/switch-store/$id'
    | '/store-information/premium-stores/gallery/$store-gallery/'
    | '/store-information/premium-stores/host-management/$clubid/'
    | '/store-information/premium-stores/plan-management/$clubid/'
    | '/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery'
    | '/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery'
    | '/store-information/basic-stores/host-management/$clubid/$manage-host/'
    | '/store-information/basic-stores/host-management/$clubid/add-host/'
    | '/store-information/premium-stores/host-management/$clubid/$manage-host/'
    | '/store-information/premium-stores/host-management/$clubid/add-host/'
    | '/store-information/premium-stores/host-management/gallery/$host-gallery/'
    | '/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery/'
    | '/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forbidden'
    | '/login'
    | '/store-information/switch-store'
    | '/account/language'
    | '/dashboard/overview'
    | '/dashboard/sales-performance'
    | '/promos-offer/offer'
    | '/account'
    | '/configuration-management'
    | '/dashboard'
    | '/faq'
    | '/logs-management'
    | '/payment-management'
    | '/points-management'
    | '/promos-offer'
    | '/recommendation-management'
    | '/store-information'
    | '/users'
    | '/store-information/basic-stores/switch-store'
    | '/store-information/premium-stores/plan-management'
    | '/payment-management/admin-payment-setup/add-bank-information'
    | '/payment-management/affiliate-log/$monthly-report'
    | '/users/affiliates/$affiliateId'
    | '/users/customers/$customerId'
    | '/account/profile'
    | '/configuration-management/charges'
    | '/configuration-management/commissions'
    | '/configuration-management/discount-management'
    | '/configuration-management/group-management'
    | '/configuration-management/hoslog-plans'
    | '/configuration-management/location'
    | '/configuration-management/withdrawals-setup'
    | '/dashboard/conversion-analytics'
    | '/dashboard/referral-reports'
    | '/dashboard/reservation-ledger'
    | '/faq/complaints'
    | '/faq/inquiry'
    | '/faq/review-ratings'
    | '/logs-management/access-logs'
    | '/logs-management/api-logs'
    | '/logs-management/email-logs'
    | '/logs-management/sms-logs'
    | '/logs-management/static-data-type'
    | '/payment-management/account-information'
    | '/payment-management/admin-payment-setup'
    | '/payment-management/affiliate-log'
    | '/payment-management/customer-payment-logs'
    | '/payment-management/overview'
    | '/payment-management/store-payment-log'
    | '/points-management/points-balance-statement'
    | '/points-management/points-configuration'
    | '/points-management/points-request'
    | '/points-management/points-transfer'
    | '/points-management/system-transfer'
    | '/promos-offer/advertisement'
    | '/promos-offer/promotional-banner'
    | '/recommendation-management/editors-pick'
    | '/recommendation-management/main-page'
    | '/store-information/basic-stores'
    | '/store-information/premium-stores'
    | '/users/admin'
    | '/users/affiliates'
    | '/users/customers'
    | '/users/roles'
    | '/users/store-owners'
    | '/store-information/premium-stores/host-management/gallery'
    | '/configuration-management/group-management/$sub-group/$club-gallery'
    | '/users/roles/privilege/$roleId'
    | '/configuration-management/charges/$categoryId'
    | '/configuration-management/commissions/$categoryId'
    | '/configuration-management/discount-management/$discountCategory'
    | '/configuration-management/group-management/$sub-group'
    | '/logs-management/static-data-type/$staticDataTypeName'
    | '/payment-management/store-payment-log/$storeId'
    | '/recommendation-management/main-page/$store-list'
    | '/store-information/basic-stores/$manage-store'
    | '/store-information/basic-stores/add-store'
    | '/store-information/premium-stores/$manage-premium-store'
    | '/store-information/premium-stores/add-premium-store'
    | '/store-information/basic-stores/host-management/$clubid/gallery'
    | '/store-information/premium-stores/host-management/$clubid/gallery'
    | '/points-management/points-configuration/affiliate/$pointCategoryId/slabs'
    | '/configuration-management/charges/$categoryId/slabs'
    | '/dashboard/referral-reports/$reportType/$referrerId'
    | '/points-management/points-configuration/customer/$programId'
    | '/recommendation-management/main-page/$store-list/$host-list'
    | '/store-information/basic-stores/host-management/$clubid'
    | '/store-information/basic-stores/switch-store/$id'
    | '/store-information/premium-stores/gallery/$store-gallery'
    | '/store-information/premium-stores/host-management/$clubid'
    | '/store-information/premium-stores/plan-management/$clubid'
    | '/store-information/basic-stores/host-management/$clubid/$manage-host'
    | '/store-information/basic-stores/host-management/$clubid/add-host'
    | '/store-information/premium-stores/host-management/$clubid/$manage-host'
    | '/store-information/premium-stores/host-management/$clubid/add-host'
    | '/store-information/premium-stores/host-management/gallery/$host-gallery'
    | '/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery'
    | '/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery'
  id:
    | '__root__'
    | '/'
    | '/(app)'
    | '/(app)/account'
    | '/(app)/configuration-management'
    | '/(app)/dashboard'
    | '/(app)/faq'
    | '/(app)/logs-management'
    | '/(app)/payment-management'
    | '/(app)/points-management'
    | '/(app)/promos-offer'
    | '/(app)/recommendation-management'
    | '/(app)/store-information'
    | '/(app)/users'
    | '/(app)/forbidden'
    | '/(auth)/login'
    | '/(app)/account/profile'
    | '/(app)/configuration-management/charges'
    | '/(app)/configuration-management/commissions'
    | '/(app)/configuration-management/discount-management'
    | '/(app)/configuration-management/group-management'
    | '/(app)/configuration-management/hoslog-plans'
    | '/(app)/configuration-management/location'
    | '/(app)/configuration-management/withdrawals-setup'
    | '/(app)/dashboard/conversion-analytics'
    | '/(app)/dashboard/referral-reports'
    | '/(app)/dashboard/reservation-ledger'
    | '/(app)/faq/complaints'
    | '/(app)/faq/inquiry'
    | '/(app)/faq/review-ratings'
    | '/(app)/logs-management/email-logs'
    | '/(app)/logs-management/sms-logs'
    | '/(app)/logs-management/static-data-type'
    | '/(app)/payment-management/account-information'
    | '/(app)/payment-management/affiliate-log'
    | '/(app)/payment-management/customer-payment-logs'
    | '/(app)/payment-management/overview'
    | '/(app)/payment-management/store-payment-log'
    | '/(app)/points-management/points-balance-statement'
    | '/(app)/points-management/points-configuration'
    | '/(app)/points-management/points-transfer'
    | '/(app)/points-management/system-transfer'
    | '/(app)/promos-offer/advertisement'
    | '/(app)/promos-offer/promotional-banner'
    | '/(app)/recommendation-management/editors-pick'
    | '/(app)/recommendation-management/main-page'
    | '/(app)/store-information/basic-stores'
    | '/(app)/store-information/premium-stores'
    | '/(app)/store-information/switch-store'
    | '/(app)/users/admin'
    | '/(app)/users/affiliates'
    | '/(app)/users/customers'
    | '/(app)/users/roles'
    | '/(app)/users/store-owners'
    | '/(app)/account/language'
    | '/(app)/dashboard/overview'
    | '/(app)/dashboard/sales-performance'
    | '/(app)/promos-offer/offer'
    | '/(app)/account/'
    | '/(app)/configuration-management/'
    | '/(app)/dashboard/'
    | '/(app)/faq/'
    | '/(app)/logs-management/'
    | '/(app)/payment-management/'
    | '/(app)/points-management/'
    | '/(app)/promos-offer/'
    | '/(app)/recommendation-management/'
    | '/(app)/store-information/'
    | '/(app)/users/'
    | '/(app)/configuration-management/charges/$categoryId'
    | '/(app)/configuration-management/commissions/$categoryId'
    | '/(app)/configuration-management/discount-management/$discountCategory'
    | '/(app)/configuration-management/group-management/$sub-group'
    | '/(app)/logs-management/static-data-type/$staticDataTypeName'
    | '/(app)/payment-management/store-payment-log/$storeId'
    | '/(app)/recommendation-management/main-page/$store-list'
    | '/(app)/store-information/basic-stores/$manage-store'
    | '/(app)/store-information/basic-stores/add-store'
    | '/(app)/store-information/basic-stores/switch-store'
    | '/(app)/store-information/premium-stores/$manage-premium-store'
    | '/(app)/store-information/premium-stores/add-premium-store'
    | '/(app)/store-information/premium-stores/plan-management'
    | '/(app)/payment-management/admin-payment-setup/add-bank-information'
    | '/(app)/payment-management/affiliate-log/$monthly-report'
    | '/(app)/users/affiliates/$affiliateId'
    | '/(app)/users/customers/$customerId'
    | '/(app)/account/profile/'
    | '/(app)/configuration-management/charges/'
    | '/(app)/configuration-management/commissions/'
    | '/(app)/configuration-management/discount-management/'
    | '/(app)/configuration-management/group-management/'
    | '/(app)/configuration-management/hoslog-plans/'
    | '/(app)/configuration-management/location/'
    | '/(app)/configuration-management/withdrawals-setup/'
    | '/(app)/dashboard/conversion-analytics/'
    | '/(app)/dashboard/referral-reports/'
    | '/(app)/dashboard/reservation-ledger/'
    | '/(app)/faq/complaints/'
    | '/(app)/faq/inquiry/'
    | '/(app)/faq/review-ratings/'
    | '/(app)/logs-management/access-logs/'
    | '/(app)/logs-management/api-logs/'
    | '/(app)/logs-management/email-logs/'
    | '/(app)/logs-management/sms-logs/'
    | '/(app)/logs-management/static-data-type/'
    | '/(app)/payment-management/account-information/'
    | '/(app)/payment-management/admin-payment-setup/'
    | '/(app)/payment-management/affiliate-log/'
    | '/(app)/payment-management/customer-payment-logs/'
    | '/(app)/payment-management/overview/'
    | '/(app)/payment-management/store-payment-log/'
    | '/(app)/points-management/points-balance-statement/'
    | '/(app)/points-management/points-configuration/'
    | '/(app)/points-management/points-request/'
    | '/(app)/points-management/points-transfer/'
    | '/(app)/points-management/system-transfer/'
    | '/(app)/promos-offer/advertisement/'
    | '/(app)/promos-offer/promotional-banner/'
    | '/(app)/recommendation-management/editors-pick/'
    | '/(app)/recommendation-management/main-page/'
    | '/(app)/store-information/basic-stores/'
    | '/(app)/store-information/premium-stores/'
    | '/(app)/users/admin/'
    | '/(app)/users/affiliates/'
    | '/(app)/users/customers/'
    | '/(app)/users/roles/'
    | '/(app)/users/store-owners/'
    | '/(app)/configuration-management/charges/$categoryId/slabs'
    | '/(app)/points-management/points-configuration/customer/$programId'
    | '/(app)/recommendation-management/main-page/$store-list/$host-list'
    | '/(app)/store-information/basic-stores/host-management/$clubid'
    | '/(app)/store-information/premium-stores/gallery/$store-gallery'
    | '/(app)/store-information/premium-stores/host-management/$clubid'
    | '/(app)/store-information/premium-stores/host-management/gallery'
    | '/(app)/store-information/premium-stores/plan-management/$clubid'
    | '/(app)/configuration-management/group-management/$sub-group/$club-gallery'
    | '/(app)/users/roles/privilege/$roleId'
    | '/(app)/configuration-management/charges/$categoryId/'
    | '/(app)/configuration-management/commissions/$categoryId/'
    | '/(app)/configuration-management/discount-management/$discountCategory/'
    | '/(app)/configuration-management/group-management/$sub-group/'
    | '/(app)/logs-management/static-data-type/$staticDataTypeName/'
    | '/(app)/payment-management/store-payment-log/$storeId/'
    | '/(app)/recommendation-management/main-page/$store-list/'
    | '/(app)/store-information/basic-stores/$manage-store/'
    | '/(app)/store-information/basic-stores/add-store/'
    | '/(app)/store-information/premium-stores/$manage-premium-store/'
    | '/(app)/store-information/premium-stores/add-premium-store/'
    | '/(app)/store-information/basic-stores/host-management/$clubid/$manage-host'
    | '/(app)/store-information/basic-stores/host-management/$clubid/add-host'
    | '/(app)/store-information/basic-stores/host-management/$clubid/gallery'
    | '/(app)/store-information/premium-stores/host-management/$clubid/$manage-host'
    | '/(app)/store-information/premium-stores/host-management/$clubid/add-host'
    | '/(app)/store-information/premium-stores/host-management/$clubid/gallery'
    | '/(app)/store-information/premium-stores/host-management/gallery/$host-gallery'
    | '/(app)/points-management/points-configuration/affiliate/$pointCategoryId/slabs'
    | '/(app)/configuration-management/charges/$categoryId/slabs/'
    | '/(app)/dashboard/referral-reports/$reportType/$referrerId/'
    | '/(app)/points-management/points-configuration/customer/$programId/'
    | '/(app)/recommendation-management/main-page/$store-list/$host-list/'
    | '/(app)/store-information/basic-stores/host-management/$clubid/'
    | '/(app)/store-information/basic-stores/switch-store/$id/'
    | '/(app)/store-information/premium-stores/gallery/$store-gallery/'
    | '/(app)/store-information/premium-stores/host-management/$clubid/'
    | '/(app)/store-information/premium-stores/plan-management/$clubid/'
    | '/(app)/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery'
    | '/(app)/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery'
    | '/(app)/store-information/basic-stores/host-management/$clubid/$manage-host/'
    | '/(app)/store-information/basic-stores/host-management/$clubid/add-host/'
    | '/(app)/store-information/premium-stores/host-management/$clubid/$manage-host/'
    | '/(app)/store-information/premium-stores/host-management/$clubid/add-host/'
    | '/(app)/store-information/premium-stores/host-management/gallery/$host-gallery/'
    | '/(app)/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery/'
    | '/(app)/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRouteWithChildren
  authLoginRoute: typeof authLoginRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRouteWithChildren,
  authLoginRoute: authLoginRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/(auth)/login"
      ]
    },
    "/": {
      "filePath": "index.tsx",
      "children": [
        "/(app)"
      ]
    },
    "/(app)": {
      "filePath": "(app)/route.tsx",
      "parent": "/",
      "children": [
        "/(app)/account",
        "/(app)/configuration-management",
        "/(app)/dashboard",
        "/(app)/faq",
        "/(app)/logs-management",
        "/(app)/payment-management",
        "/(app)/points-management",
        "/(app)/promos-offer",
        "/(app)/recommendation-management",
        "/(app)/store-information",
        "/(app)/users",
        "/(app)/forbidden"
      ]
    },
    "/(app)/account": {
      "filePath": "(app)/account/route.tsx",
      "parent": "/(app)",
      "children": [
        "/(app)/account/profile",
        "/(app)/account/language",
        "/(app)/account/"
      ]
    },
    "/(app)/configuration-management": {
      "filePath": "(app)/configuration-management/route.tsx",
      "parent": "/(app)",
      "children": [
        "/(app)/configuration-management/charges",
        "/(app)/configuration-management/commissions",
        "/(app)/configuration-management/discount-management",
        "/(app)/configuration-management/group-management",
        "/(app)/configuration-management/hoslog-plans",
        "/(app)/configuration-management/location",
        "/(app)/configuration-management/withdrawals-setup",
        "/(app)/configuration-management/"
      ]
    },
    "/(app)/dashboard": {
      "filePath": "(app)/dashboard/route.tsx",
      "parent": "/(app)",
      "children": [
        "/(app)/dashboard/conversion-analytics",
        "/(app)/dashboard/referral-reports",
        "/(app)/dashboard/reservation-ledger",
        "/(app)/dashboard/overview",
        "/(app)/dashboard/sales-performance",
        "/(app)/dashboard/"
      ]
    },
    "/(app)/faq": {
      "filePath": "(app)/faq/route.tsx",
      "parent": "/(app)",
      "children": [
        "/(app)/faq/complaints",
        "/(app)/faq/inquiry",
        "/(app)/faq/review-ratings",
        "/(app)/faq/"
      ]
    },
    "/(app)/logs-management": {
      "filePath": "(app)/logs-management/route.tsx",
      "parent": "/(app)",
      "children": [
        "/(app)/logs-management/email-logs",
        "/(app)/logs-management/sms-logs",
        "/(app)/logs-management/static-data-type",
        "/(app)/logs-management/",
        "/(app)/logs-management/access-logs/",
        "/(app)/logs-management/api-logs/"
      ]
    },
    "/(app)/payment-management": {
      "filePath": "(app)/payment-management/route.tsx",
      "parent": "/(app)",
      "children": [
        "/(app)/payment-management/account-information",
        "/(app)/payment-management/affiliate-log",
        "/(app)/payment-management/customer-payment-logs",
        "/(app)/payment-management/overview",
        "/(app)/payment-management/store-payment-log",
        "/(app)/payment-management/",
        "/(app)/payment-management/admin-payment-setup/add-bank-information",
        "/(app)/payment-management/admin-payment-setup/"
      ]
    },
    "/(app)/points-management": {
      "filePath": "(app)/points-management/route.tsx",
      "parent": "/(app)",
      "children": [
        "/(app)/points-management/points-balance-statement",
        "/(app)/points-management/points-configuration",
        "/(app)/points-management/points-transfer",
        "/(app)/points-management/system-transfer",
        "/(app)/points-management/",
        "/(app)/points-management/points-request/"
      ]
    },
    "/(app)/promos-offer": {
      "filePath": "(app)/promos-offer/route.tsx",
      "parent": "/(app)",
      "children": [
        "/(app)/promos-offer/advertisement",
        "/(app)/promos-offer/promotional-banner",
        "/(app)/promos-offer/offer",
        "/(app)/promos-offer/"
      ]
    },
    "/(app)/recommendation-management": {
      "filePath": "(app)/recommendation-management/route.tsx",
      "parent": "/(app)",
      "children": [
        "/(app)/recommendation-management/editors-pick",
        "/(app)/recommendation-management/main-page",
        "/(app)/recommendation-management/"
      ]
    },
    "/(app)/store-information": {
      "filePath": "(app)/store-information/route.tsx",
      "parent": "/(app)",
      "children": [
        "/(app)/store-information/basic-stores",
        "/(app)/store-information/premium-stores",
        "/(app)/store-information/switch-store",
        "/(app)/store-information/"
      ]
    },
    "/(app)/users": {
      "filePath": "(app)/users/route.tsx",
      "parent": "/(app)",
      "children": [
        "/(app)/users/admin",
        "/(app)/users/affiliates",
        "/(app)/users/customers",
        "/(app)/users/roles",
        "/(app)/users/store-owners",
        "/(app)/users/"
      ]
    },
    "/(app)/forbidden": {
      "filePath": "(app)/forbidden.tsx",
      "parent": "/(app)"
    },
    "/(auth)/login": {
      "filePath": "(auth)/login.tsx"
    },
    "/(app)/account/profile": {
      "filePath": "(app)/account/profile/route.tsx",
      "parent": "/(app)/account",
      "children": [
        "/(app)/account/profile/"
      ]
    },
    "/(app)/configuration-management/charges": {
      "filePath": "(app)/configuration-management/charges/route.tsx",
      "parent": "/(app)/configuration-management",
      "children": [
        "/(app)/configuration-management/charges/$categoryId",
        "/(app)/configuration-management/charges/"
      ]
    },
    "/(app)/configuration-management/commissions": {
      "filePath": "(app)/configuration-management/commissions/route.tsx",
      "parent": "/(app)/configuration-management",
      "children": [
        "/(app)/configuration-management/commissions/$categoryId",
        "/(app)/configuration-management/commissions/"
      ]
    },
    "/(app)/configuration-management/discount-management": {
      "filePath": "(app)/configuration-management/discount-management/route.tsx",
      "parent": "/(app)/configuration-management",
      "children": [
        "/(app)/configuration-management/discount-management/$discountCategory",
        "/(app)/configuration-management/discount-management/"
      ]
    },
    "/(app)/configuration-management/group-management": {
      "filePath": "(app)/configuration-management/group-management/route.tsx",
      "parent": "/(app)/configuration-management",
      "children": [
        "/(app)/configuration-management/group-management/$sub-group",
        "/(app)/configuration-management/group-management/"
      ]
    },
    "/(app)/configuration-management/hoslog-plans": {
      "filePath": "(app)/configuration-management/hoslog-plans/route.tsx",
      "parent": "/(app)/configuration-management",
      "children": [
        "/(app)/configuration-management/hoslog-plans/"
      ]
    },
    "/(app)/configuration-management/location": {
      "filePath": "(app)/configuration-management/location/route.tsx",
      "parent": "/(app)/configuration-management",
      "children": [
        "/(app)/configuration-management/location/"
      ]
    },
    "/(app)/configuration-management/withdrawals-setup": {
      "filePath": "(app)/configuration-management/withdrawals-setup/route.tsx",
      "parent": "/(app)/configuration-management",
      "children": [
        "/(app)/configuration-management/withdrawals-setup/"
      ]
    },
    "/(app)/dashboard/conversion-analytics": {
      "filePath": "(app)/dashboard/conversion-analytics/route.tsx",
      "parent": "/(app)/dashboard",
      "children": [
        "/(app)/dashboard/conversion-analytics/"
      ]
    },
    "/(app)/dashboard/referral-reports": {
      "filePath": "(app)/dashboard/referral-reports/route.tsx",
      "parent": "/(app)/dashboard",
      "children": [
        "/(app)/dashboard/referral-reports/",
        "/(app)/dashboard/referral-reports/$reportType/$referrerId/"
      ]
    },
    "/(app)/dashboard/reservation-ledger": {
      "filePath": "(app)/dashboard/reservation-ledger/route.tsx",
      "parent": "/(app)/dashboard",
      "children": [
        "/(app)/dashboard/reservation-ledger/"
      ]
    },
    "/(app)/faq/complaints": {
      "filePath": "(app)/faq/complaints/route.tsx",
      "parent": "/(app)/faq",
      "children": [
        "/(app)/faq/complaints/"
      ]
    },
    "/(app)/faq/inquiry": {
      "filePath": "(app)/faq/inquiry/route.tsx",
      "parent": "/(app)/faq",
      "children": [
        "/(app)/faq/inquiry/"
      ]
    },
    "/(app)/faq/review-ratings": {
      "filePath": "(app)/faq/review-ratings/route.tsx",
      "parent": "/(app)/faq",
      "children": [
        "/(app)/faq/review-ratings/"
      ]
    },
    "/(app)/logs-management/email-logs": {
      "filePath": "(app)/logs-management/email-logs/route.tsx",
      "parent": "/(app)/logs-management",
      "children": [
        "/(app)/logs-management/email-logs/"
      ]
    },
    "/(app)/logs-management/sms-logs": {
      "filePath": "(app)/logs-management/sms-logs/route.tsx",
      "parent": "/(app)/logs-management",
      "children": [
        "/(app)/logs-management/sms-logs/"
      ]
    },
    "/(app)/logs-management/static-data-type": {
      "filePath": "(app)/logs-management/static-data-type/route.tsx",
      "parent": "/(app)/logs-management",
      "children": [
        "/(app)/logs-management/static-data-type/$staticDataTypeName",
        "/(app)/logs-management/static-data-type/"
      ]
    },
    "/(app)/payment-management/account-information": {
      "filePath": "(app)/payment-management/account-information/route.tsx",
      "parent": "/(app)/payment-management",
      "children": [
        "/(app)/payment-management/account-information/"
      ]
    },
    "/(app)/payment-management/affiliate-log": {
      "filePath": "(app)/payment-management/affiliate-log/route.tsx",
      "parent": "/(app)/payment-management",
      "children": [
        "/(app)/payment-management/affiliate-log/$monthly-report",
        "/(app)/payment-management/affiliate-log/"
      ]
    },
    "/(app)/payment-management/customer-payment-logs": {
      "filePath": "(app)/payment-management/customer-payment-logs/route.tsx",
      "parent": "/(app)/payment-management",
      "children": [
        "/(app)/payment-management/customer-payment-logs/"
      ]
    },
    "/(app)/payment-management/overview": {
      "filePath": "(app)/payment-management/overview/route.tsx",
      "parent": "/(app)/payment-management",
      "children": [
        "/(app)/payment-management/overview/"
      ]
    },
    "/(app)/payment-management/store-payment-log": {
      "filePath": "(app)/payment-management/store-payment-log/route.tsx",
      "parent": "/(app)/payment-management",
      "children": [
        "/(app)/payment-management/store-payment-log/$storeId",
        "/(app)/payment-management/store-payment-log/"
      ]
    },
    "/(app)/points-management/points-balance-statement": {
      "filePath": "(app)/points-management/points-balance-statement/route.tsx",
      "parent": "/(app)/points-management",
      "children": [
        "/(app)/points-management/points-balance-statement/"
      ]
    },
    "/(app)/points-management/points-configuration": {
      "filePath": "(app)/points-management/points-configuration/route.tsx",
      "parent": "/(app)/points-management",
      "children": [
        "/(app)/points-management/points-configuration/",
        "/(app)/points-management/points-configuration/customer/$programId",
        "/(app)/points-management/points-configuration/affiliate/$pointCategoryId/slabs"
      ]
    },
    "/(app)/points-management/points-transfer": {
      "filePath": "(app)/points-management/points-transfer/route.tsx",
      "parent": "/(app)/points-management",
      "children": [
        "/(app)/points-management/points-transfer/"
      ]
    },
    "/(app)/points-management/system-transfer": {
      "filePath": "(app)/points-management/system-transfer/route.tsx",
      "parent": "/(app)/points-management",
      "children": [
        "/(app)/points-management/system-transfer/"
      ]
    },
    "/(app)/promos-offer/advertisement": {
      "filePath": "(app)/promos-offer/advertisement/route.tsx",
      "parent": "/(app)/promos-offer",
      "children": [
        "/(app)/promos-offer/advertisement/"
      ]
    },
    "/(app)/promos-offer/promotional-banner": {
      "filePath": "(app)/promos-offer/promotional-banner/route.tsx",
      "parent": "/(app)/promos-offer",
      "children": [
        "/(app)/promos-offer/promotional-banner/"
      ]
    },
    "/(app)/recommendation-management/editors-pick": {
      "filePath": "(app)/recommendation-management/editors-pick/route.tsx",
      "parent": "/(app)/recommendation-management",
      "children": [
        "/(app)/recommendation-management/editors-pick/"
      ]
    },
    "/(app)/recommendation-management/main-page": {
      "filePath": "(app)/recommendation-management/main-page/route.tsx",
      "parent": "/(app)/recommendation-management",
      "children": [
        "/(app)/recommendation-management/main-page/$store-list",
        "/(app)/recommendation-management/main-page/"
      ]
    },
    "/(app)/store-information/basic-stores": {
      "filePath": "(app)/store-information/basic-stores/route.tsx",
      "parent": "/(app)/store-information",
      "children": [
        "/(app)/store-information/basic-stores/$manage-store",
        "/(app)/store-information/basic-stores/add-store",
        "/(app)/store-information/basic-stores/switch-store",
        "/(app)/store-information/basic-stores/",
        "/(app)/store-information/basic-stores/host-management/$clubid"
      ]
    },
    "/(app)/store-information/premium-stores": {
      "filePath": "(app)/store-information/premium-stores/route.tsx",
      "parent": "/(app)/store-information",
      "children": [
        "/(app)/store-information/premium-stores/$manage-premium-store",
        "/(app)/store-information/premium-stores/add-premium-store",
        "/(app)/store-information/premium-stores/plan-management",
        "/(app)/store-information/premium-stores/",
        "/(app)/store-information/premium-stores/gallery/$store-gallery",
        "/(app)/store-information/premium-stores/host-management/$clubid",
        "/(app)/store-information/premium-stores/host-management/gallery"
      ]
    },
    "/(app)/store-information/switch-store": {
      "filePath": "(app)/store-information/switch-store/route.tsx",
      "parent": "/(app)/store-information"
    },
    "/(app)/users/admin": {
      "filePath": "(app)/users/admin/route.tsx",
      "parent": "/(app)/users",
      "children": [
        "/(app)/users/admin/"
      ]
    },
    "/(app)/users/affiliates": {
      "filePath": "(app)/users/affiliates/route.tsx",
      "parent": "/(app)/users",
      "children": [
        "/(app)/users/affiliates/$affiliateId",
        "/(app)/users/affiliates/"
      ]
    },
    "/(app)/users/customers": {
      "filePath": "(app)/users/customers/route.tsx",
      "parent": "/(app)/users",
      "children": [
        "/(app)/users/customers/$customerId",
        "/(app)/users/customers/"
      ]
    },
    "/(app)/users/roles": {
      "filePath": "(app)/users/roles/route.tsx",
      "parent": "/(app)/users",
      "children": [
        "/(app)/users/roles/",
        "/(app)/users/roles/privilege/$roleId"
      ]
    },
    "/(app)/users/store-owners": {
      "filePath": "(app)/users/store-owners/route.tsx",
      "parent": "/(app)/users",
      "children": [
        "/(app)/users/store-owners/"
      ]
    },
    "/(app)/account/language": {
      "filePath": "(app)/account/language.tsx",
      "parent": "/(app)/account"
    },
    "/(app)/dashboard/overview": {
      "filePath": "(app)/dashboard/overview.tsx",
      "parent": "/(app)/dashboard"
    },
    "/(app)/dashboard/sales-performance": {
      "filePath": "(app)/dashboard/sales-performance.tsx",
      "parent": "/(app)/dashboard"
    },
    "/(app)/promos-offer/offer": {
      "filePath": "(app)/promos-offer/offer.tsx",
      "parent": "/(app)/promos-offer"
    },
    "/(app)/account/": {
      "filePath": "(app)/account/index.tsx",
      "parent": "/(app)/account"
    },
    "/(app)/configuration-management/": {
      "filePath": "(app)/configuration-management/index.tsx",
      "parent": "/(app)/configuration-management"
    },
    "/(app)/dashboard/": {
      "filePath": "(app)/dashboard/index.tsx",
      "parent": "/(app)/dashboard"
    },
    "/(app)/faq/": {
      "filePath": "(app)/faq/index.tsx",
      "parent": "/(app)/faq"
    },
    "/(app)/logs-management/": {
      "filePath": "(app)/logs-management/index.tsx",
      "parent": "/(app)/logs-management"
    },
    "/(app)/payment-management/": {
      "filePath": "(app)/payment-management/index.tsx",
      "parent": "/(app)/payment-management"
    },
    "/(app)/points-management/": {
      "filePath": "(app)/points-management/index.tsx",
      "parent": "/(app)/points-management"
    },
    "/(app)/promos-offer/": {
      "filePath": "(app)/promos-offer/index.tsx",
      "parent": "/(app)/promos-offer"
    },
    "/(app)/recommendation-management/": {
      "filePath": "(app)/recommendation-management/index.tsx",
      "parent": "/(app)/recommendation-management"
    },
    "/(app)/store-information/": {
      "filePath": "(app)/store-information/index.tsx",
      "parent": "/(app)/store-information"
    },
    "/(app)/users/": {
      "filePath": "(app)/users/index.tsx",
      "parent": "/(app)/users"
    },
    "/(app)/configuration-management/charges/$categoryId": {
      "filePath": "(app)/configuration-management/charges/$categoryId/route.tsx",
      "parent": "/(app)/configuration-management/charges",
      "children": [
        "/(app)/configuration-management/charges/$categoryId/slabs",
        "/(app)/configuration-management/charges/$categoryId/"
      ]
    },
    "/(app)/configuration-management/commissions/$categoryId": {
      "filePath": "(app)/configuration-management/commissions/$categoryId/route.tsx",
      "parent": "/(app)/configuration-management/commissions",
      "children": [
        "/(app)/configuration-management/commissions/$categoryId/"
      ]
    },
    "/(app)/configuration-management/discount-management/$discountCategory": {
      "filePath": "(app)/configuration-management/discount-management/$discountCategory/route.tsx",
      "parent": "/(app)/configuration-management/discount-management",
      "children": [
        "/(app)/configuration-management/discount-management/$discountCategory/"
      ]
    },
    "/(app)/configuration-management/group-management/$sub-group": {
      "filePath": "(app)/configuration-management/group-management/$sub-group/route.tsx",
      "parent": "/(app)/configuration-management/group-management",
      "children": [
        "/(app)/configuration-management/group-management/$sub-group/$club-gallery",
        "/(app)/configuration-management/group-management/$sub-group/"
      ]
    },
    "/(app)/logs-management/static-data-type/$staticDataTypeName": {
      "filePath": "(app)/logs-management/static-data-type/$staticDataTypeName/route.tsx",
      "parent": "/(app)/logs-management/static-data-type",
      "children": [
        "/(app)/logs-management/static-data-type/$staticDataTypeName/"
      ]
    },
    "/(app)/payment-management/store-payment-log/$storeId": {
      "filePath": "(app)/payment-management/store-payment-log/$storeId/route.tsx",
      "parent": "/(app)/payment-management/store-payment-log",
      "children": [
        "/(app)/payment-management/store-payment-log/$storeId/"
      ]
    },
    "/(app)/recommendation-management/main-page/$store-list": {
      "filePath": "(app)/recommendation-management/main-page/$store-list/route.tsx",
      "parent": "/(app)/recommendation-management/main-page",
      "children": [
        "/(app)/recommendation-management/main-page/$store-list/$host-list",
        "/(app)/recommendation-management/main-page/$store-list/"
      ]
    },
    "/(app)/store-information/basic-stores/$manage-store": {
      "filePath": "(app)/store-information/basic-stores/$manage-store/route.tsx",
      "parent": "/(app)/store-information/basic-stores",
      "children": [
        "/(app)/store-information/basic-stores/$manage-store/"
      ]
    },
    "/(app)/store-information/basic-stores/add-store": {
      "filePath": "(app)/store-information/basic-stores/add-store/route.tsx",
      "parent": "/(app)/store-information/basic-stores",
      "children": [
        "/(app)/store-information/basic-stores/add-store/"
      ]
    },
    "/(app)/store-information/basic-stores/switch-store": {
      "filePath": "(app)/store-information/basic-stores/switch-store/route.tsx",
      "parent": "/(app)/store-information/basic-stores",
      "children": [
        "/(app)/store-information/basic-stores/switch-store/$id/"
      ]
    },
    "/(app)/store-information/premium-stores/$manage-premium-store": {
      "filePath": "(app)/store-information/premium-stores/$manage-premium-store/route.tsx",
      "parent": "/(app)/store-information/premium-stores",
      "children": [
        "/(app)/store-information/premium-stores/$manage-premium-store/"
      ]
    },
    "/(app)/store-information/premium-stores/add-premium-store": {
      "filePath": "(app)/store-information/premium-stores/add-premium-store/route.tsx",
      "parent": "/(app)/store-information/premium-stores",
      "children": [
        "/(app)/store-information/premium-stores/add-premium-store/"
      ]
    },
    "/(app)/store-information/premium-stores/plan-management": {
      "filePath": "(app)/store-information/premium-stores/plan-management/route.tsx",
      "parent": "/(app)/store-information/premium-stores",
      "children": [
        "/(app)/store-information/premium-stores/plan-management/$clubid"
      ]
    },
    "/(app)/payment-management/admin-payment-setup/add-bank-information": {
      "filePath": "(app)/payment-management/admin-payment-setup/add-bank-information.tsx",
      "parent": "/(app)/payment-management"
    },
    "/(app)/payment-management/affiliate-log/$monthly-report": {
      "filePath": "(app)/payment-management/affiliate-log/$monthly-report.tsx",
      "parent": "/(app)/payment-management/affiliate-log"
    },
    "/(app)/users/affiliates/$affiliateId": {
      "filePath": "(app)/users/affiliates/$affiliateId.tsx",
      "parent": "/(app)/users/affiliates"
    },
    "/(app)/users/customers/$customerId": {
      "filePath": "(app)/users/customers/$customerId.tsx",
      "parent": "/(app)/users/customers"
    },
    "/(app)/account/profile/": {
      "filePath": "(app)/account/profile/index.tsx",
      "parent": "/(app)/account/profile"
    },
    "/(app)/configuration-management/charges/": {
      "filePath": "(app)/configuration-management/charges/index.tsx",
      "parent": "/(app)/configuration-management/charges"
    },
    "/(app)/configuration-management/commissions/": {
      "filePath": "(app)/configuration-management/commissions/index.tsx",
      "parent": "/(app)/configuration-management/commissions"
    },
    "/(app)/configuration-management/discount-management/": {
      "filePath": "(app)/configuration-management/discount-management/index.tsx",
      "parent": "/(app)/configuration-management/discount-management"
    },
    "/(app)/configuration-management/group-management/": {
      "filePath": "(app)/configuration-management/group-management/index.tsx",
      "parent": "/(app)/configuration-management/group-management"
    },
    "/(app)/configuration-management/hoslog-plans/": {
      "filePath": "(app)/configuration-management/hoslog-plans/index.tsx",
      "parent": "/(app)/configuration-management/hoslog-plans"
    },
    "/(app)/configuration-management/location/": {
      "filePath": "(app)/configuration-management/location/index.tsx",
      "parent": "/(app)/configuration-management/location"
    },
    "/(app)/configuration-management/withdrawals-setup/": {
      "filePath": "(app)/configuration-management/withdrawals-setup/index.tsx",
      "parent": "/(app)/configuration-management/withdrawals-setup"
    },
    "/(app)/dashboard/conversion-analytics/": {
      "filePath": "(app)/dashboard/conversion-analytics/index.tsx",
      "parent": "/(app)/dashboard/conversion-analytics"
    },
    "/(app)/dashboard/referral-reports/": {
      "filePath": "(app)/dashboard/referral-reports/index.tsx",
      "parent": "/(app)/dashboard/referral-reports"
    },
    "/(app)/dashboard/reservation-ledger/": {
      "filePath": "(app)/dashboard/reservation-ledger/index.tsx",
      "parent": "/(app)/dashboard/reservation-ledger"
    },
    "/(app)/faq/complaints/": {
      "filePath": "(app)/faq/complaints/index.tsx",
      "parent": "/(app)/faq/complaints"
    },
    "/(app)/faq/inquiry/": {
      "filePath": "(app)/faq/inquiry/index.tsx",
      "parent": "/(app)/faq/inquiry"
    },
    "/(app)/faq/review-ratings/": {
      "filePath": "(app)/faq/review-ratings/index.tsx",
      "parent": "/(app)/faq/review-ratings"
    },
    "/(app)/logs-management/access-logs/": {
      "filePath": "(app)/logs-management/access-logs/index.tsx",
      "parent": "/(app)/logs-management"
    },
    "/(app)/logs-management/api-logs/": {
      "filePath": "(app)/logs-management/api-logs/index.tsx",
      "parent": "/(app)/logs-management"
    },
    "/(app)/logs-management/email-logs/": {
      "filePath": "(app)/logs-management/email-logs/index.tsx",
      "parent": "/(app)/logs-management/email-logs"
    },
    "/(app)/logs-management/sms-logs/": {
      "filePath": "(app)/logs-management/sms-logs/index.tsx",
      "parent": "/(app)/logs-management/sms-logs"
    },
    "/(app)/logs-management/static-data-type/": {
      "filePath": "(app)/logs-management/static-data-type/index.tsx",
      "parent": "/(app)/logs-management/static-data-type"
    },
    "/(app)/payment-management/account-information/": {
      "filePath": "(app)/payment-management/account-information/index.tsx",
      "parent": "/(app)/payment-management/account-information"
    },
    "/(app)/payment-management/admin-payment-setup/": {
      "filePath": "(app)/payment-management/admin-payment-setup/index.tsx",
      "parent": "/(app)/payment-management"
    },
    "/(app)/payment-management/affiliate-log/": {
      "filePath": "(app)/payment-management/affiliate-log/index.tsx",
      "parent": "/(app)/payment-management/affiliate-log"
    },
    "/(app)/payment-management/customer-payment-logs/": {
      "filePath": "(app)/payment-management/customer-payment-logs/index.tsx",
      "parent": "/(app)/payment-management/customer-payment-logs"
    },
    "/(app)/payment-management/overview/": {
      "filePath": "(app)/payment-management/overview/index.tsx",
      "parent": "/(app)/payment-management/overview"
    },
    "/(app)/payment-management/store-payment-log/": {
      "filePath": "(app)/payment-management/store-payment-log/index.tsx",
      "parent": "/(app)/payment-management/store-payment-log"
    },
    "/(app)/points-management/points-balance-statement/": {
      "filePath": "(app)/points-management/points-balance-statement/index.tsx",
      "parent": "/(app)/points-management/points-balance-statement"
    },
    "/(app)/points-management/points-configuration/": {
      "filePath": "(app)/points-management/points-configuration/index.tsx",
      "parent": "/(app)/points-management/points-configuration"
    },
    "/(app)/points-management/points-request/": {
      "filePath": "(app)/points-management/points-request/index.tsx",
      "parent": "/(app)/points-management"
    },
    "/(app)/points-management/points-transfer/": {
      "filePath": "(app)/points-management/points-transfer/index.tsx",
      "parent": "/(app)/points-management/points-transfer"
    },
    "/(app)/points-management/system-transfer/": {
      "filePath": "(app)/points-management/system-transfer/index.tsx",
      "parent": "/(app)/points-management/system-transfer"
    },
    "/(app)/promos-offer/advertisement/": {
      "filePath": "(app)/promos-offer/advertisement/index.tsx",
      "parent": "/(app)/promos-offer/advertisement"
    },
    "/(app)/promos-offer/promotional-banner/": {
      "filePath": "(app)/promos-offer/promotional-banner/index.tsx",
      "parent": "/(app)/promos-offer/promotional-banner"
    },
    "/(app)/recommendation-management/editors-pick/": {
      "filePath": "(app)/recommendation-management/editors-pick/index.tsx",
      "parent": "/(app)/recommendation-management/editors-pick"
    },
    "/(app)/recommendation-management/main-page/": {
      "filePath": "(app)/recommendation-management/main-page/index.tsx",
      "parent": "/(app)/recommendation-management/main-page"
    },
    "/(app)/store-information/basic-stores/": {
      "filePath": "(app)/store-information/basic-stores/index.tsx",
      "parent": "/(app)/store-information/basic-stores"
    },
    "/(app)/store-information/premium-stores/": {
      "filePath": "(app)/store-information/premium-stores/index.tsx",
      "parent": "/(app)/store-information/premium-stores"
    },
    "/(app)/users/admin/": {
      "filePath": "(app)/users/admin/index.tsx",
      "parent": "/(app)/users/admin"
    },
    "/(app)/users/affiliates/": {
      "filePath": "(app)/users/affiliates/index.tsx",
      "parent": "/(app)/users/affiliates"
    },
    "/(app)/users/customers/": {
      "filePath": "(app)/users/customers/index.tsx",
      "parent": "/(app)/users/customers"
    },
    "/(app)/users/roles/": {
      "filePath": "(app)/users/roles/index.tsx",
      "parent": "/(app)/users/roles"
    },
    "/(app)/users/store-owners/": {
      "filePath": "(app)/users/store-owners/index.tsx",
      "parent": "/(app)/users/store-owners"
    },
    "/(app)/configuration-management/charges/$categoryId/slabs": {
      "filePath": "(app)/configuration-management/charges/$categoryId/slabs/route.tsx",
      "parent": "/(app)/configuration-management/charges/$categoryId",
      "children": [
        "/(app)/configuration-management/charges/$categoryId/slabs/"
      ]
    },
    "/(app)/points-management/points-configuration/customer/$programId": {
      "filePath": "(app)/points-management/points-configuration/customer/$programId/route.tsx",
      "parent": "/(app)/points-management/points-configuration",
      "children": [
        "/(app)/points-management/points-configuration/customer/$programId/"
      ]
    },
    "/(app)/recommendation-management/main-page/$store-list/$host-list": {
      "filePath": "(app)/recommendation-management/main-page/$store-list/$host-list/route.tsx",
      "parent": "/(app)/recommendation-management/main-page/$store-list",
      "children": [
        "/(app)/recommendation-management/main-page/$store-list/$host-list/"
      ]
    },
    "/(app)/store-information/basic-stores/host-management/$clubid": {
      "filePath": "(app)/store-information/basic-stores/host-management/$clubid/route.tsx",
      "parent": "/(app)/store-information/basic-stores",
      "children": [
        "/(app)/store-information/basic-stores/host-management/$clubid/$manage-host",
        "/(app)/store-information/basic-stores/host-management/$clubid/add-host",
        "/(app)/store-information/basic-stores/host-management/$clubid/gallery",
        "/(app)/store-information/basic-stores/host-management/$clubid/"
      ]
    },
    "/(app)/store-information/premium-stores/gallery/$store-gallery": {
      "filePath": "(app)/store-information/premium-stores/gallery/$store-gallery/route.tsx",
      "parent": "/(app)/store-information/premium-stores",
      "children": [
        "/(app)/store-information/premium-stores/gallery/$store-gallery/"
      ]
    },
    "/(app)/store-information/premium-stores/host-management/$clubid": {
      "filePath": "(app)/store-information/premium-stores/host-management/$clubid/route.tsx",
      "parent": "/(app)/store-information/premium-stores",
      "children": [
        "/(app)/store-information/premium-stores/host-management/$clubid/$manage-host",
        "/(app)/store-information/premium-stores/host-management/$clubid/add-host",
        "/(app)/store-information/premium-stores/host-management/$clubid/gallery",
        "/(app)/store-information/premium-stores/host-management/$clubid/"
      ]
    },
    "/(app)/store-information/premium-stores/host-management/gallery": {
      "filePath": "(app)/store-information/premium-stores/host-management/gallery/route.tsx",
      "parent": "/(app)/store-information/premium-stores",
      "children": [
        "/(app)/store-information/premium-stores/host-management/gallery/$host-gallery"
      ]
    },
    "/(app)/store-information/premium-stores/plan-management/$clubid": {
      "filePath": "(app)/store-information/premium-stores/plan-management/$clubid/route.tsx",
      "parent": "/(app)/store-information/premium-stores/plan-management",
      "children": [
        "/(app)/store-information/premium-stores/plan-management/$clubid/"
      ]
    },
    "/(app)/configuration-management/group-management/$sub-group/$club-gallery": {
      "filePath": "(app)/configuration-management/group-management/$sub-group/$club-gallery.tsx",
      "parent": "/(app)/configuration-management/group-management/$sub-group"
    },
    "/(app)/users/roles/privilege/$roleId": {
      "filePath": "(app)/users/roles/privilege/$roleId.tsx",
      "parent": "/(app)/users/roles"
    },
    "/(app)/configuration-management/charges/$categoryId/": {
      "filePath": "(app)/configuration-management/charges/$categoryId/index.tsx",
      "parent": "/(app)/configuration-management/charges/$categoryId"
    },
    "/(app)/configuration-management/commissions/$categoryId/": {
      "filePath": "(app)/configuration-management/commissions/$categoryId/index.tsx",
      "parent": "/(app)/configuration-management/commissions/$categoryId"
    },
    "/(app)/configuration-management/discount-management/$discountCategory/": {
      "filePath": "(app)/configuration-management/discount-management/$discountCategory/index.tsx",
      "parent": "/(app)/configuration-management/discount-management/$discountCategory"
    },
    "/(app)/configuration-management/group-management/$sub-group/": {
      "filePath": "(app)/configuration-management/group-management/$sub-group/index.tsx",
      "parent": "/(app)/configuration-management/group-management/$sub-group"
    },
    "/(app)/logs-management/static-data-type/$staticDataTypeName/": {
      "filePath": "(app)/logs-management/static-data-type/$staticDataTypeName/index.tsx",
      "parent": "/(app)/logs-management/static-data-type/$staticDataTypeName"
    },
    "/(app)/payment-management/store-payment-log/$storeId/": {
      "filePath": "(app)/payment-management/store-payment-log/$storeId/index.tsx",
      "parent": "/(app)/payment-management/store-payment-log/$storeId"
    },
    "/(app)/recommendation-management/main-page/$store-list/": {
      "filePath": "(app)/recommendation-management/main-page/$store-list/index.tsx",
      "parent": "/(app)/recommendation-management/main-page/$store-list"
    },
    "/(app)/store-information/basic-stores/$manage-store/": {
      "filePath": "(app)/store-information/basic-stores/$manage-store/index.tsx",
      "parent": "/(app)/store-information/basic-stores/$manage-store"
    },
    "/(app)/store-information/basic-stores/add-store/": {
      "filePath": "(app)/store-information/basic-stores/add-store/index.tsx",
      "parent": "/(app)/store-information/basic-stores/add-store"
    },
    "/(app)/store-information/premium-stores/$manage-premium-store/": {
      "filePath": "(app)/store-information/premium-stores/$manage-premium-store/index.tsx",
      "parent": "/(app)/store-information/premium-stores/$manage-premium-store"
    },
    "/(app)/store-information/premium-stores/add-premium-store/": {
      "filePath": "(app)/store-information/premium-stores/add-premium-store/index.tsx",
      "parent": "/(app)/store-information/premium-stores/add-premium-store"
    },
    "/(app)/store-information/basic-stores/host-management/$clubid/$manage-host": {
      "filePath": "(app)/store-information/basic-stores/host-management/$clubid/$manage-host/route.tsx",
      "parent": "/(app)/store-information/basic-stores/host-management/$clubid",
      "children": [
        "/(app)/store-information/basic-stores/host-management/$clubid/$manage-host/"
      ]
    },
    "/(app)/store-information/basic-stores/host-management/$clubid/add-host": {
      "filePath": "(app)/store-information/basic-stores/host-management/$clubid/add-host/route.tsx",
      "parent": "/(app)/store-information/basic-stores/host-management/$clubid",
      "children": [
        "/(app)/store-information/basic-stores/host-management/$clubid/add-host/"
      ]
    },
    "/(app)/store-information/basic-stores/host-management/$clubid/gallery": {
      "filePath": "(app)/store-information/basic-stores/host-management/$clubid/gallery/route.tsx",
      "parent": "/(app)/store-information/basic-stores/host-management/$clubid",
      "children": [
        "/(app)/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery"
      ]
    },
    "/(app)/store-information/premium-stores/host-management/$clubid/$manage-host": {
      "filePath": "(app)/store-information/premium-stores/host-management/$clubid/$manage-host/route.tsx",
      "parent": "/(app)/store-information/premium-stores/host-management/$clubid",
      "children": [
        "/(app)/store-information/premium-stores/host-management/$clubid/$manage-host/"
      ]
    },
    "/(app)/store-information/premium-stores/host-management/$clubid/add-host": {
      "filePath": "(app)/store-information/premium-stores/host-management/$clubid/add-host/route.tsx",
      "parent": "/(app)/store-information/premium-stores/host-management/$clubid",
      "children": [
        "/(app)/store-information/premium-stores/host-management/$clubid/add-host/"
      ]
    },
    "/(app)/store-information/premium-stores/host-management/$clubid/gallery": {
      "filePath": "(app)/store-information/premium-stores/host-management/$clubid/gallery/route.tsx",
      "parent": "/(app)/store-information/premium-stores/host-management/$clubid",
      "children": [
        "/(app)/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery"
      ]
    },
    "/(app)/store-information/premium-stores/host-management/gallery/$host-gallery": {
      "filePath": "(app)/store-information/premium-stores/host-management/gallery/$host-gallery/route.tsx",
      "parent": "/(app)/store-information/premium-stores/host-management/gallery",
      "children": [
        "/(app)/store-information/premium-stores/host-management/gallery/$host-gallery/"
      ]
    },
    "/(app)/points-management/points-configuration/affiliate/$pointCategoryId/slabs": {
      "filePath": "(app)/points-management/points-configuration/affiliate/$pointCategoryId/slabs.tsx",
      "parent": "/(app)/points-management/points-configuration"
    },
    "/(app)/configuration-management/charges/$categoryId/slabs/": {
      "filePath": "(app)/configuration-management/charges/$categoryId/slabs/index.tsx",
      "parent": "/(app)/configuration-management/charges/$categoryId/slabs"
    },
    "/(app)/dashboard/referral-reports/$reportType/$referrerId/": {
      "filePath": "(app)/dashboard/referral-reports/$reportType/$referrerId/index.tsx",
      "parent": "/(app)/dashboard/referral-reports"
    },
    "/(app)/points-management/points-configuration/customer/$programId/": {
      "filePath": "(app)/points-management/points-configuration/customer/$programId/index.tsx",
      "parent": "/(app)/points-management/points-configuration/customer/$programId"
    },
    "/(app)/recommendation-management/main-page/$store-list/$host-list/": {
      "filePath": "(app)/recommendation-management/main-page/$store-list/$host-list/index.tsx",
      "parent": "/(app)/recommendation-management/main-page/$store-list/$host-list"
    },
    "/(app)/store-information/basic-stores/host-management/$clubid/": {
      "filePath": "(app)/store-information/basic-stores/host-management/$clubid/index.tsx",
      "parent": "/(app)/store-information/basic-stores/host-management/$clubid"
    },
    "/(app)/store-information/basic-stores/switch-store/$id/": {
      "filePath": "(app)/store-information/basic-stores/switch-store/$id/index.tsx",
      "parent": "/(app)/store-information/basic-stores/switch-store"
    },
    "/(app)/store-information/premium-stores/gallery/$store-gallery/": {
      "filePath": "(app)/store-information/premium-stores/gallery/$store-gallery/index.tsx",
      "parent": "/(app)/store-information/premium-stores/gallery/$store-gallery"
    },
    "/(app)/store-information/premium-stores/host-management/$clubid/": {
      "filePath": "(app)/store-information/premium-stores/host-management/$clubid/index.tsx",
      "parent": "/(app)/store-information/premium-stores/host-management/$clubid"
    },
    "/(app)/store-information/premium-stores/plan-management/$clubid/": {
      "filePath": "(app)/store-information/premium-stores/plan-management/$clubid/index.tsx",
      "parent": "/(app)/store-information/premium-stores/plan-management/$clubid"
    },
    "/(app)/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery": {
      "filePath": "(app)/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery/route.tsx",
      "parent": "/(app)/store-information/basic-stores/host-management/$clubid/gallery",
      "children": [
        "/(app)/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery/"
      ]
    },
    "/(app)/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery": {
      "filePath": "(app)/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery/route.tsx",
      "parent": "/(app)/store-information/premium-stores/host-management/$clubid/gallery",
      "children": [
        "/(app)/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery/"
      ]
    },
    "/(app)/store-information/basic-stores/host-management/$clubid/$manage-host/": {
      "filePath": "(app)/store-information/basic-stores/host-management/$clubid/$manage-host/index.tsx",
      "parent": "/(app)/store-information/basic-stores/host-management/$clubid/$manage-host"
    },
    "/(app)/store-information/basic-stores/host-management/$clubid/add-host/": {
      "filePath": "(app)/store-information/basic-stores/host-management/$clubid/add-host/index.tsx",
      "parent": "/(app)/store-information/basic-stores/host-management/$clubid/add-host"
    },
    "/(app)/store-information/premium-stores/host-management/$clubid/$manage-host/": {
      "filePath": "(app)/store-information/premium-stores/host-management/$clubid/$manage-host/index.tsx",
      "parent": "/(app)/store-information/premium-stores/host-management/$clubid/$manage-host"
    },
    "/(app)/store-information/premium-stores/host-management/$clubid/add-host/": {
      "filePath": "(app)/store-information/premium-stores/host-management/$clubid/add-host/index.tsx",
      "parent": "/(app)/store-information/premium-stores/host-management/$clubid/add-host"
    },
    "/(app)/store-information/premium-stores/host-management/gallery/$host-gallery/": {
      "filePath": "(app)/store-information/premium-stores/host-management/gallery/$host-gallery/index.tsx",
      "parent": "/(app)/store-information/premium-stores/host-management/gallery/$host-gallery"
    },
    "/(app)/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery/": {
      "filePath": "(app)/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery/index.tsx",
      "parent": "/(app)/store-information/basic-stores/host-management/$clubid/gallery/$host-gallery"
    },
    "/(app)/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery/": {
      "filePath": "(app)/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery/index.tsx",
      "parent": "/(app)/store-information/premium-stores/host-management/$clubid/gallery/$host-gallery"
    }
  }
}
ROUTE_MANIFEST_END */
